import _ from "lodash";
import client from "lib/apolloClient/client";
import { persistor, cache } from "lib/apolloClient";
import React, { createContext } from "react";
import update from "immutability-helper";
import asyncWrap from "Utils/asyncWrap";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  deleteProjectDeadlineMutation,
  updateProjectDeadlineMutation,
  createProjectDeadlineMutation,
  createProjectTemplateCopyMutation,
  updateProjectFieldMutation,
  markProjectDeadlinesCompleteMutation,
  updateProjectMutation,
  editProjectMutation,
  createProjectMutation,
  removeProjectsMutation,
  restoreProjectsMutation,
  createProjectGroupGuidingQuestionMutation,
  updateProjectGroupGuidingQuestionMutaion,
  deleteProjectGroupGuidingQuestionMutation,
  reorderProjectGroupGuidingQuestionMutation,
  updateStudentProjectPortfolioMutation,
  updateAchievedPlannerElementMutation,
  updateStudentPortfolioStatusMutation,
  updateProjectWithoutResponseFieldsMutation,
  generateProjectFileUrlMutation,
  generateProjectFileFolderUrlMutation,
  generateFileFolderUrlByStudentProjectGroupMutation,
  updateProjectGroupMutation,
  bulkUpdateEntityLockingStatusMutation,
  updateProjectFieldValuesForStudentAndProjectGroupsMutation,
  createAttachmentMutationForProjects,
  removeLosFromPostsMutation,
  updateElementRemarkMutationMutation,
  bulkCreateProjectMutation,
  generatePortfolioFileFolderUrlMutation,
} from "./ProjectMutations";
import {
  writeProjectGroupDeadlineInCache,
  getProjectInfoFromCache,
  writeProjectInfoInCache,
  writeGuidingQuestionFragmentInCache,
  getGuidingQuestionFragmentFromCache,
  getGuidingQuestionsFromCache,
  writeGuidingQuestionsInCache,
  getProjectDetailsFromCache,
  writeProjectDetailsInCache,
  getLearningOutcomesWithEvidencesFromCache,
  writeLearningOutcomesWithEvidencesInCache,
  getStudentProjectPortfolioProgressFragmentInCache,
  writeStudentProjectPortfolioProgressFragmentInCache,
  getProjectGroupProjectCountFromCache,
  writeProjectGroupProjectCountInCache,
  writeProjectRatedCriteriaInCache,
  writeProjectStudentCriteriaDetails,
  getProjectCriteriaDetailsFromCache,
  getProjectStudentCriteriaDetailsFromCache,
  getProjectStudentInfoFragmentFromCache,
  getProjectGroupYearGroupFromCache,
  writeProjectGroupBasicDetailsInCache,
  readProjectGroupBasicDetailsFromCache,
  getProjectAttachmentFragmentFromCache,
  writeProjectAttachmentInCache,
  getProjectHeaderInfoFromCache,
  writeProjectHeaderInfoInCache,
} from "./ProjectGraphqlHelpers";
import {
  getStudentLearningOutcomesInsightsFromCache,
  writeLearningOutcomesInsightsWithEvidencesInCache,
} from "Projects/routes/StudentPortfolios/routes/PortfolioDetails/routes/StudentPortfolio/components/StudentPortfolioInsights/modules/StudentPortfolioInsightsGraphqlHelpers.js";
import {
  createProcessJournalMutation,
  updateProcessJournalMutation,
  deleteProcessJournalMutation,
} from "../routes/ProjectDetails/routes/ProcessJournal/modules/Mutations";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import {
  formatDate,
  moveElementInArray,
  isValidValue,
  exportData,
  generateRandomId,
  getYearDurationFormat,
  getMemoizedLangFunction,
} from "Utils";
import {
  getSubjectLevelTag,
  getUpdatedActionLabel,
  getCriterionAssessmentRating,
  getSubmittedCountLabel,
  getIsProjectGroupTypePortfolio,
  getIsTypeOfProjectPortfolioLOs,
  getSortedUsersList,
  getUpdatedFileFolderInput,
  getInitialSortedFields,
  getOrderByFieldsMemoized,
  getDashboardIdMemoized,
  getArchivalButtonState,
  getArchivedLabel,
  getArchivedDialogDetails,
  getProjectHeaderInfoVariables,
  getDeletedDialogDetails,
  getDeletedButtonState,
  getTotalScore,
  getUniquePlannerElements,
  isNewDeadlineEnabled,
  findMappedCollaborators,
} from "./Utils";
import {
  getProjectGroupProjectAndPortfolioCountQuery,
  getGuidingQuestionsQuery,
  getProjectGroupProjectsWithFieldsQuery,
  getProjectGroupProjectCountQuery,
  getStudentProjectPortfolioQuery,
  getProjectAssessmentBulkDownloadQuery,
  getProjectAssessmentDownloadUrlQuery,
  getProjectGroupCourseQuery,
  getStudentPortfolioProjectsQuery,
  getProjectHeaderInfoQuery,
  getUserProjectGroupYearGroupsQuery,
  getStudentProjectPortfolioFeedbackQuery,
  getStudentPortfolioSupervisorsQuery,
  getProjectDetailsQuery,
  getProjectGroupProjectSupervisorsQuery,
  getUserProjectGroupsQuery,
  getProjectApprovedSupervisorsQuery,
  getProjectStudentCollaboratorsForSplittingQuery,
  getLearningOutcomesPostsQuery,
  getStudentRatingDetailQuery,
  getProjectGroupProjectsIdsQuery,
  getProjectGroupDeletedProjectsWithFieldsQuery,
  getLearningOutcomesWithEvidencesQuery,
  getProjectGroupProjectsWithStudentsIdsQuery,
} from "./ProjectQueries";
import {
  getStudentPortfolioInsightsProjectsQuery,
  getLearningOutcomesWithEvidencesInsightsQuery,
} from "Projects/routes/StudentPortfolios/routes/PortfolioDetails/routes/StudentPortfolio/components/StudentPortfolioInsights/modules/StudentPortfolioInsightsQueries";
import {
  removeProgressElement,
  downloadFromUrl,
  setProgress,
  isExcludedParentTypesForAttachmentCache,
} from "modules/Services";
import { getResolvedOptimisticValue } from "modules/ElementValueUtils";
import { projectFieldItemFragment } from "./ProjectFragments";
import {
  createAttachmentMutation,
  updateEntityIsReadMutation,
} from "modules/CommonMutations";
import { getProjectReportTemplateDetailsQuery } from "Projects/routes/Setup/routes/ReportTemplate/modules/ReportTemplateQuery";
import {
  getProjectGroupProjectsQuery,
  getProjectGroupProjectsCountQuery,
} from "Projects/routes/Setup/routes/Invite/modules/InviteQueries";
import {
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_STATUS_PENDING_FOR_APPROVAL,
  PROJECT_STATUS_NOT_STARTED,
  PROJECT_STATUS_DRAFT,
  PROJECT_GROUP_TYPE_DP_CAS,
  ROLE_ADMIN,
  ROLE_SUPERVISOR,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_EE,
  ROLE_STUDENT,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_REPORT_STATUS_APPROVED,
  PROJECT_REPORT_STATUS_SUBMITTED,
  PROJECT_REPORT_STATUS_NOT_STARTED,
  PROJECT_REPORT_STATUS_NON_SUBMISSION,
  PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL,
  PROJECT_REPORT_STATUS_PENDING,
  PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT,
  PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT,
  ATTACHMENT_TYPE_PROJECT_GROUP_SL_STIMULI,
  ATTACHMENT_TYPE_PROJECT_GROUP_HL_STIMULI,
  SL_LABEL,
  PROJECT_GROUP_SUB_TYPE_CORE,
  PLANNER_ELEMENT_TYPE_DP_EE_CATEGORY,
  PROJECT_STATUS_APPROVED,
  PROJECT_STATUS_COMPLETED,
  PROJECT_REPORT_STATUS_IN_PROGRESS,
  SUPERVISOR_APPROVAL_STATUS_PENDING,
  SUPERVISOR_APPROVAL_STATUS_APPROVED,
  PROJECT_GROUP_ID_NOT_FOUND,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  SUBMISSION_MODE_INDIVIDUAL,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
  PORTFOLIO_LEARNING_OUTCOMES_MAP,
  PROJECT_PORTFOLIO_TYPE,
  PROJECT_SUPERVISOR_TYPE_EXTERNAL,
  PORTFOLIO_STRANDS_MAPPING,
  STUDENT_NAME,
  SUBMISSION_ITEM,
  NO_GROUPING,
  DOWNLOAD_OPTIONS_FILE_FORMAT,
  REFRESH_PAGE_ERROR,
  PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE,
  PROJECT_FINAL_GRADE,
  PROJECT_STATUS_REJECTED,
  PROJECT_REPORT_STATUS_REJECTED,
  CRITERIA_RUBRIC_FINAL_GRADE,
  ARCHIVE,
  NOT_SUBMITTED,
  OVERDUE,
  REQUEST_RESUBMISSION_OVERDUE,
  REQUEST_RESUBMISSION,
  SUBMISSION_PENDING,
  TURNED_IN_ON_TIME,
  TURNED_IN_LATE,
  RESUBMISSION_NOT_SUBMITTED,
  PROJECT_GROUP_SUBMISSION_ITEM_TEMPLATE,
  PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO,
  SAA_PORTFOLIO_REVAMP_PERM,
  PORTFOLIO_INSIGHTS_PROJECT_GROUP_TYPE_MAPPING,
  SUBMISSION_TYPE_DRAFT,
  SUBMISSION_TYPE_FINAL,
  RATING_REFRESH_PAGE_ERROR,
} from "Projects/Constants/stringConstants";
import { getSupervisorProjectQuery } from "Projects/routes/Progress/modules/ProgressQueries";
import { getOrganizationGradesFromCache } from "GradesSetup/modules/GraphqlHelpers";
import ACLStore from "lib/aclStore";
import {
  PROJECT_REPORT_STATUS,
  PROJECT_STATUS,
  PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
  PROJECT_REPORT_STATUS_FILTER_OPTIONS,
} from "Projects/config/constants";
import {
  PlannerCreateIBPYPElementRatingsMutation,
  PlannerDeleteIBPYPElementRatingMutation,
  deleteProjectRatingsByIdsMutation,
} from "Projects/routes/ProjectDetails/routes/Assessment/modules/Mutations";
import {
  getFormattedUserName,
  getUserSortOptions,
} from "Utils/GetFormattedUserName";
import moment from "moment-timezone";
import { getSettingValue } from "Utils/ConfigurationUtils";
import { ENABLE_PROJECTS_ZIP_DOWNLOAD_V2 } from "Constants/permissionConstants";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import {
  getAttachmentOfNodeFromCache,
  writeAttachmentNodeFragment,
} from "modules/CommonGraphqlHelpers";
import {
  CURRICULUM_TYPE_DP,
  ENTITY_UNLOCKED_STATE,
  ENTITY_LOCKED_STATE,
  LAST_NAME,
  STUDENT_FIRST_NAME,
  STUDENT_MIDDLE_NAME,
  STUDENT_LAST_NAME,
  STUDENT_FULL_NAME,
  STAFF_LAST_NAME,
  FIRST_NAME,
  MIDDLE_NAME,
  FULL_NAME,
  CURRICULUM_TYPE_MYP,
  PROJECT_TYPE_SERVICE_AS_ACTION,
  STAFF_MIDDLE_NAME,
  STAFF_FIRST_NAME,
  STAFF_FULL_NAME,
} from "Constants/stringConstants";
import { COLLABORATOR_V2_ADD_EDIT_MODAL } from "AppComponents/CollaboratorV2/modules/constants/stringConstants";
import { ATTACHMENT_CREATE_ATTRIBUTES } from "store/static";
import {
  constructNestedTemplate,
  getLocalisedTemplate,
} from "@toddle-edu/frontend-utils";
import {
  POST_NOTIFICATION_BADGES_COUNT,
  COMMENT_NOTIFICATION_BADGES_COUNT,
  ACADEMIC_HONESTY_NOTIFICATION_BADGES_COUNT,
  ATTACHMENT_NOTIFICATION_BADGES_COUNT,
  REVIEW_NOTIFICATION_BADGES_COUNT,
  FEEDBACK_NOTIFICATION_BADGES_COUNT,
  OTHER_CHANGES_BADGES_COUNT,
  EXPERIENCE_NOTIFICATION_BADGES_COUNT,
  INTERVIEW_NOTIFICATION_BADGES_COUNT,
  ANNOTATION_NOTIFICATION_BADGES_COUNT,
} from "Projects/components/NotificationBadgesTooltip/modules/stringConstants";
import { EXAM_REGISTRATION_CATEGORIES_LABEL } from "Utils/IBISRegistrationHelpers";
import { FINAL_GRADE_SUBTEXT } from "Projects/routes/ProjectDetails/routes/Assessment/modules/Utils";
import {
  MentionOutlined,
  TickSmallOutlined,
  ClockOutlined,
  MinusCircleOutlined,
  ClockTimerOutlined,
  ReSubmissionRequestOutlined,
  TickCircleFilled,
  EvaluationNotApplicableOutlined,
  ClipboardPencilLinesOutlined,
  WarningCircleOutlined,
  DeviceDesktopOutlined,
  OneDriveColored,
  GoogleDriveColored,
  ArrowOutOutlined,
  PlaceholderFileOutlined,
  CloseCircleFilled,
  DashedCircleMinusOutlined,
  BadgeTickFilled,
  InProgressThumbsupOutlined,
} from "@toddle-edu/ds-icons";
import {
  getUserArchivalStatus,
  getSelectedAcademicYearId,
  getSelectedAcademicYear,
  getCurrentCurriculumProgramType,
} from "modules/CommonSelectors";
import { Avatar, Tooltip, IconButton } from "@toddle-edu/ds-web";
import { ATTACHMENT_WARNINGS } from "Utils/AttachmentHelpers";
import { getIsSubjectBasedGradingEnabled } from "Teacher/routes/LearningCourses/modules/Utils";

export const NAME = "project";

export const UPDATE_CREATE_PROJECT_DATA_IN_REDUX =
  "UPDATE_CREATE_PROJECT_DATA_IN_REDUX" + " " + NAME;

export const RESET_CREATE_PROJECT_DATA_IN_REDUX =
  "RESET_CREATE_PROJECT_DATA_IN_REDUX" + " " + NAME;

export const UPDATE_RIGHT_SIDEBAR_TAB = "UPDATE_RIGHT_SIDEBAR_TAB" + " " + NAME;
export const UPDATE_YEAR_GROUP_DETAILS =
  "UPDATE_YEAR_GROUP_DETAILS" + " " + NAME;

export const UPDATE_PROJECT_MODAL_AND_DIALOGUE_VALUE =
  "UPDATE_PROJECT_MODAL_AND_DIALOGUE_VALUE" + " " + NAME;

export const SET_REFLECTION_SEARCH_TEXT =
  "SET_REFLECTION_SEARCH_TEXT" + " " + NAME;

export const IS_PROJECT_DISABLED = "IS_PROJECT_DISABLED" + " " + NAME;

export const SET_G4_PROJECT_CREATION_STUDENT_SEARCH_TEXT =
  "SET_G4_PROJECT_CREATION_STUDENT_SEARCH_TEXT" + " " + NAME;

export const UPDATE_ROLE_VALUE = "UPDATE_ROLE_VALUE" + " " + NAME;
export const RESET_ROLE_VALUE = "RESET_ROLE_VALUE" + " " + NAME;

export const UPDATE_DASHBOARD_FILTERS = "UPDATE_DASHBOARD_FILTERS" + " " + NAME;

export const UPDATE_INSIGHTS_FILTERS = "UPDATE_INSIGHTS_FILTERS" + " " + NAME;
export const RESET_INSIGHTS_FILTERS = "RESET_INSIGHTS_FILTERS" + " " + NAME;

export const PORTFOLIO_INSIGHTS_VALUES =
  "PORTFOLIO_INSIGHTS_VALUES" + " " + NAME;

// projectGroupDetails
export const UPDATE_PROJECT_GROUP_DETAILS =
  "UPDATE_PROJECT_GROUP_DETAILS" + NAME;

// overall progress indicators
export const UPDATE_OVERALL_PROGRESS_INDICATORS =
  "UPDATE_OVERALL_PROGRESS_INDICATORS" + NAME;

// learning outcome indicators
export const UPDATE_LEARNING_OUTCOME_INDICATORS =
  "UPDATE_LEARNING_OUTCOME_INDICATORS" + NAME;

// Pagination counts
export const PROJECT_GROUP_PROJECTS_FIRST_COUNT = 25;

export const UPDATE_TOTAL_PROJECTS_COUNT_FOR_BULK_ACTIONS =
  "UPDATE_TOTAL_PROJECTS_COUNT_FOR_BULK_ACTIONS" + " " + NAME;

export const IS_PROJECT_DELETED = "IS_PROJECT_DELETED" + " " + NAME;

export const ACADEMIC_YEAR_FILTER = "ACADEMIC_YEAR_FILTER" + " " + NAME;

export const isToddleTemplate = parentType => {
  return _.includes(
    [
      "TODDLE_PERSONAL_PROJECT_REPORT_TEMPLATE",
      "TODDLE_COMMUNITY_PROJECT_REPORT_TEMPLATE",
      "TODDLE_TOK_EXHIBITION_REPORT_TEMPLATE",
      "TODDLE_TOK_ESSAY_REPORT_TEMPLATE",
      "TODDLE_EXTENDED_ESSAY_REPORT_TEMPLATE",
    ],
    parentType
  );
};

export const isSubmissionItemTemplate = parentType => {
  return (
    isToddleTemplate(parentType) ||
    parentType === PROJECT_GROUP_SUBMISSION_ITEM_TEMPLATE
  );
};

export const PROJECT_TYPE_LABEL_MAP = {
  [PROJECT_GROUP_TYPE_PERSONAL]: "project:personal_project",
  [PROJECT_GROUP_TYPE_COMMUNITY]: "project:community_project",
  [PROJECT_GROUP_TYPE_DP_CAS]: "project:cas",
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: "project:tok_essay",
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: "project:tok_exhibition",
  [PROJECT_GROUP_TYPE_DP_EE]: "project:ee",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:service_as_action",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "project:service_learning",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: "project:reflective_project",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "project:community_engagement",
};

export const PROJECT_GROUP_AVATAR_MAP = {
  [PROJECT_GROUP_TYPE_COMMUNITY]: { color: "violet", acronym: "C P" },
  [PROJECT_GROUP_TYPE_PERSONAL]: { color: "pink", acronym: "P P" },
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: { color: "yellow", acronym: "S A" },
  [PROJECT_GROUP_TYPE_DP_CAS]: { color: "pink", acronym: "C S" },
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: { color: "purple", acronym: "T K" },
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: { color: "violet", acronym: "T K" },
  [PROJECT_GROUP_TYPE_DP_EE]: { color: "blue", acronym: "E E" },
  [PROJECT_GROUP_TYPE_DP_G4_PROJECT]: { color: "yellow", acronym: "G 4" },
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]: {
    color: "pink",
    acronym: "C S",
  },
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: {
    color: "violet",
    acronym: "R P",
  },
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: { color: "yellow", acronym: "S L" },
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: {
    color: "yellow",
    acronym: "C E",
  },
};

export const PROJECT_TYPE_LABEL_MAP_V2 = {
  [PROJECT_GROUP_TYPE_PERSONAL]: "project:personal_project",
  [PROJECT_GROUP_TYPE_COMMUNITY]: "project:community_project",
  [PROJECT_GROUP_TYPE_DP_CAS]: "project:creativity_action_service",
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: "project:theory_of_knowledge_essay",
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]:
    "project:theory_of_knowledge_exhibition",
  [PROJECT_GROUP_TYPE_DP_EE]: "project:extended_essay",
  [PROJECT_GROUP_TYPE_DP_G4_PROJECT]: "project:g4_project",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:service_as_action",
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]:
    "project:dp_collaborative_sciences_project",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: "project:reflective_project",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "project:service_learning",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "project:community_engagement",
};

export const PROJECT_TYPE_PERMISSION_MAP = {
  [PROJECT_GROUP_TYPE_PERSONAL]: "Common:PersonalProject",
  [PROJECT_GROUP_TYPE_COMMUNITY]: "Common:CommunityProject",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "Common:ServiceAsAction",
  [PROJECT_GROUP_TYPE_DP_EE]: "Common:EEProjects",
  [PROJECT_GROUP_TYPE_DP_CAS]: "Common:CASPortfolio",
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: "Common:TOKEssayProjects",
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: "Common:TOKExhibitionProjects",
  [PROJECT_GROUP_TYPE_DP_G4_PROJECT]: "Common:Group4AndCollaborativeSciences",
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]:
    "Common:Group4AndCollaborativeSciences",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: "Common:ReflectiveProject",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "Common:ServiceLearning",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "Common:ServiceLearning", // jatin create new permission here
};

export const PROJECT_TYPE_PERMISSION_FAMILY_MAP = {
  [PROJECT_GROUP_TYPE_PERSONAL]: "Common:PersonalProjectFamily",
  [PROJECT_GROUP_TYPE_COMMUNITY]: "Common:CommunityProjectFamily",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "Common:ServiceAsActionFamily",
  [PROJECT_GROUP_TYPE_DP_EE]: "Common:EEProjectsFamily",
  [PROJECT_GROUP_TYPE_DP_CAS]: "Common:CASPortfolioFamily",
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: "Common:TOKEssayProjectsFamily",
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: "Common:TOKExhibitionProjectsFamily",
  [PROJECT_GROUP_TYPE_DP_G4_PROJECT]:
    "Common:Group4AndCollaborativeSciencesFamily",
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]:
    "Common:Group4AndCollaborativeSciencesFamily",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: "Common:ReflectiveProjectFamily",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "Common:ServiceLearningFamily",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "Common:ServiceLearning", // jatin create new permission here
};

export const getGroup4TeacherObject = ({ userId, userName, staff }) => {
  return {
    value: userId,
    label: userName,
    groupId: _.find(staff, item =>
      _.isEqual(_.get(item, "node.id", null), userId)
    )
      ? "SCIENCES_TEACHERS"
      : "OTHER_TEACHERS",
  };
};

export const getMemoizedNodeExtractedUsers = _.memoize(({ userList }) =>
  _.map(userList, user => user?.node)
);

export const getFieldValue = ({
  type,
  nodeField,
  projectFields = {},
  fielduid,
}) => {
  switch (type) {
    case "SubmissionItem": {
      return _.get(nodeField, "attachments", null);
    }
    case "SelectAttachmentComponent": {
      return _.get(nodeField, "resolvedMinimalTree.attachments", null);
    }
    default:
      return (
        _.get(nodeField, "value", null) ??
        _.get(projectFields[fielduid], "value", null)
      );
  }
};

export const getUserNameFromUserObject = ({ user: { node = {} } = {} }) => {
  return getFormattedUserName({
    user: node,
  });
};

export const getProjectGroupTypeToCompareForSimilarity = ({
  projectGroupSubType,
  projectGroupType,
}) => {
  const projectComparisonMap = {
    [PROJECT_GROUP_TYPE_PERSONAL]: "MYP_PERSONAL_PROJECT",
    [PROJECT_GROUP_TYPE_COMMUNITY]: "MYP_COMMUNITY_PROJECT",
  };

  switch (projectGroupSubType) {
    case PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT:
    case PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT:
      return projectGroupSubType;
    default:
      return projectComparisonMap[projectGroupType] ?? projectGroupType;
  }
};

export const getProjectGroupSubtype = ({ projectGroupId, academicYearId }) => {
  const yearGroupData = getProjectGroupYearGroupFromCache({
    id: projectGroupId,
    gradeFilters: {
      academicYearId,
    },
  });
  return _.get(yearGroupData, "node.subType", null);
};

export const getProjectReportStatusIconType = ({
  reportStatus,
  t,
  projectGroupId,
}) => {
  switch (reportStatus) {
    case PROJECT_REPORT_STATUS_APPROVED: {
      return {
        icon: "thumbsIcon",
        customTooltip: t("project:approved"),
      };
    }
    case PROJECT_REPORT_STATUS_IN_PROGRESS: {
      return {
        icon: "thumbsIcon",
        customTooltip: t("project:in_progress"),
      };
    }
    case PROJECT_REPORT_STATUS_SUBMITTED:
      return {
        icon: "tickIcon",
        customTooltip: _.includes(
          [
            PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT,
            PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT,
          ],
          getProjectGroupSubtype({ projectGroupId })
        )
          ? t("common:completed")
          : null,
      };
    case PROJECT_REPORT_STATUS_NOT_STARTED:
      return "dashedMinusIcon";
    case PROJECT_REPORT_STATUS_PENDING:
    case PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL:
      return "alertIcon";
    case PROJECT_REPORT_STATUS_NON_SUBMISSION:
      return "closeIcon";
    case PROJECT_REPORT_STATUS_REJECTED:
      return {
        icon: "closeIcon",
        customTooltip: t("common:rejected"),
      };
    default:
      return null;
  }
};

export const getSupervisorNameCascade = ({ supervisors }) => {
  const firstSupervisorInList = _.first(supervisors);

  const archivedNames = getArchivedUsersNames(supervisors);

  return {
    isUsersListEmpty: _.isEmpty(supervisors),
    firstProfileName: `${getFormattedUserName({
      user: firstSupervisorInList,
    })}`,
    firstProfileImage: _.get(firstSupervisorInList, "profileImage", null),
    firstProfileId: _.get(firstSupervisorInList, "id", null),
    tailingUsers: _.map(
      _.tail(supervisors),
      supervisor =>
        `${getFormattedUserName({
          user: supervisor,
        })}`
    ),
    archivedNames,
  };
};

export const getShowSimilarityOnProject = ({
  projectGroupType,
  projectGroupId,
  organizationId,
  academicYearId,
}) => {
  const projectGroupSubType = getProjectGroupSubtype({
    projectGroupId,
    academicYearId,
  });
  let showSimilarityOnProject = false;

  if (!_.isNil(projectGroupType)) {
    const projectTypeToCompare = getProjectGroupTypeToCompareForSimilarity({
      projectGroupSubType,
      projectGroupType,
    });
    const turnitinEnabledProjects = getSettingValue({
      name: "TurnitinEnabledForOtherModules",
      organizationId,
      readFromUserAndOrgLevel: true,
    });

    showSimilarityOnProject = _.includes(
      turnitinEnabledProjects,
      projectTypeToCompare
    );
  }
  return showSimilarityOnProject;
};

export const getG4ProjectCreationFooterText = _.memoize(
  ({ selectedStudents, t }) =>
    t("common:total_colon_count_selected", {
      count: _.size(selectedStudents),
    })
);

//FIXME: remove this now everything moved to the template
export const feedDataColumnList = [
  {
    label: "Status",
    locale: "common:status",
    id: "project_report_status",
    style: {
      paddingLeft: "24px",
      justifyContent: "center",
    },
    uiConfig: { uiType: "STATUS_THUMBS_OR_TICK" },
    dataConfig: {
      dataType: "PROJECT_REPORT_STATUS",
    },
    sortConfig: {
      entity: "PROJECT_REPORT_STATUS",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR, ROLE_STUDENT],
    projectGroupType: [
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Student",
    locale: "common:student",
    id: "student_name",
    style: {
      justifyContent: "start",
      position: "sticky",
      left: "0",
      backgroundColor: "inherit",
      zIndex: "9",
      width: "100%",
      padding: "0 20px",
      height: "100%",
      alignItems: "center",
    },
    uiConfig: {
      uiType: "NAME_WITH_AVATAR",
      profileCascadeStyle: { height: "32px", width: "32px" },
    },
    dataConfig: { dataType: "PORTFOLIO_STUDENT_NAME_WITH_AVATAR" },
    sortConfig: {
      entity: "STUDENT",
      hasSortingEnabled: true,
      sortOptionsType: "name",
      sortType: "dropdown",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Student",
    locale: "common:student",
    id: "student_name",
    style: {
      justifyContent: "start",
      position: "sticky",
      left: "0",
      backgroundColor: "inherit",
      zIndex: "9",
      width: "100%",
      padding: "0 20px",
      height: "100%",
      alignItems: "center",
    },
    uiConfig: {
      uiType: "NAME_WITH_AVATAR",
      profileCascadeStyle: { height: "32px", width: "32px" },
    },
    dataConfig: { dataType: "PROJECT_STUDENT_NAME_WITH_AVATAR" },
    sortConfig: {
      entity: "STUDENT",
      hasSortingEnabled: true,
      sortOptionsType: "name",
      sortType: "dropdown",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Student",
    locale: "common:student",
    id: "student_cascade",
    uiConfig: {
      uiType: "NAMES_CASCADE_WITH_AVATAR",
      profileCascadeStyle: { height: "32px", width: "32px" },
    },
    dataConfig: {
      dataType: "PROJECT_STUDENT_NAME_WITH_AVATAR",
    },
    sortConfig: {
      entity: "STUDENT",
      sortType: "dropdown",
      hasSortingEnabled: true,
      sortOptionsType: "name",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR, ROLE_STUDENT],
    projectGroupType: [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON],
  },
  {
    label: "Adviser",
    locale: "project:advisor",
    id: "advisor_name",
    style: { justifyContent: "start" },
    uiConfig: {
      uiType: "NAME_WITH_AVATAR",
      profileCascadeStyle: { height: "24px", width: "24px" },
    },
    sortConfig: {
      entity: "STAFF",
      hasSortingEnabled: true,
      sortType: "dropdown",
      sortOptionsType: "name",
    },
    dataConfig: { dataType: "PORTFOLIO_STAFF_NAME_WITH_AVATAR" },
    users: [ROLE_ADMIN],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Supervisors",
    locale: "project:supervisor",
    id: "supervisor_name",
    style: { justifyContent: "start" },
    sortConfig: {
      entity: "STAFF",
      hasSortingEnabled: true,
      sortOptionsType: "name",
      sortType: "dropdown",
    },
    uiConfig: {
      uiType: "NAME_WITH_AVATAR",
      profileCascadeStyle: { height: "24px", width: "24px" },
    },
    dataConfig: { dataType: "PROJECT_SUPERVISOR_NAME_WITH_AVATAR" },
    users: [ROLE_ADMIN, ROLE_STUDENT],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Teacher",
    locale: "common:teacher",
    id: "supervisor_name",
    style: { justifyContent: "start" },
    uiConfig: {
      uiType: "NAME_WITH_AVATAR",
      profileCascadeStyle: { height: "24px", width: "24px" },
    },
    dataConfig: { dataType: "PROJECT_SUPERVISOR_NAME_WITH_AVATAR" },
    sortConfig: {
      entity: "STAFF",
      hasSortingEnabled: true,
      sortType: "dropdown",
      sortOptionsType: "name",
    },
    users: [ROLE_ADMIN],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
    ],
  },
  {
    label: "Experiences",
    locale: "project:experience_plural",
    id: "experience_count",
    style: { justifyContent: "start" },
    type: "INTCOLUMN",
    dataConfig: { dataType: "EXPERIENCE_COUNT" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Projects",
    locale: "project:project_plural",
    id: "project_count",
    style: { justifyContent: "start" },
    type: "INTCOLUMN",
    dataConfig: { dataType: "PROJECT_COUNT" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Learning Outcomes achieved",
    locale: "project:lo_achieved",
    id: "lo_count",
    sortConfig: {
      entity: "ACHIEVED_PLANNER_ELEMENTS_COUNT",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    style: { justifyContent: "start" },
    type: "INTCOLUMN",
    dataConfig: { dataType: "LO_COUNT" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Interviews",
    locale: "project:interview_plural",
    id: "interviews",
    uiConfig: { uiType: "STATUS_TICK_MARK" },
    dataConfig: { dataType: "PORTFOLIO_INTERVIEWS" },
    sortConfig: {
      entity: "FORMAL_INTERVIEWS_COUNT",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Title",
    locale: "common:title",
    id: "titlePlannerField",
    type: "TEXTCOLUMN",
    dataConfig: {
      fieldType: "essayTitle",
      dataType: "PLANNER_FIELD",
    },
    style: { paddingRight: "24px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_TOK_ESSAY],
  },
  {
    label: "Project Title",
    locale: "progressReport:project_title",
    id: "titleField",
    dataConfig: {
      fieldType: "title",
      dataType: "FIELD",
    },
    uiConfig: { uiType: "TEXT_OR_DASH" },
    style: { paddingRight: "20px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Activity Title",
    locale: "project:activity_title",
    id: "titleField",
    uiConfig: { uiType: "TEXT_OR_DASH" },
    dataConfig: {
      fieldType: "title",
      dataType: "FIELD",
    },
    style: { paddingRight: "20px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR, ROLE_STUDENT],
    projectGroupType: [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON],
  },
  {
    label: "Meeting notes",
    locale: "project:meeting_note",
    id: "meeting_notes",
    uiConfig: { uiType: "MEETING_NOTES" },
    dataConfig: { dataType: "PROJECT_ACADEMIC_HONESTY" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Subject",
    locale: "project:subject",
    id: "subject",
    type: "TEXTCOLUMN",
    dataConfig: { dataType: "SUBJECT" },
    sortConfig: {
      entity: "SUBJECT",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_EE],
  },
  {
    label: "Title",
    locale: "project:title",
    id: "titleField",
    type: "TEXTCOLUMN",
    dataConfig: {
      fieldType: "title",
      dataType: "FIELD",
    },
    style: { paddingRight: "20px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_EE],
  },
  {
    label: "Theme",
    locale: "project:theme",
    id: "theme",
    type: "TEXTCOLUMN",
    dataConfig: {
      fieldType: "TOKTheme",
      dataType: "PLANNER_FIELD",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION],
  },
  {
    label: "IA Prompt",
    locale: "project:ia_prompts",
    id: "ia_prompt",
    type: "TEXTCOLUMN",
    dataConfig: {
      fieldType: "IAPrompt",
      dataType: "PLANNER_FIELD",
    },
    style: { paddingRight: "20px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION],
  },
  {
    label: "Proposal",
    locale: "project:proposal_status",
    id: "proposal",
    uiConfig: { uiType: "ICON" },
    dataConfig: { dataType: "PROJECT_REPORT_STATUS" },
    style: { width: "100%" },
    sortConfig: {
      entity: "REPORT_STATUS",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
    ],
  },
  {
    label: "Reflection",
    locale: "project:reflection_session_plural",
    id: "reflection",
    uiConfig: { uiType: "STATUS_TICK_MARK" },
    dataConfig: { dataType: "PROJECT_ACADEMIC_HONESTY" },
    sortConfig: {
      entity: "REFLECTION_COUNT",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_EE],
  },
  {
    label: "Interaction",
    locale: "project:interaction_status",
    id: "interaction",
    uiConfig: { uiType: "STATUS_TICK_MARK" },
    dataConfig: { dataType: "PROJECT_ACADEMIC_HONESTY" },
    sortConfig: {
      entity: "REFLECTION_COUNT",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_TOK_ESSAY],
  },
  {
    label: "RPPF",
    locale: "project:rppf_status",
    id: "rppf",
    style: { width: "100%" },
    uiConfig: { uiType: "STATUS_TICK_MARK" },
    dataConfig: { dataType: "PROJECT_ACADEMIC_HONESTY_REMARKS" },
    sortConfig: {
      entity: "RPPF",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_EE],
  },
  {
    label: "PPF",
    locale: "project:ppf_status",
    id: "ppf",
    uiConfig: { uiType: "STATUS_TICK_MARK" },
    dataConfig: { dataType: "PROJECT_ACADEMIC_HONESTY_REMARKS" },
    sortConfig: {
      entity: "RPPF",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_TOK_ESSAY],
  },
  {
    label: "Overall progress",
    locale: "project:overall_progress",
    id: "cas_overall_progress",
    uiConfig: { uiType: "OVERALL_PROGRESS" },
    dataConfig: { dataType: "PROJECT_STATUS" },
    sortConfig: {
      entity: "OVERALL_PROGRESS",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    disableCellClick: true,
    style: { paddingRight: "28px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
  },
  {
    label: "Overall progress",
    locale: "project:overall_progress",
    id: "ee_overall_progress",
    uiConfig: { uiType: "OVERALL_PROGRESS" },
    dataConfig: { dataType: "PROJECT_STATUS" },
    sortConfig: {
      entity: "STATUS",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    disableCellClick: true,
    style: { paddingRight: "28px" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
    ],
  },
  {
    label: "Status",
    locale: "common:status",
    id: "mark_complete",
    disableCellClick: true,
    uiConfig: { uiType: "STATUS" },
    dataConfig: { dataType: "PORTFOLIO_STATUS" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_CAS],
    style: { paddingRight: "20px" },
  },
  {
    label: "Status",
    locale: "common:status",
    id: "status",
    uiConfig: { uiType: "STATUS" },
    dataConfig: { dataType: "PROJECT_STATUS" },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    style: { paddingRight: "32px" },
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
    ],
  },
  {
    label: "Grade",
    locale: "project:grade",
    id: "grade",
    type: "INTCOLUMN",
    style: { justifyContent: "start" },
    dataConfig: {
      dataType: "ASSESSMENT_RATING",
      totalAssessmentRating: 10,
      ratingType: "FINAL_GRADE",
    },
    sortConfig: {
      entity: "ASSESSMENT_GRADE",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [PROJECT_GROUP_TYPE_DP_EE],
  },
  {
    label: "Assessment",
    locale: "project:assessment",
    id: "TOKgrade",
    type: "INTCOLUMN",
    style: { justifyContent: "start" },
    sortConfig: {
      entity: "ASSESSMENT_GRADE",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    dataConfig: {
      ratingType: "IB_DEFINED",
      totalAssessmentRating: 10,
      dataType: "ASSESSMENT_RATING",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
    ],
  },
  {
    label: "AHF",
    locale: "project:AHF",
    id: "academic_honesty",
    style: {
      justifyContent: "center",
    },
    uiConfig: { uiType: "LOCK_OPEN_CLOSE" },
    dataConfig: {
      dataType: "PROJECT_ACADEMIC_HONESTY_LOCKED",
    },
    sortConfig: {
      entity: "ACADEMIC_HONESTY",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Assessment",
    locale: "project:assessment",
    id: "pp_grade",
    dataConfig: {
      dataType: "ASSESSMENT_RATING",
      totalAssessmentRating: 24,
    },
    uiConfig: { uiType: "TEXT_OR_DASH" },
    sortConfig: {
      entity: "ASSESSMENT_GRADE",
      hasSortingEnabled: true,
      sortType: "toggle",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Overall Student Progress",
    locale: "project:overall_student_progress",
    id: "project_status",
    uiConfig: { uiType: "COLOR_TEXT" },
    dataConfig: {
      dataType: "PROJECT_STATUS",
    },
    users: [ROLE_ADMIN, ROLE_SUPERVISOR],
    projectGroupType: [
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
  {
    label: "Action",
    locale: "common:action_plural",
    id: "project_actions",
    type: "ACTIONS",
    dataConfig: {
      dataType: "PROJECT_ACTIONS",
    },
    style: { justifyContent: "center" },
    disableCellClick: true,
    users: [ROLE_ADMIN, ROLE_SUPERVISOR, ROLE_STUDENT],
    projectGroupType: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
      PROJECT_GROUP_TYPE_COMMUNITY,
    ],
  },
];
//FIXME: remove this now everything moved to the template
export const getFeedDataColumnList = ({ userType, projectGroupType }) => {
  return _.filter(
    feedDataColumnList,
    columnDetails =>
      _.includes(columnDetails.users, userType) &&
      _.includes(columnDetails.projectGroupType, projectGroupType)
  );
};

// disabling bulk download checkbox and dashboard action if user hasn't uploaded a file
export const disableActionOrCheckbox = ({ action, nodeFields = [] }) => {
  const actionType = _.get(action, "actionType", "");
  const zipConfig = _.get(action, "config.zipConfig", {});
  const filesFolderList = _.get(zipConfig, "filesFolderList", []);
  const getIsChildEntityDisabled = ({ list }) => {
    if (_.isEqual(_.get(list, "fileType", ""), "PROJECT_FIELD")) {
      const uid = _.get(list, "fileDetails.fieldUid", "");
      const dynamicItemType = _.get(list, "dynamicFileFolderConfig.type", "");
      switch (dynamicItemType) {
        case "ARTWORK": {
          let disabled = true;
          const pseudoFieldUid = _.get(list, "fileDetails.pseudoFieldUid", "");
          const artworkItems = _.filter(nodeFields, {
            pseudoFieldUid: "artwork_item",
          });
          const artworkItemsChildIds = _.flatMap(artworkItems, "children");

          _.forEach(artworkItemsChildIds, childId => {
            const areAttachmentsUploaded = _.filter(nodeFields, field => {
              return (
                field.id === childId &&
                field.pseudoFieldUid === pseudoFieldUid &&
                _.size(field.attachments)
              );
            });
            if (!_.isEmpty(areAttachmentsUploaded)) {
              disabled = false;
            }
          });
          return {
            disabled,
            fieldUids: [pseudoFieldUid, "artwork_item"],
          };
        }
        default: {
          return {
            disabled: _.isEmpty(
              _.get(_.find(nodeFields, { uid }), "attachments", [])
            ),
            fieldUids: [uid],
          };
        }
      }
    }
    return { disabled: false, fieldUids: [] };
  };

  const getIsFolderEntityDisabled = ({ filesFolderList }) => {
    // here thinking as user hasn't uploaded a single so making disabled true, so now finding through each that if
    // user has uploaded the file then making disabled as false and not checking it further, the ultimate goal here
    // is to find if user has uploaded at least a file
    const result = { disabled: true, fieldUids: [] };
    _.forEach(filesFolderList, list => {
      if (_.isEqual(_.get(list, "type", ""), "FILE")) {
        if (result.disabled) {
          const isChildEntityDisabled = getIsChildEntityDisabled({ list });
          result.disabled = isChildEntityDisabled.disabled;
          // collecting all the uids or pseudoFieldUids so that the fields can be fetched in bulk download
          result.fieldUids.push(...isChildEntityDisabled.fieldUids);
        }
      } else if (_.isEqual(_.get(list, "type", ""), "FOLDER")) {
        if (result.disabled) {
          const isFolderEntityDisabled = getIsFolderEntityDisabled({
            filesFolderList: list["children"],
          });
          result.disabled = isFolderEntityDisabled.disabled;
          // collecting all the uids or pseudoFieldUids so that the fields can be fetched in bulk download
          result.fieldUids.push(...isFolderEntityDisabled.fieldUids);
        }
      }
    });
    return result;
  };

  switch (actionType) {
    case "PROJECT_FILE_FOLDER":
    case "PROJECT_FILE_FOLDER_WITH_SETTINGS_WARNING_MODAL":
    case "STUDENT_PROJECT_GROUP_FILE_FOLDER_WITH_SETTINGS_WARNING_MODAL":
    case "STUDENT_PROJECT_GROUP_FILE_FOLDER":
    case "PROJECT_FILE":
    case "PROJECT_FILE_WITH_SETTINGS_WARNING_MODAL": {
      return getIsFolderEntityDisabled({ filesFolderList });
    }
    default: {
      return { disabled: false, fieldUids: [] };
    }
  }
};

export const getUpdatedAction = ({
  entityType,
  action,
  isFinalReportSubmitted,
  nodeFields,
  t,
  courseId,
  actionId,
}) => {
  if (actionId === "fileFolderConfig") return action;
  const {
    bulkOptionLabelLocale,
    bulkOptionSubtextLabelLocale,
    optionLabelLocale,
    optionSubtextLabelLocale,
    headerTitleLocale,
    config = {},
  } = action || {};

  const {
    fileNameLocale,
    selectionModalSubtextLabelLocale,
    assessmentSheetNameLocale,
    modalsList = [],
  } = config || {};

  switch (entityType) {
    case "FINAL_REPORT":
      return {
        ...action,
        disabled: !isFinalReportSubmitted,
        disabledTooltip: t("common:file_not_uploaded_yet"),
      };

    default: {
      const titleFieldUid = _.get(action, "config.titleFieldUid", null);

      if (titleFieldUid) {
        const titleField = _.find(nodeFields, {
          uid: titleFieldUid,
        });
        action.config.projectTitleName = titleField?.value;
        action.config.titleFieldObject = titleField;
      }

      const projectFieldUIDs = _.get(
        action,
        "config.zipConfig.projectFieldUIDs",
        []
      );
      const pdfPrintTypes = _.get(action, "config.zipConfig.pdfPrintTypes", []);

      if (_.isEmpty(pdfPrintTypes) && !_.isEmpty(projectFieldUIDs)) {
        const disabled = !_.some(
          projectFieldUIDs,
          uid =>
            !_.isEmpty(_.get(_.find(nodeFields, { uid }), "value", null)) ||
            !_.isEmpty(_.get(_.find(nodeFields, { uid }), "attachments", null))
        );

        return {
          ..._.omit(action, [
            "bulkOptionLabelLocale",
            "bulkOptionSubtextLabelLocale",
            "optionLabelLocale",
            "optionSubtextLabelLocale",
          ]),
          bulkOptionLabel: getUpdatedActionLabel({
            labelLocale: bulkOptionLabelLocale,
            t,
          }),
          bulkOptionSubtextLabel: getUpdatedActionLabel({
            labelLocale: bulkOptionSubtextLabelLocale,
            t,
          }),
          optionSubtextLabel: getUpdatedActionLabel({
            labelLocale: optionSubtextLabelLocale,
            t,
          }),
          optionLabel: getUpdatedActionLabel({
            labelLocale: optionLabelLocale,
            t,
          }),
          headerTitle: getUpdatedActionLabel({
            labelLocale: headerTitleLocale,
            t,
          }),
          config: {
            ..._.omit(action.config, [
              "fileNameLocale",
              "selectionModalSubtextLabelLocale",
              "assessmentSheetNameLocale",
            ]),
            fileName: getUpdatedActionLabel({
              labelLocale: fileNameLocale,
              t,
            }),
            selectionModalSubtextLabel: getUpdatedActionLabel({
              labelLocale: selectionModalSubtextLabelLocale,
              t,
            }),
            assessmentSheetName: getUpdatedActionLabel({
              labelLocale: assessmentSheetNameLocale,
              t,
            }),
            ...(action.config?.modalsList && {
              modalsList: _.map(modalsList, modalInfo => ({
                ...modalInfo,
                modalBodyLabel: getUpdatedActionLabel({
                  labelLocale: modalInfo.modalBodyLabelLocale,
                  t,
                }),
                modalTitleLabel: getUpdatedActionLabel({
                  labelLocale: modalInfo.modalTitleLabelLocale,
                  t,
                }),
                button2Label: getUpdatedActionLabel({
                  labelLocale: modalInfo.button2LabelLocale,
                  t,
                }),
              })),
            }),
          },
          disabled,
          disabledTooltip: t("common:file_not_uploaded_yet_plural", {
            count: _.size(projectFieldUIDs),
          }),
        };
      }
      const isActionDisabled = isNewDeadlineEnabled()
        ? false
        : _.get(
            disableActionOrCheckbox({ action, nodeFields }),
            "disabled",
            false
          );
      return {
        disabled: isActionDisabled,
        disabledTooltip: t("common:file_not_uploaded_yet_plural"),
        ..._.omit(action, [
          "bulkOptionLabelLocale",
          "bulkOptionSubtextLabelLocale",
          "optionLabelLocale",
          "optionSubtextLabelLocale",
        ]),
        bulkOptionLabel: getUpdatedActionLabel({
          labelLocale: bulkOptionLabelLocale,
          t,
        }),
        bulkOptionSubtextLabel: getUpdatedActionLabel({
          labelLocale: bulkOptionSubtextLabelLocale,
          t,
        }),

        optionSubtextLabel: getUpdatedActionLabel({
          labelLocale: optionSubtextLabelLocale,
          t,
        }),

        optionLabel: getUpdatedActionLabel({
          labelLocale: optionLabelLocale,
          t,
        }),
        headerTitle: getUpdatedActionLabel({
          labelLocale: headerTitleLocale,
          t,
        }),
        config: {
          ..._.omit(action.config, [
            "fileNameLocale",
            "selectionModalSubtextLabelLocale",
            "assessmentSheetNameLocale",
          ]),
          fileName: getUpdatedActionLabel({
            labelLocale: fileNameLocale,
            t,
          }),
          selectionModalSubtextLabel: getUpdatedActionLabel({
            labelLocale: selectionModalSubtextLabelLocale,
            t,
          }),
          assessmentSheetName: getUpdatedActionLabel({
            labelLocale: assessmentSheetNameLocale,
            t,
          }),
          metadata: {
            ...action.config?.metadata,
            ...(courseId && { courseId }),
          },
          ...(action.config?.modalsList && {
            modalsList: _.map(modalsList, modalInfo => ({
              ...modalInfo,
              modalBodyLabel: getUpdatedActionLabel({
                labelLocale: modalInfo.modalBodyLabelLocale,
                t,
              }),
              modalTitleLabel: getUpdatedActionLabel({
                labelLocale: modalInfo.modalTitleLabelLocale,
                t,
              }),
              button2Label: getUpdatedActionLabel({
                labelLocale: modalInfo.button2LabelLocale,
                t,
              }),
            })),
          }),
        },
      };
    }
  }
};

const getProjectActionDetails = props => {
  const {
    id,
    t,
    isFinalReportSubmitted,
    getPrintFile,
    updateProjectModalAndDialogueValue,
    goToRelativeRoute,
    key,
    action,
    nodeFields,
    courseId,
    getProjectFileUrl,
    getProjectFileFolderUrl,
    supervisors,
    students,
    reportStatus,
    studentId,
    projectCount,
    disabled,
    projectGroupType,
    fileFolderConfig,
    projectGroupId,
    currentUserId,
    currentUserType,
    createdBy,
    currentUserRole,
    actionsList,
    studentName,
    currentCurriculumProgramId,
    organizationId,
    yearGroupName,
    isArchived,
    archivedById,
    projectGroupCategoryType,
  } = props;

  const { entityType } = _.get(action, "config", {});

  const updatedAction = getUpdatedAction({
    entityType,
    action,
    isFinalReportSubmitted,
    nodeFields,
    t,
    courseId,
    actionId: key,
  });

  const {
    optionLabel,
    actionType,
    optionSubtextLabel,
    showOnlyLabel = false,
    isDisabledOverride,
    disabledTooltipLabelOverride,
  } = updatedAction;

  const isDisabled =
    disabled || _.isEqual(reportStatus, PROJECT_REPORT_STATUS_SUBMITTED);

  switch (actionType) {
    case "PORTFOLIO_PRINT": {
      const { fileName, type } = _.get(updatedAction, "config", {});
      return {
        key,
        label: t("common:download_without_lowercase_label", {
          label: optionLabel,
        }),
        disabled: isDisabledOverride,
        disabledTooltip: disabledTooltipLabelOverride
          ? t(disabledTooltipLabelOverride)
          : t("project:CAS_experience_empty_state_title"),
        clickAction: () => {
          if (projectCount !== 0) {
            return updateProjectModalAndDialogueValue({
              id,
              projectGroupId,
              displayProjectsDownloadModal: true,
              projectsDownloadDetails: {
                name: fileName,
                mode: "pdfurl",
                type,
                projectStudents: [studentId],
                studentName,
              },
              projectGroupType,
            });
          }
          return getPrintFile({
            id,
            type,
            name: t(
              "project:projectPortfolio_individual_portfolio_download_fileName",
              {
                label: studentName,
                projectPortfolioType: t(
                  PROJECT_PORTFOLIO_TYPE[projectGroupType]
                ),
                yearGroupName,
              }
            ),
            mode: "pdfurl",
            metadata: {
              projectIds: [],
              organizationId,
              curriculumProgramId: currentCurriculumProgramId,
              projectGroupId,
            },
            shouldOpenInWindow: false,
            isDownload: true,
          });
        },
      };
    }
    case "PORTFOLIO_FILE_FOLDER": {
      const { fileName, type } = _.get(updatedAction, "config", {});
      return {
        key,
        label: t("common:download_without_lowercase_label", {
          label: optionLabel,
        }),
        clickAction: () => {
          return updateProjectModalAndDialogueValue({
            id,
            projectGroupId,
            displayProjectsDownloadModal: true,
            projectsDownloadDetails: {
              name: fileName,
              mode: "pdfurl",
              type,
              projectStudents: [studentId],
              studentName,
            },
            projectGroupType,
          });
        },
      };
    }

    case "PROJECT_FILE": {
      const { fileName, zipConfig, metadata } = _.get(
        updatedAction,
        "config",
        {}
      );

      const { disabled = false, disabledTooltip } = updatedAction;

      return {
        key,
        label: showOnlyLabel
          ? optionLabel
          : t("common:download_with_label", {
              label: optionLabel,
            }),
        clickAction: () =>
          getProjectFileUrl({
            projectIds: [id],
            zipConfig,
            metadata,
            name: fileName,
          }),
        disabled,
        disabledTooltip,
      };
    }

    case "PROJECT_FILE_WITH_SETTINGS_WARNING_MODAL": {
      const { fileName, zipConfig, metadata } = _.get(
        updatedAction,
        "config",
        {}
      );

      const modalsList = _.get(updatedAction, "config.modalsList", "");
      const modalConfig = _.find(modalsList, { id: "linkWarning" }, {});

      const { userSettingName } = modalConfig;

      const { disabled = false, disabledTooltip } = updatedAction;

      const settingValue = getSettingValue({
        name: userSettingName,
        userId: currentUserId,
        userEntityType: currentUserType,
        readFromUserAndOrgLevel: true,
      });

      const handleDownloadFile = () =>
        getProjectFileUrl({
          projectIds: [id],
          zipConfig,
          metadata,
          name: fileName,
        });

      return {
        key,
        label: showOnlyLabel
          ? optionLabel
          : t("common:download_with_label", {
              label: optionLabel,
            }),
        clickAction: () =>
          settingValue
            ? handleDownloadFile()
            : updateProjectModalAndDialogueValue({
                id,
                modalType: "PROJECT_FILE_WITH_SETTINGS_WARNING_MODAL",
                displayModal: true,
                modalDetails: {
                  ...modalConfig,
                  handleDownloadFile,
                  modalTitleLabel: t("project:downloading_with_label", {
                    label: fileName,
                  }),
                },
              }),
        disabled,
        disabledTooltip,
      };
    }

    case "PROJECT_FILE_FOLDER": {
      const {
        fileName,
        zipConfig,
        metadata,
        showFormLanguageChangeModal = false,
        formNames = [],
        formLanguageOptions = [],
      } = _.get(updatedAction, "config", {});
      const { disabled = false, disabledTooltip } = updatedAction;

      const { isLongRunningTask = false } = zipConfig;

      const isTeacherAllowedToSwitchFormLanguage = getSettingValue({
        name: "AllowTeachersToSwitchFormLanguage",
        organizationId,
        userEntityType: currentUserType,
        userId: currentUserId,
        currentCurriculumProgramId,
      });

      const defaultFormLanguage = getSettingValue({
        name: "ProjectFormLanguage",
        organizationId,
        userEntityType: currentUserType,
        userId: currentUserId,
        currentCurriculumProgramId,
      });

      const onDownloadClick = (params = {}) => {
        const { formLanguage } = params;
        const fileNameFormatFromTemplate = _.get(
          fileFolderConfig,
          "fileLabelConfig.fileNameFormat"
        );
        const fileNameFormat = _.includes(["download_zip", "artwork"], key)
          ? DOWNLOAD_OPTIONS_FILE_FORMAT[STUDENT_NAME]
          : fileNameFormatFromTemplate ??
            DOWNLOAD_OPTIONS_FILE_FORMAT[SUBMISSION_ITEM];
        getProjectFileFolderUrl({
          projectIds: [id],
          zipConfig,
          fileFolderConfig: getUpdatedFileFolderInput({
            downloadGroupType: NO_GROUPING,
            fileFolderConfig,
            fileNameFormat,
          }),
          metadata: {
            ...metadata,
            pdfFormLng: formLanguage || defaultFormLanguage,
          },
          name: fileName,
          courseIds: courseId ? [courseId] : [],
          isLongRunningTask,
          isDownload: !isLongRunningTask,
        });
      };
      return {
        key,
        label: showOnlyLabel
          ? optionLabel
          : t("common:download_with_label", {
              label: optionLabel,
            }),
        subText: optionSubtextLabel,

        clickAction: () =>
          isTeacherAllowedToSwitchFormLanguage && showFormLanguageChangeModal
            ? updateProjectModalAndDialogueValue({
                id,
                modalType: "PROJECT_FORM_LANGUAGE_SWITCH_MODAL",
                displayModal: true,
                modalDetails: {
                  formNames,
                  fileName,
                  formLanguageOptions,
                  defaultFormLanguage,
                  onDownloadClick,
                },
              })
            : onDownloadClick(),
        disabled,
        disabledTooltip,
      };
    }
    case "PROJECT_FILE_FOLDER_WITH_SETTINGS_WARNING_MODAL": {
      const { fileName, zipConfig, metadata } = _.get(
        updatedAction,
        "config",
        {}
      );

      const { isLongRunningTask = false } = zipConfig;

      const modalsList = _.get(updatedAction, "config.modalsList", "");
      const modalConfig = _.find(modalsList, { id: "linkWarning" }, {});

      const { disabled = false, disabledTooltip } = updatedAction;

      const { userSettingName } = modalConfig;

      const settingValue = getSettingValue({
        name: userSettingName,
        userId: currentUserId,
        userEntityType: currentUserType,
        readFromUserAndOrgLevel: true,
      });

      const fileNameFormatFromTemplate = _.get(
        fileFolderConfig,
        "fileLabelConfig.fileNameFormat"
      );

      const fileNameFormat = _.includes(["download_zip", "artwork"], key)
        ? DOWNLOAD_OPTIONS_FILE_FORMAT[STUDENT_NAME]
        : fileNameFormatFromTemplate ??
          DOWNLOAD_OPTIONS_FILE_FORMAT[SUBMISSION_ITEM];

      const handleDownloadFile = () =>
        getProjectFileFolderUrl({
          projectIds: [id],
          zipConfig,
          fileFolderConfig: getUpdatedFileFolderInput({
            downloadGroupType: NO_GROUPING,
            fileFolderConfig,
            fileNameFormat,
          }),
          metadata,
          name: fileName,
          courseIds: courseId ? [courseId] : [],
          isLongRunningTask,
          isDownload: !isLongRunningTask,
        });

      return {
        key,
        label: showOnlyLabel
          ? optionLabel
          : t("common:download_with_label", {
              label: optionLabel,
            }),
        subText: optionSubtextLabel,
        clickAction: () =>
          settingValue
            ? handleDownloadFile()
            : updateProjectModalAndDialogueValue({
                id,
                modalType: "PROJECT_FILE_FOLDER_WITH_SETTINGS_WARNING_MODAL",
                displayModal: true,
                modalDetails: {
                  ...modalConfig,
                  handleDownloadFile,
                  modalTitleLabel: t("project:downloading_with_label", {
                    label: fileName,
                  }),
                },
              }),

        disabled,
        disabledTooltip,
      };
    }
    case "PRINT": {
      const { fileName, type, metadata } = _.get(updatedAction, "config", {});
      const { disabled = false, disabledTooltip } = updatedAction;
      return {
        key,
        label: t("common:download_with_label", {
          label: optionLabel,
        }),
        clickAction: () =>
          getPrintFile({
            id,
            name: fileName,
            mode: "pdfurl",
            type,
            metadata,
            shouldOpenInWindow: false,
          }),
        disabled,
        disabledTooltip,
      };
    }

    case "DELETE": {
      const title = _.find(nodeFields, { uid: "title" });

      const {
        disabledTooltip = "",
        disabled: deleteBtnDisabled = false,
      } = getDeletedButtonState({
        projectGroupType,
        t,
        isDisabled,
        currentUserRole,
        currentUserId,
        createdById: createdBy,
        projectGroupCategoryType,
      });

      const dialogueDetails = getDeletedDialogDetails({
        projectGroupType,
        t,
        projectTitle: _.get(title, "value", ""),
      });

      return {
        key,
        label: optionLabel,
        isDestructive: true,
        disabled: disabled || deleteBtnDisabled,
        disabledTooltip: disabledTooltip,
        tooltipPlacement: "left",
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            projectId: id,
            displayDialogueBox: true,
            dialogueType: "DELETE",
            ...(dialogueDetails
              ? { dialogueDetails }
              : { title: _.get(title, "value", "") }),
          }),
      };
    }

    case ARCHIVE: {
      const title = _.find(nodeFields, { uid: "title" });
      const projectTitle = _.get(title, "value", "");
      const {
        disabled: isButtonDisabled = false,
        tooltip: disabledTooltip = null,
      } = getArchivalButtonState({
        archivedById,
        createdById: createdBy,
        userId: currentUserId,
        userType: currentUserType,
        isDisabled: disabled,
        isArchived,
        projectGroupType,
        t,
      });

      return {
        key,
        label: isArchived ? t("common:unarchive") : optionLabel,
        disabled: isButtonDisabled,
        disabledTooltip,
        tooltipPlacement: "left",
        clickAction: () => {
          updateProjectModalAndDialogueValue({
            displayDialogueBox: true,
            dialogueType: ARCHIVE,
            dialogueDetails: getArchivedDialogDetails({
              t,
              projectGroupType,
              projectTitle,
              isArchived,
              projectGroupCategoryType,
            }),
            modalDetails: {
              isArchived: !isArchived,
              projectId: id,
            },
          });
        },
      };
    }

    case "EDIT_STUDENT_COLLABORATOR": {
      return {
        key,
        label: optionLabel,
        disabled: isDisabled || isArchived,
        clickAction: () => {
          updateProjectModalAndDialogueValue({
            modalType: "EDIT_PROJECT_COLLABORATORS",
            displayModal: true,

            modalDetails: {
              variant: COLLABORATOR_V2_ADD_EDIT_MODAL,
              searchListTypes: ["PROJECT_GROUP_STUDENTS_POOL"],
              preventRemovingAllCollaborators: true,
              projectId: id,
              labelsConfig: {
                modalHeaderTextLocale: "common:collaborators",
                modalHeaderText: "common:edit_with_label",
                modalFooterCountText: "common:student_count",
                modalListHeaderText:
                  "project:all_members_listed_below_have_access_to_this_activity",
                modalListHeaderTextLocale: "common:student_plural",
                unsavedChangesModalHeader: "common:unsaved_changes",
                unsavedChangesModalBody:
                  "project:the_changes_you_have_made_will_be_discarded_with_label",
                unsavedChangesModalBodyLocale: "common:student_plural",
                disableCollaboratorRemovalTooltip:
                  "project:saa_prevent_student_removal_tooltip",
                noSelectedCollaboratorsEmptyStateText:
                  "common:no_students_added_yet",
                noSelectedCollaboratorsEmptyStateSubText:
                  "project:no_students_empty_state_subtext_saa",
              },
            },
          });
        },
      };
    }

    case "EDIT_SUPERVISOR_COLLABORATOR": {
      return {
        key,
        label: optionLabel,
        disabled: isDisabled || isArchived,
        clickAction: () => {
          updateProjectModalAndDialogueValue({
            modalType: "EDIT_PROJECT_SUPERVISORS",
            displayModal: true,
            modalDetails: {
              variant: COLLABORATOR_V2_ADD_EDIT_MODAL,
              showCurriculum: true,
              searchListTypes: ["ORGANIZATION_STAFF"],
              projectId: id,
              labelsConfig: {
                modalHeaderTextLocale: "project:supervisor_plural",
                modalHeaderText: "common:edit_with_label",
                modalFooterCountText: "project:supervisor_with_count",
                modalListHeaderText:
                  "project:all_members_listed_below_have_access_to_this_activity",
                modalListHeaderTextLocale: "project:supervisor_plural",
                unsavedChangesModalHeader: "common:unsaved_changes",
                unsavedChangesModalBody:
                  "project:the_changes_you_have_made_will_be_discarded_with_label",
                unsavedChangesModalBodyLocale: "project:supervisor_plural",
                noSelectedCollaboratorsEmptyStateText:
                  "project:no_supervisors_added_yet",
                noSelectedCollaboratorsEmptyStateSubText:
                  "project:no_supervisors_empty_state_subtext_saa",
              },
            },
          });
        },
      };
    }

    case "EDIT": {
      const {
        extraParams,
        type,
        projectTitleName,
        titleFieldObject,
        subtype,
      } = _.get(updatedAction, "config", {});
      return {
        key,
        label: optionLabel,
        disabled: isDisabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            projectId: id,
            [type]: true,
            extraParams,
            subtype,
            projectTitleName,
            modalMode: "EDIT",
            titleFieldObject,
            supervisors,
            students,
          }),
      };
    }

    case "GO_TO_PROJECT": {
      return {
        key,
        label: optionLabel,
        disabled: isDisabled,
        clickAction: () =>
          goToRelativeRoute({
            route: `./${id}`,
          }),
      };
    }

    case "SUB_MENU": {
      const options = getProjectActionMenu({
        id,
        t,
        actionsList,
        actionIds: action?.options,
        getPrintFile,
        updateProjectModalAndDialogueValue,
        courseId,
        getProjectFileUrl,
        getProjectFileFolderUrl,
        fileFolderConfig,
        entityType,
        isFinalReportSubmitted,
        nodeFields,
        yearGroupName,
      });
      const isAllOptionsDisabled = _.every(options, { disabled: true });

      return {
        key,
        label: t("common:download_with_label", {
          label: optionLabel,
        }),
        isSubMenu: true,
        disabled: disabled || isAllOptionsDisabled,
        disabledTooltip: t("project:no_file_added_yet"),
        options,
        projectGroupCategoryType,
      };
    }

    default:
      return {};
  }
};

export const getProjectActionMenu = props => {
  const { actionIds, actionsList, ...rest } = props;

  return _.reduce(
    actionIds,
    (result, key) => {
      const action = _.get(actionsList, `${key}`, {});
      const isDivider = _.get(action, "isDivider", false);

      result.push({
        ...getProjectActionDetails({
          key,
          action,
          actionsList,
          ...rest,
        }),
        shouldFocusOnActionDropdownOnActionClick: true,
      });

      if (isDivider) {
        result.push({ isDivider: true });
      }
      return result;
    },
    []
  );
};

export const isProjectFieldFilled = ({
  fields,
  fieldUid,
  dataConfig,
  uiConfig,
  project,
}) => {
  const { dataType = "", fieldUids = [], fieldType } = dataConfig;
  const { uiType } = uiConfig;

  const getFieldValue = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => _.get(field, "uid") == fieldType),
      "value",
      ""
    );
    return value;
  };

  const getFieldAttachments = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => _.get(field, "uid") == fieldType),
      "attachments",
      ""
    );
    return value;
  };

  const getFieldIsComplete = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "isComplete"
    );
    return value;
  };
  const isNewDeadline = isNewDeadlineEnabled();
  let draftSubmissionItem = {};
  let finalSubmissionItem = {};

  if (isNewDeadline) {
    const tasks = _.get(project, "tasks", []);

    draftSubmissionItem = _.find(
      tasks,
      item => item?.task?.submission?.type === SUBMISSION_TYPE_DRAFT
    );
    finalSubmissionItem = _.find(
      tasks,
      item => item?.task?.submission?.type === SUBMISSION_TYPE_FINAL
    );
  }

  switch (dataType) {
    case "FIELD": {
      const value = getFieldValue({
        fieldType,
        fields,
      });
      const attachments = getFieldAttachments({ fieldType, fields });

      switch (uiType) {
        case "FINAL_REPORT_WITH_SIMILARITY": {
          return isNewDeadline
            ? _.get(finalSubmissionItem, "isSubmissionTurnedIn")
            : !_.isEmpty(attachments);
        }
        case "TICK_AND_CLOCK":
        case "ICON": {
          switch (fieldUid) {
            case "bibliography":
            case "draftReport": {
              return isNewDeadline
                ? _.get(draftSubmissionItem, "isSubmissionTurnedIn")
                : !_.isEmpty(attachments);
            }
            default: {
              return !_.isEmpty(value);
            }
          }
        }
        case "TEXT_WITH_IMAGE": {
          const image = getFieldValue({ fieldType: "image", fields });
          return !_.isEmpty(value) && !_.isEmpty(image);
        }
        case "FORM_COMPLETE_ICON_SL_HL_NA": {
          const { subjectLevel } = dataConfig;

          const studentSubjectLevel = getSubjectLevelTag({
            student: _.get(project, "students.0", {}),
          });

          if (_.isEqual(subjectLevel, studentSubjectLevel)) {
            const isComplete = getFieldIsComplete({
              fieldType,
              fields,
            });
            return isComplete;
          } else {
            return false;
          }
        }
        case "FORM_COMPLETE_ICON": {
          const isComplete = getFieldIsComplete({
            fieldType,
            fields,
          });
          return isComplete;
        }
        default:
          return !_.isEmpty(value);
      }
    }

    case "MULTIFIELD": {
      const filterFields = _.filter(fields, field =>
        _.includes(fieldUids, field.pseudoFieldUid)
      );

      switch (fieldUid) {
        case "extract":
          return !_.some(filterFields, item => {
            if (_.isEqual(item.pseudoFieldUid, "extract_title")) {
              return _.isEmpty(item.value);
            } else if (_.isEqual(item.pseudoFieldUid, "extract_description")) {
              const fieldValue = _.get(
                item.value,
                `fieldValues.${item.value?.selectedField}`,
                null
              );
              return _.isEmpty(fieldValue);
            } else {
              return true;
            }
          });
        case "draft_solution":
        case "final_solution":
          return !_.some(filterFields, item => {
            return _.isEmpty(_.get(item, "attachments", []));
          });
        case "draft_submission":
          return isNewDeadline
            ? _.get(draftSubmissionItem, "isSubmissionTurnedIn")
            : !_.some(filterFields, item => {
                return _.isEmpty(item.value);
              });
        case "final_submission":
          return isNewDeadline
            ? _.get(finalSubmissionItem, "isSubmissionTurnedIn")
            : !_.some(filterFields, item => {
                return _.isEmpty(item.value);
              });

        default:
          return !_.some(filterFields, item => {
            return _.isEmpty(item.value);
          });
      }
    }
    case "DRAFT_REPORT":
      return isNewDeadline
        ? _.get(draftSubmissionItem, "isSubmissionTurnedIn")
        : !_.isEmpty(_.get(project, "projectReports", []));

    case "FINAL_REPORT_WITH_SIMILARITY":
      return isNewDeadline
        ? _.get(finalSubmissionItem, "isSubmissionTurnedIn")
        : !_.isEmpty(_.get(project, "finalProjectReports", []));
  }
};

const getColumnData = props => {
  const {
    t,
    subjects,
    getPrintFile,
    project,
    dataConfig = {},
    updateProjectDetails,
    id,
    updateProjectModalAndDialogueValue,
    uiType,
    assessmentTools,
    deadlines,
    goToRelativeRoute,
    actionIds = [],
    actionsList,
    courseId,
    getProjectFileUrl,
    getProjectFileFolderUrl,
    disabled = false,
    projectGroupType,
    template,
    projectGroupId,
    currentUserId,
    currentUserType,
    orgSupervisorsStaff = [],
    advisers = [],
    studentNameOrderBy,
    role,
    currentCurriculumProgramId,
    organizationId,
    yearGroupName,
    projectGroupCategoryType,
    criteria,
    customOverallProgressIndicators = [],
    allActiveProjectMappedStudents = [],
  } = props;

  const getFieldValue = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "value",
      ""
    );
    return value;
  };

  const getFieldIsComplete = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "isComplete",
      ""
    );
    return value;
  };

  const getFieldAttachments = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "attachments",
      ""
    );
    return value;
  };

  const getResolvedMinimalTreeValue = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "resolvedMinimalTree",
      ""
    );
    return value;
  };

  const getSubjectValue = ({ fields }) => {
    const subjectId = getFieldValue({ fieldType: "subject", fields });
    return _.get(
      _.find(subjects, subject => subject.id == subjectId),
      "name",
      "-"
    );
  };

  const getPlannerElementValue = ({ fieldType, fields }) => {
    const plannerNodes = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "resolvedMinimalTree.nodes",
      []
    );
    return _.get(_.first(plannerNodes), "label", "-");
  };

  const getDeadlinesValue = ({ completedDeadlines }) => {
    const deadlinesList = _.map(deadlines, deadline => ({
      ...deadline,
      isChecked: Boolean(
        _.find(
          completedDeadlines,
          completedDeadline => completedDeadline.deadline.id === deadline.id
        )
      ),
    }));
    const deadlineLabel =
      _.size(deadlines) > 0
        ? `${_.size(_.filter(deadlinesList, { isChecked: true }))}/${_.size(
            deadlines
          )}`
        : "-";
    const deadlinesAchieved = _.filter(deadlinesList, { isChecked: true });
    const deadlinesPending = _.filter(deadlinesList, { isChecked: false });
    const isTooltipEnabled = !_.isEmpty(deadlines);
    const deadlineData = [
      {
        id: "COMPLETED",
        data: deadlinesAchieved,
        subLabel: "common:completed",
      },
      { id: "PENDING", data: deadlinesPending, subLabel: "common:pending" },
    ];

    return { deadlineData, deadlineLabel, isTooltipEnabled };
  };

  const getDeadlinesValueV2 = ({ projectTasks }) => {
    const tasks = _.map(projectTasks, projectTask => {
      const { title, description, dueOn, closesOn, id } = _.get(
        projectTask,
        "task",
        {}
      );
      const { isComplete } = projectTask;
      return {
        id,
        title,
        description,
        dueOn,
        closesOn,
        isComplete,
      };
    });
    const completedTasks = _.filter(tasks, { isComplete: true });
    const label =
      _.size(tasks) == 0 ? "-" : `${_.size(completedTasks)}/${_.size(tasks)}`;

    return { tasks, label };
  };

  const getAssessmentRatings = ({
    project,
    totalAssessmentRating,
    ratingType,
  }) => {
    const ibPYPElementRatings = _.get(project, "node.ibPYPElementRatings", []);

    if (ratingType) {
      if (ratingType == "CRITERIA_RUBRIC_FINAL_GRADE")
        return _.get(
          _.find(
            ibPYPElementRatings,
            value =>
              _.get(value, "academicCriteriaSet.criteriaType", "") == ratingType
          ),
          "value",
          "-"
        );
      const assessmentRating = _.get(
        _.find(
          ibPYPElementRatings,
          value =>
            _.get(value, "academicCriteriaSet.criteriaType", "") == ratingType
        ),
        "academicCriteriaValue.abbreviation",
        "-"
      );

      return assessmentRating > 0
        ? `${assessmentRating}/${totalAssessmentRating}`
        : "-";
    } else {
      if (_.isEmpty(ibPYPElementRatings)) {
        return null;
      }

      //uniqBy is used on ibPYPElementId to remove duplicate data in case of multiple students in a project
      const rating = _.reduce(
        _.uniqBy(ibPYPElementRatings, "ibPYPElementId"),
        (count, item) => {
          const { academicCriteriaSet: { criteriaType = "" } = {} } =
            item || {};
          if (
            !_.isEqual(criteriaType, PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE)
          ) {
            return (
              count + +_.get(item, "academicCriteriaValue.abbreviation", "0")
            );
          }
          return count;
        },
        0
      );
      return rating ? `${rating}/${totalAssessmentRating}` : "-";
    }
  };

  const getInterviewArray = ({ project }) => {
    const interviews = _.get(project, "node.interviews.edges", []);

    return _.reduce(
      interviews,
      (res, item) => {
        const isLocked = _.isEqual(
          _.get(item, "node.lockingState.state"),
          ENTITY_LOCKED_STATE
        );
        res[item.node.displaySequence - 1] = isLocked;
        return res;
      },
      _.fill(Array(3), false)
    );
  };

  const getInterviewFieldsArray = ({ project }) => {
    let interviewFieldsArray = [];

    const interviews = _.get(project, "node.interviews.edges", []);
    interviewFieldsArray = _.reduce(
      interviews,
      (res, item) => {
        const {
          meetingDate,
          description,
          attachments,
          displaySequence,
        } = _.get(item, "node", {});
        res.push({
          isMeetingDateAdded: meetingDate ? true : false,
          isRemarkAdded: description ? true : false,
          isAttachmentAdded: !_.isEmpty(attachments),
          displaySequence,
        });
        return res;
      },
      []
    );

    return interviewFieldsArray;
  };

  const getIsFieldValueSubmitted = ({ filterFields, fieldUid, value }) => {
    const fieldValue = _.get(
      _.find(filterFields, { pseudoFieldUid: fieldUid }),
      value,
      []
    );

    return !_.isEmpty(fieldValue);
  };

  const { dataType = "" } = dataConfig;
  switch (dataType) {
    case "ID":
      return _.get(project, "node.id", "");

    case "DRAFT_SUBMISSION_STATUS": {
      const { tasks: projectTasks = [] } = _.get(project, "node", {});

      const draftSubmissionTask = _.filter(projectTasks, item => {
        return _.get(item, "task.submission.type") === SUBMISSION_TYPE_DRAFT;
      });

      return {
        submissionStatus: _.get(
          draftSubmissionTask,
          "0.latestSubmissionResponse.status"
        ),
      };
    }

    case "FINAL_SUBMISSION_STATUS": {
      const { tasks: projectTasks = [] } = _.get(project, "node", {});

      const finalSubmissionTask = _.filter(projectTasks, item => {
        return _.get(item, "task.submission.type") === SUBMISSION_TYPE_FINAL;
      });

      return {
        submissionStatus: _.get(
          finalSubmissionTask,
          "0.latestSubmissionResponse.status"
        ),
      };
    }

    case "ACADEMIC_YEAR_NAME": {
      const { academicYear = {} } = _.get(project, "node", {});

      const { startDate, endDate } = academicYear;
      const yearDuration = getYearDurationFormat({ startDate, endDate });

      const academicYearName = t("project:ay_with_label", {
        label: yearDuration,
      });
      return academicYearName;
    }

    case "STUDENT_ID":
      return _.get(project, "node.student.id", "");

    case "PORTFOLIO_STUDENT_NAME_WITH_AVATAR":
      return {
        id: _.get(project, `node.student.id`, null),
        name: getFormattedUserName({
          user: _.get(project, "node.student", {}),
          showStudentUID: true,
          orderBy: studentNameOrderBy,
        }),
        profileImage: _.get(project, `node.student.profileImage`, null),
        studentAlertsConfig: {
          alertTypes: _.get(project, "node.student.alertTypes"),
          studentId: _.get(project, "node.student.id", null),
        },
      };

    case "PROJECT_SUPERVISOR_NAME_CASCADE": {
      const supervisors = _.get(project, "node.supervisors", []);

      return getSupervisorNameCascade({ supervisors });
    }

    case "PROJECT_STUDENT_NAME_WITH_AVATAR": {
      switch (uiType) {
        default:
        case "NAME_WITH_AVATAR":
          return {
            id: _.get(project, `node.students[0].id`, null),
            name: getFormattedUserName({
              user: _.first(_.get(project, "node.students", [])),
              showStudentUID: true,
            }),
            profileImage: _.get(project, `node.students[0].profileImage`, null),
            studentAlertsConfig: {
              alertTypes: _.get(project, "node.students[0].alertTypes"),
              studentId: _.get(project, "node.students[0].id", null),
            },
          };

        case "NAMES_CASCADE_WITH_AVATAR": {
          const students = _.get(project, "node.students", []);
          const currentUserInStudents = _.find(students, { id: currentUserId });

          const firstStudent = currentUserInStudents
            ? currentUserInStudents
            : _.get(students, ["0"], {});
          const {
            profileImage: firstProfileImage,
            id: firstProfileId,
          } = firstStudent;

          const tailingUsers = _.map(
            currentUserType === "STUDENT"
              ? _.reject(students, { id: currentUserId })
              : _.tail(students),
            student =>
              getFormattedUserName({ user: student, showStudentUID: true })
          );

          return {
            isUsersListEmpty: _.isEmpty(_.get(project, "node.students")),
            firstProfileName: getFormattedUserName({
              user: firstStudent,
              showStudentUID: true,
            }),
            firstProfileImage,
            firstProfileId,
            tailingUsers,
          };
        }
      }
    }

    case "PORTFOLIO_STAFF_NAME_WITH_AVATAR":
      return {
        id: _.get(project, `node.staff.id`, null),
        name: `${getFormattedUserName({
          user: _.get(project, "node.staff", {}),
        })}`,
        profileImage: _.get(project, `node.staff.profileImage`, null),
        isArchived: getUserArchivalStatus(_.get(project, "node.staff", {})),
      };

    case "PORTFOLIO_COMPLETION_STATUS":
      return _.get(project, "node.completionStatus.isComplete", false)
        ? { icon: "tickIcon", customTooltip: t("common:completed") }
        : { icon: "thumbsIcon", customTooltip: t("project:pending") };

    case "PROJECT_SUPERVISOR_NAME_WITH_AVATAR": {
      return {
        id: _.get(project, `node.supervisors[0].id`, null),
        name: `${getFormattedUserName({
          user: _.get(project, "node.supervisors[0]", {}),
        })}`,
        profileImage: _.get(project, `node.supervisors[0].profileImage`, null),
        isArchived: getUserArchivalStatus(
          _.get(project, `node.supervisors[0]`, {})
        ),
      };
    }

    case "EXPERIENCE_SUPERVISOR_NAME_WITH_AVATAR": {
      const isExternalSupervisorEnabled = ACLStore.can(
        "FeatureFlag:CASExternalSupervisor"
      );

      const isCasExternalPortingDone = _.get(
        project,
        "node.isCasExternalPortingDone",
        false
      );

      let supervisorType = _.get(
        _.find(_.get(project, "node.fields", []), { uid: "supervisorType" }),
        "value",
        null
      );
      //extra check just in case if already assigned supervisors are not set by default INTERNAL during porting for SAA
      const supervisors = _.get(project, "node.supervisors");
      if (
        _.isEqual(projectGroupType, PROJECT_GROUP_TYPE_SERVICE_AS_ACTON) &&
        _.isNil(supervisorType) &&
        !_.isNil(supervisors)
      ) {
        supervisorType = "INTERNAL";
      }

      const isInternalSupervisor = _.isEqual(supervisorType, "INTERNAL");
      const isProjectGroupTypeSL =
        projectGroupType === PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING;
      const isProjectGroupTypeSAA =
        projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON;
      const isExternalSupervisor = _.isEqual(supervisorType, "EXTERNAL");

      const userData = {};

      let hasOldExternalSupervisor = false;

      let archivedNames = [];

      if (
        isInternalSupervisor ||
        (isExternalSupervisorEnabled &&
          !isProjectGroupTypeSL &&
          !isProjectGroupTypeSAA)
      ) {
        const taggedSupervisors = _.get(project, "node.supervisors", []);
        let updatedTaggedSupervisors = taggedSupervisors;

        // if external enabled and porting not done append the unported data
        if (
          isExternalSupervisorEnabled &&
          !isCasExternalPortingDone &&
          isExternalSupervisor
        ) {
          const oldExternalSupervisorDetails = _.find(
            _.get(project, "node.fields", []),
            { uid: "supervisor" }
          );
          const { id = "", value = "" } = oldExternalSupervisorDetails;
          hasOldExternalSupervisor = !_.isEmpty(value);

          if (value) {
            updatedTaggedSupervisors = [
              ...(taggedSupervisors ? taggedSupervisors : []),
              {
                id,
                firstName: value,
                lastName: "",
                profileImage: null,
              },
            ];
          }
        }

        const projectSupervisors = _.orderBy(
          updatedTaggedSupervisors,
          supervisor =>
            _.lowerCase(`${getFormattedUserName({ user: supervisor })}`)
        );

        archivedNames = getArchivedUsersNames(projectSupervisors);

        // deatils of supervisor if it is also the current User
        const currentUserInProjectSupervisors = _.find(projectSupervisors, {
          id: currentUserId,
        });

        const firstSupervisortoDisplay = currentUserInProjectSupervisors
          ? currentUserInProjectSupervisors
          : _.get(projectSupervisors, ["0"], {});

        userData["id"] = _.get(firstSupervisortoDisplay, "id", null);

        userData["name"] = getFormattedUserName({
          user: firstSupervisortoDisplay,
        });

        userData["profileImage"] = _.get(
          firstSupervisortoDisplay,
          "profileImage",
          null
        );

        userData["tailingUsers"] = _.map(
          _.filter(
            projectSupervisors,
            supervisor => supervisor?.id != userData?.id
          ),
          supervisor => getFormattedUserName({ user: supervisor })
        );
      } else {
        const supervisorTypeDetails = _.find(
          _.get(project, "node.fields", []),
          {
            uid: "supervisorType",
          }
        );

        const supervisorNameDetails = _.find(
          _.get(project, "node.fields", []),
          { uid: "supervisor" }
        );

        userData["id"] = _.get(supervisorTypeDetails, "id", "");
        userData["name"] = _.get(supervisorNameDetails, "value", "");
      }

      let isUsersListEmpty = false;
      if (
        isExternalSupervisorEnabled &&
        !isProjectGroupTypeSL &&
        !isProjectGroupTypeSAA
      ) {
        isUsersListEmpty = !_.trim(userData?.name);
      } else {
        isUsersListEmpty = !supervisorType || !_.trim(userData?.name);
      }

      return {
        isUsersListEmpty,
        firstProfileName: userData?.name,
        firstProfileImage: userData?.profileImage || null,
        firstProfileId: userData?.id,
        tailingUsers: userData?.tailingUsers || [],
        archivedNames,
        hasOldExternalSupervisor,
      };
    }

    case "PROJECT_REFLECTION_COUNT": {
      const academicHonesty = _.get(project, "node.academicHonesty", []);
      const academicHonestyListSize = _.size(academicHonesty);
      const getName = ({ item }) => {
        return getFormattedUserName({
          user: item,
        });
      };
      const reflectionDetails = _.reduce(
        academicHonesty,
        (reflectionData, item) => {
          const { createdBy, description } = item;
          if (description) {
            reflectionData.totalCount += 1;
            reflectionData.tooltipData.push({
              text: getName({ item: createdBy }),
              isChecked: true,
            });
          } else {
            reflectionData.tooltipData.push({
              text: getName({ item: createdBy }),
              isChecked: false,
            });
          }

          return reflectionData;
        },
        { totalCount: 0, tooltipData: [] }
      );
      return {
        text: `${reflectionDetails?.totalCount}/${academicHonestyListSize}`,
        tooltipWithCheckAndCross: reflectionDetails?.tooltipData,
      };
    }

    case "UNREAD_COMMENTS_COUNT": {
      const showNewTag = !_.get(project, "node.isRead", true);

      const {
        unreadPostCount = 0,
        unreadPostCommentCount = 0,
        unreadCommentCount = 0,
        unreadAcademicHonestyCount = 0,
        unreadAttachmentCount = 0,
        unreadPendingReviewLogCount = 0,
        unreadResolvedReviewLogCount = 0,
        interestsAndGoalsCommentCount = 0,
        learningOutcomesCommentCount = 0,
        feedbackCommentCount = 0,
        feedbackCount = 0,
        totalUnreadCountsOfPortfolioProjects = 0,
        unreadAttachmentAnnotatedCount = 0,
        unreadPendingReviewLogCommentCount = 0,
        unreadResolvedReviewLogCommentCount = 0,
        newProjectCount = 0,
        interviewCount = 0,
        unreadProjectEvidenceCommentCount = 0,
        unreadProjectTasksCommentsCount = 0,
        unreadProjectPresentationCommentsCount = 0,
      } = _.get(project, "node.notificationBadgeCounts", {});

      const notificationList = {
        [POST_NOTIFICATION_BADGES_COUNT]: unreadPostCount,
        [COMMENT_NOTIFICATION_BADGES_COUNT]:
          unreadCommentCount +
          unreadPostCommentCount +
          interestsAndGoalsCommentCount +
          learningOutcomesCommentCount +
          feedbackCommentCount +
          unreadPendingReviewLogCommentCount +
          unreadResolvedReviewLogCommentCount +
          unreadProjectEvidenceCommentCount +
          unreadProjectTasksCommentsCount +
          unreadProjectPresentationCommentsCount,
        [ACADEMIC_HONESTY_NOTIFICATION_BADGES_COUNT]: unreadAcademicHonestyCount,
        [ATTACHMENT_NOTIFICATION_BADGES_COUNT]: unreadAttachmentCount,
        [REVIEW_NOTIFICATION_BADGES_COUNT]:
          unreadPendingReviewLogCount + unreadResolvedReviewLogCount,
        [FEEDBACK_NOTIFICATION_BADGES_COUNT]: feedbackCount,
        [EXPERIENCE_NOTIFICATION_BADGES_COUNT]: newProjectCount,
        [INTERVIEW_NOTIFICATION_BADGES_COUNT]: interviewCount,
        [OTHER_CHANGES_BADGES_COUNT]: totalUnreadCountsOfPortfolioProjects,
        [ANNOTATION_NOTIFICATION_BADGES_COUNT]: unreadAttachmentAnnotatedCount,
      };

      return {
        notificationCount:
          unreadAttachmentAnnotatedCount +
          unreadPostCount +
          unreadPostCommentCount +
          unreadCommentCount +
          unreadAcademicHonestyCount +
          unreadAttachmentCount +
          unreadPendingReviewLogCount +
          unreadResolvedReviewLogCount +
          interestsAndGoalsCommentCount +
          learningOutcomesCommentCount +
          feedbackCommentCount +
          feedbackCount +
          totalUnreadCountsOfPortfolioProjects +
          unreadPendingReviewLogCommentCount +
          newProjectCount +
          unreadResolvedReviewLogCommentCount +
          interviewCount +
          unreadProjectEvidenceCommentCount +
          unreadProjectTasksCommentsCount +
          unreadProjectPresentationCommentsCount,
        showNewTag,
        notificationList,
        projectId: _.get(project, "node.id", ""),
      };
    }

    case "FIELD": {
      const { fieldType, showSubtext = true } = dataConfig;
      const fields = _.get(project, "node.fields", []);
      switch (uiType) {
        case "FINAL_REPORT_WITH_SIMILARITY": {
          const attachments = getFieldAttachments({ fieldType, fields });
          return {
            finalReport: attachments,
            projectId: _.get(project, "node.id", null),
          };
        }
        case "TICK_AND_CLOCK":
        case "ICON": {
          switch (id) {
            case "bibliography":
            case "draft_report": {
              const attachments = getFieldAttachments({ fieldType, fields });

              const isValueEmpty = _.isEmpty(attachments);

              return {
                iconType: !isValueEmpty ? "tickIcon" : "closeIcon",
                iconVariant: !isValueEmpty ? "success" : "subtle",
              };
            }

            default: {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return { iconType: !_.isEmpty(value) ? "tickIcon" : "closeIcon" };
            }
          }
        }
        case "TEXT_WITH_IMAGE": {
          const isArchived = _.get(project, "node.isArchived", false);
          let subTitleText = "";
          switch (id) {
            case "experience_title":
              subTitleText = showSubtext
                ? _.isEqual(_.get(project, "node.type", ""), "PROJECT")
                  ? t("project:project")
                  : t("project:experience")
                : "";
              break;
          }
          return {
            value:
              getFieldValue({
                fieldType,
                fields,
              }) || t("common:untitled"),
            image: getFieldValue({ fieldType: "image", fields }),
            subTitleText,
            isArchived,
          };
        }
        case "LABEL_SLASH_LABEL": {
          let currentValue = "";
          const { totalCountLabel = "" } = dataConfig;
          switch (id) {
            case "no_of_artworks": {
              currentValue = _.size(
                _.get(_.find(fields, { uid: fieldType }), "children", [])
              );
              break;
            }
          }

          return {
            label1: currentValue,
            label2: totalCountLabel,
            label2Variant: "subtle",
          };
        }

        case "PROJECT_LOS_TAGGED_POPOVER": {
          const resolvedMinimalTree = getResolvedMinimalTreeValue({
            fieldType,
            fields,
          });
          const losTagged = _.map(resolvedMinimalTree?.nodes, item => {
            const displayName = _.get(item, ["metadata", "display_name"], null);
            const { label, type } = item;
            return getIsTypeOfProjectPortfolioLOs({ type }) && displayName
              ? `${displayName}: ${label}`
              : label;
          });

          return {
            losTaggedList: losTagged,
          };
        }

        case "TEXT_WITH_TOOLTIP": {
          let data = [];
          switch (id) {
            case "days": {
              const value = getFieldValue({
                fieldType,
                fields,
              });

              const { startDate, endDate } = value || {};

              if (startDate && endDate) {
                data = {
                  text: t("common:days_with_count", {
                    count:
                      _.toNumber(
                        moment
                          .duration(moment(endDate).diff(moment(startDate)))
                          .format("D")
                      ) + 1,
                  }),
                  tooltip: `${formatDate({
                    date: startDate,
                    format: DATE_TIME_CONSTANTS.D_MMM_YYYY,
                  })} - ${formatDate({
                    date: endDate,
                    format: DATE_TIME_CONSTANTS.D_MMM_YYYY,
                  })}`,
                };
              } else {
                data = {
                  text: "-",
                  tooltip: "",
                };
              }

              break;
            }
            case "cas_strands":
            case "sl_service_type":
            case "saa_service_type": {
              const strandsMap = _.get(
                PORTFOLIO_STRANDS_MAPPING,
                projectGroupType,
                {}
              );

              const resolvedMinimalTree = getResolvedMinimalTreeValue({
                fieldType,
                fields,
              });

              const availableStrands = _.map(resolvedMinimalTree?.nodes, item =>
                _.get(item, "metadata.subType", "")
              );

              data = _.reduce(
                availableStrands,
                (res, item) => {
                  const strandDetails = _.find(strandsMap, {
                    subType: item,
                  });

                  const { text: resText, tooltip: resTooltip } = res;
                  const label = t(_.get(strandDetails, "label", ""));
                  const abbreviation = _.get(strandDetails, "abbreviation", "");

                  return {
                    text: resText
                      ? `${resText}, ${abbreviation}`
                      : abbreviation,
                    tooltip: resTooltip ? `${resTooltip}, ${label}` : label,
                  };
                },
                { text: "", tooltip: "" }
              );
            }
          }
          return data;
        }

        case "TEXT_OR_DASH": {
          switch (id) {
            case "duration": {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return t("common:days_with_count", {
                count: _.toNumber(
                  moment
                    .duration(
                      moment(value?.endDate).diff(moment(value?.startDate))
                    )
                    .format("DD")
                ),
              });
            }
            case "start_date": {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return value?.startDate
                ? formatDate({
                    date: value?.startDate,
                    format: DATE_TIME_CONSTANTS.D_MMM_YYYY,
                  })
                : "-";
            }
            case "end_date": {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return value?.endDate
                ? formatDate({
                    date: value?.endDate,
                    format: DATE_TIME_CONSTANTS.D_MMM_YYYY,
                  })
                : "-";
            }
            case "subject": {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return _.get(
                _.find(subjects, subject => subject.id == value),
                "name",
                "-"
              );
            }
            case "subjectV2": {
              const value = getFieldValue({
                fieldType,
                fields,
              });

              const selectedSubject = _.filter(subjects, subject => {
                return _.includes(_.get(value, "[0]", []), subject.id);
              });

              const res = _.map(selectedSubject, "name").join(", ");
              return res;
            }
            case "supervision_hours": {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return value
                ? t("project:duration_with_h", {
                    hours: value,
                  })
                : "";
            }
            case "activityDuration":
            case "projectDuration": {
              const value = getFieldValue({
                fieldType,
                fields,
              });
              return !_.isNil(value)
                ? t("project:duration_with_h", {
                    hours: value,
                  })
                : "-";
            }
          }
          const value = getFieldValue({
            fieldType,
            fields,
          });
          return !value &&
            _.isEqual(projectGroupType, PROJECT_TYPE_SERVICE_AS_ACTION)
            ? t("common:untitled_with_label", {
                label: t("common:activity"),
              })
            : value;
        }
        case "FORM_COMPLETE_ICON": {
          const isComplete = getFieldIsComplete({
            fieldType,
            fields,
          });
          return {
            iconType: isComplete ? "tickIcon" : "closeIcon",
            isComplete,
          };
        }
        case "FORM_COMPLETE_ICON_SL_HL_NA": {
          const { subjectLevel } = dataConfig;

          const studentSubjectLevel = getSubjectLevelTag({
            student: _.get(project, "node.students.0", {}),
          });

          if (_.isEqual(subjectLevel, studentSubjectLevel)) {
            const isComplete = getFieldIsComplete({
              fieldType,
              fields,
            });
            return {
              showNA: false,
              iconType: isComplete ? "tickIcon" : "closeIcon",
              isComplete,
            };
          } else {
            return { showNA: true };
          }
        }
        case "TEXT": {
          const value =
            getFieldValue({
              fieldType,
              fields,
            }) || 0;
          return t("project:duration_with_h", {
            hours: value,
          });
        }
        default:
          return getFieldValue({
            fieldType,
            fields,
          });
      }
    }

    case "MULTIFIELD": {
      const { fieldUids } = dataConfig;
      const fields = _.get(project, "node.fields", []);

      const filterFields = _.reduce(
        fieldUids,
        (result, fieldUid) => {
          const field = _.find(fields, { pseudoFieldUid: fieldUid });
          if (!_.isEmpty(field)) {
            result.push(field);
          }
          return result;
        },
        []
      );

      switch (uiType) {
        case "ICON": {
          switch (id) {
            case "extract": {
              return {
                iconType: !_.some(filterFields, item => {
                  if (_.isEqual(item.pseudoFieldUid, "extract_title")) {
                    return _.isEmpty(item.value);
                  } else if (
                    _.isEqual(item.pseudoFieldUid, "extract_description")
                  ) {
                    const fieldValue = _.get(
                      item.value,
                      `fieldValues.${item.value?.selectedField}`,
                      null
                    );
                    return _.isEmpty(fieldValue);
                  }
                })
                  ? "tickIcon"
                  : "closeIcon",
              };
            }
            case "draft_solution":
            case "final_solution": {
              return {
                iconType: !_.some(filterFields, item => {
                  return _.isEmpty(_.get(item, "attachments", []));
                })
                  ? "tickIcon"
                  : "closeIcon",
              };
            }
            default: {
              return {
                iconType: !_.some(filterFields, item => {
                  return _.isEmpty(item.value);
                })
                  ? "tickIcon"
                  : "closeIcon",
              };
            }
          }
        }
        case "MULTI_CIRCLE_TEXT_ICON": {
          const { iconsConfig = [] } = dataConfig;

          switch (id) {
            case "draft_submission_multi_circle_files":
            case "final_submission_multi_circle_files": {
              return {
                iconsUpdatedConfig: _.map(iconsConfig, item => {
                  const itemConfig = {
                    ...item,
                    isSubmitted: getIsFieldValueSubmitted({
                      filterFields,
                      fieldUid: item.fieldUid,
                      value: "attachments",
                    }),
                  };
                  return itemConfig;
                }),
              };
            }
            default: {
              return {
                iconsUpdatedConfig: _.map(iconsConfig, item => {
                  const itemConfig = {
                    ...item,
                    isSubmitted: getIsFieldValueSubmitted({
                      filterFields,
                      fieldUid: item.fieldUid,
                      value: "value",
                    }),
                  };
                  return itemConfig;
                }),
              };
            }
          }
        }
        case "TEXT_WITH_TOOLTIP": {
          switch (id) {
            case "extract": {
              // Here, fields are "extract_item_one, extract_item_two", so we are using sortBy to ensure the tooltip label of extract item in order i.e extract_item_one first then extract_item_two.
              const filteredParentFields = _.filter(
                _.sortBy(fields, ["uid"]),
                item => !_.isEmpty(item?.children)
              );

              const groupedFieldsWithParent = _.reduce(
                filteredParentFields,
                (result, parentField) => {
                  result[parentField?.uid] = _.filter(fields, field =>
                    _.includes(parentField?.children, field?.id)
                  );
                  return result;
                },
                {}
              );

              const groupedFieldsWithValue = _.pickBy(
                groupedFieldsWithParent,
                (fieldsData, key) => {
                  return !_.some(fieldsData, item => {
                    switch (item.pseudoFieldUid) {
                      case "extract_title_one":
                      case "extract_title_two": {
                        return _.isEmpty(item?.value);
                      }
                      case "extract_description_one":
                      case "extract_description_two": {
                        const fieldValue = _.get(
                          item.value,
                          `fieldValues.${item?.value?.selectedField}`,
                          null
                        );

                        return _.isEmpty(fieldValue);
                      }
                      default:
                        return false;
                    }
                  });
                }
              );

              const totalCount = _.size(groupedFieldsWithParent);
              const submittedCount = _.size(groupedFieldsWithValue);
              const label =
                totalCount > 0 ? `${submittedCount}/${totalCount}` : "-";

              const tooltipData = _.reduce(
                groupedFieldsWithParent,
                (result, value, key) => {
                  const field_list = _.get(template, "body.field_list", []);

                  const label = _.get(field_list[key], "config.label", "");

                  if (_.has(groupedFieldsWithValue, key)) {
                    result.push({
                      text: label,
                      isChecked: true,
                    });
                  } else {
                    result.push({
                      text: label,
                      isChecked: false,
                    });
                  }
                  return result;
                },
                []
              );

              return {
                text: label,
                tooltipWithCheckAndCross: tooltipData,
              };
            }
            case "draft_submission":
            case "final_submission": {
              const { text, tooltipWithCheckAndCross } = getSubmittedCountLabel(
                {
                  fields: filterFields,
                  fieldProperty: "attachments",
                  template,
                  t,
                }
              );
              return {
                text,
                tooltipWithCheckAndCross,
              };
            }

            default: {
              const { text, tooltipWithCheckAndCross } = getSubmittedCountLabel(
                {
                  fields: filterFields,
                  template,
                }
              );

              return {
                text,
                tooltipWithCheckAndCross,
              };
            }
          }
        }
      }
      break;
    }

    //Deprecated!
    case "SUBJECT":
      return getSubjectValue({ fields: _.get(project, "node.fields", []) });

    case "PLANNER_FIELD": {
      const { fieldType } = dataConfig;

      return getPlannerElementValue({
        fieldType,
        fields: _.get(project, "node.fields", []),
      });
    }

    case "PROJECT_REPORT_STATUS": {
      switch (uiType) {
        case "TICK_AND_CLOCK":
        case "ICON":
          return {
            iconType:
              _.get(project, "node.reportStatus", "") ==
              PROJECT_REPORT_STATUS_APPROVED
                ? "tickIcon"
                : "clockIcon",
            tickTooltip: t("common:approved"),
            clockTooltip: t("project:pending_for_approval"),
          };

        case "TEXT_OR_DASH": {
          switch (_.get(project, `node.reportStatus`, "")) {
            case PROJECT_REPORT_STATUS_NOT_STARTED:
              return "-";
            default:
              return t(
                PROJECT_REPORT_STATUS[_.get(project, `node.reportStatus`, "")]
                  ?.label
              );
          }
        }

        default:
        case "STATUS_THUMBS_OR_TICK": {
          const reportStatus = _.get(project, "node.reportStatus", "none");
          return getProjectReportStatusIconType({
            t,
            reportStatus,
            projectGroupId,
          });
        }
      }
    }

    case "PROJECT_ACADEMIC_HONESTY":
      switch (uiType) {
        case "MEETING_NOTES":
        default:
          return {
            academicHonesty: _.get(project, "node.academicHonesty", []),
            academicHonestyRemark: _.get(
              project,
              "node.academicHonestyRemarks",
              {}
            ),
          };
      }
    case "PROJECT_STUDENT_MAP_ACADEMIC_HONESTY":
      switch (uiType) {
        case "MEETING_NOTES_POPOVER": {
          const studentCollaborators = _.get(
            project,
            "node.studentCollaborators",
            []
          );

          return {
            completedAcademicHonestyCount: _.sumBy(
              studentCollaborators,
              collaborator =>
                _.get(collaborator, "isAcademicHonestyLocked") ? 1 : 0
            ),
            academicHonestyMap: _.reduce(
              studentCollaborators,
              (result, collaborator) => {
                const studentName = getFormattedUserName({
                  user: _.get(collaborator, "student", {}),
                  orderBy: studentNameOrderBy,
                });

                const studentId = _.get(collaborator, "id");

                result[studentId] = {
                  studentName,
                  academicHonesty: _.get(collaborator, "academicHonesty", []),
                  academicHonestyRemark: _.get(
                    collaborator,
                    "academicHonestyRemarks",
                    {}
                  ),
                };
                return result;
              },
              {}
            ),
            totalStudentsInProject: _.size(studentCollaborators),
          };
        }
        case "MEETING_NOTES":
        default: {
          const studentCollaborators = _.get(
            project,
            "node.studentCollaborators",
            []
          );

          const collaborator = _.first(studentCollaborators);
          const academicHonesty = _.get(collaborator, "academicHonesty", {});

          return {
            academicHonesty,
          };
        }
      }

    case "PROJECT_ACADEMIC_HONESTY_LOCKED":
      return _.get(project, "node.isAcademicHonestyLocked", false);

    case "PROJECT_ACADEMIC_HONESTY_REMARKS":
      return {
        tickArray: [
          _.get(project, "node.academicHonestyRemarks.isLocked", false),
        ],
        tickCount: 1,
        untickedIconType: "dash",
      };

    case "PORTFOLIO_INTERVIEWS": {
      return {
        tickArray: getInterviewArray({
          project,
        }),
        projectGroupType,
        interviewFieldsArray: getInterviewFieldsArray({
          project,
        }),
        tickCount: 3,
        untickedIconType: "iconWithNumber",
      };
    }

    case "ASSESSMENT_RATING": {
      const { ratingType = null, totalAssessmentRating = 10 } = dataConfig;
      return getAssessmentRatings({
        project,
        totalAssessmentRating,
        ratingType,
      });
    }
    case "FINAL_REPORT_WITH_SIMILARITY": {
      return {
        finalReport: _.get(project, "node.finalProjectReports", []),
        projectId: _.get(project, "node.id", null),
      };
    }

    case "DRAFT_REPORT": {
      const isDraftReportEmpty = _.isEmpty(
        _.get(project, "node.projectReports", [])
      );

      return {
        iconType: !isDraftReportEmpty ? "tickIcon" : "closeIcon",
        iconVariant: !isDraftReportEmpty ? "success" : "subtle",
      };
    }

    case "PROJECT_STATUS":
      switch (uiType) {
        case "TEXT_OR_DASH": {
          const projectOverallProgress = _.find(
            project?.node?.ibPYPElementRatings,
            item =>
              item?.academicCriteriaSet?.criteriaType ==
              PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE
          );

          if (!projectOverallProgress) {
            return _.first(customOverallProgressIndicators)?.label;
          }

          return _.get(
            projectOverallProgress,
            "academicCriteriaValue.label",
            null
          );
        }

        case "STATUS_THUMBS_OR_TICK": {
          const status = _.get(project, "node.status", "");

          switch (status) {
            case PROJECT_STATUS_DRAFT:
              return {
                icon: "fileOutlinedIcon",
                customTooltip: t("common:draft"),
              };
            case PROJECT_STATUS_APPROVED:
              return {
                icon: "thumbsIcon",
                customTooltip: t("common:approved"),
              };
            case PROJECT_STATUS_COMPLETED:
              return {
                icon: "tickIcon",
                customTooltip: t("common:completed"),
              };
            case PROJECT_STATUS_REJECTED:
              return {
                icon: "closeIcon",
                customTooltip: t("common:rejected"),
              };
            default:
              return {
                icon: "fileOutlinedIcon",
              };
          }
        }
        case "COLOR_TEXT_WITH_SUBTEXT": {
          const projectOverallProgress = _.find(
            project?.node?.ibPYPElementRatings,
            item =>
              item?.academicCriteriaSet?.criteriaType ==
              PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE
          );
          return {
            itemDetails: _.get(
              projectOverallProgress,
              "academicCriteriaValue",
              {}
            ),
          };
        }
        default:
          return {
            label: t(PROJECT_STATUS[_.get(project, `node.status`, "")]?.label),
          };
      }

    case "LAST_MODIFIED": {
      const {
        cascadeUpdateAt = "",
        cascadeUpdateBy,
        updatedAt = "",
        updatedBy,
        createdAt = "",
        createdBy,
      } = _.get(project, "node", {});
      const projectUpdatedBy = _.isEmpty(cascadeUpdateBy)
        ? _.isEmpty(updatedBy)
          ? createdBy
          : updatedBy
        : cascadeUpdateBy;
      const projectUpdatedAt = _.isEmpty(cascadeUpdateAt)
        ? _.isEmpty(updatedAt)
          ? createdAt
          : updatedAt
        : cascadeUpdateAt;
      const isCurrentUser = _.get(projectUpdatedBy, "id") === currentUserId;

      const projectUpdatedByName = getFormattedUserName({
        user: projectUpdatedBy,
      });

      const tooltip = isCurrentUser
        ? t("common:by_with_label", {
            label: t("common:lowercase", { text: t("common:me") }),
          })
        : t("common:by_with_label", {
            label: projectUpdatedByName,
          });
      return {
        text: moment(projectUpdatedAt).format(
          DATE_TIME_CONSTANTS.D_MMM_YYYY_h_mm_a
        ),
        tooltip,
      };
    }

    case "DELETED_DATE": {
      const { deletedAt, deletedBy } = _.get(project, "node", {});
      const isCurrentUser = _.get(deletedBy, "id") === currentUserId;

      const projectDeletedBy = getFormattedUserName({
        user: deletedBy,
      });

      const tooltip = t("common:by_with_label", {
        label: isCurrentUser ? t("common:me") : projectDeletedBy,
      });

      return {
        text: moment(deletedAt).format(DATE_TIME_CONSTANTS.D_MMM_YYYY_h_mm_a),
        tooltip,
      };
    }
    case "STUDENT_REGISTRATION_CATEGORY_PORTFOLIO": {
      const registrationCategory = _.get(
        project,
        "node.student.registrationCategory",
        ""
      );
      const registrationCategoryLabel =
        EXAM_REGISTRATION_CATEGORIES_LABEL[registrationCategory];
      return registrationCategoryLabel ? t(registrationCategoryLabel) : "-";
    }
    case "STUDENT_REGISTRATION_CATEGORY": {
      const registrationCategory = _.get(
        project,
        "node.students.0.registrationCategory",
        ""
      );
      const registrationCategoryLabel =
        EXAM_REGISTRATION_CATEGORIES_LABEL[registrationCategory];
      return registrationCategoryLabel ? t(registrationCategoryLabel) : "-";
    }

    case "EXPERIENCE_COUNT":
      return _.get(project, `node.projectCounts.experiencesCount`, 0);

    case "PROJECT_COUNT":
      return _.get(project, `node.projectCounts.projectsCount`, 0);

    case "STRAND_COUNT": {
      const strandLocaleKeyMap = {
        SERVICE: "project:service",
        CREATIVITY: "project:creativity",
        ACTIVITY: "project:activity",
      };
      const strandCountsKey = dataConfig?.strandCountsKey;
      const strandCount = _.get(
        project,
        `node.strandCountsV2.strand.${strandCountsKey}`,
        0
      );
      const projectCounts = _.get(project, "node.projectCounts", {});
      return {
        text: strandCount,
        tooltip: t(
          "project:label_strand_selected_strandCount_times_across_projectCount_experiences_projects",
          {
            label: t(strandLocaleKeyMap[strandCountsKey]),
            strandCount,
            projectCount:
              _.get(projectCounts, "projectsCount", 0) +
              _.get(projectCounts, "experiencesCount", 0),
          }
        ),
      };
    }

    case "LO_COUNT": {
      const { plannerElementEvidences = [], student = {} } = _.get(
        project,
        "node",
        {}
      );

      const uniquePlannerElements = getUniquePlannerElements({
        plannerElementEvidences,
      });

      let loAchievedCount = 0;

      const totalLosCount = _.size(uniquePlannerElements);

      const popoverDataList = _.map(uniquePlannerElements, item => {
        const {
          isAchieved,
          plannerElementNode = {},
          id,
          gradeNames = [],
        } = item;
        const { label, metadata } = plannerElementNode;

        if (isAchieved) {
          loAchievedCount++;
        }

        return {
          loDescriptor: label,
          loDisplayName: metadata?.display_name,
          isAchieved,
          totalLosCount,
          id,
          gradeNames,
          isCustom: metadata?.isCustom,
        };
      });

      const studentName = getFormattedUserName({
        user: student,
      });

      return {
        popoverDataList,
        loAchievedCount,
        totalLosCount,
        studentName,
      };
    }

    case "POST_COUNT":
      switch (dataConfig?.postType) {
        case "allPostsCount":
          return _.get(project, "node.allPostsCount", 0);
        case "allPostsCountPortfolio": {
          return _.get(project, "node.totalEvidencesCount", 0);
        }
        default:
          return _.get(project, `node.posts.totalCount`, 0);
      }

    case "DEADLINE": {
      const { completedDeadlines = [], tasks: projectTasks = [] } = _.get(
        project,
        "node",
        {}
      );

      if (isNewDeadlineEnabled()) {
        return getDeadlinesValueV2({
          projectTasks,
        });
      } else {
        return getDeadlinesValue({
          completedDeadlines,
        });
      }
    }

    case "PROJECT_ACTIONS":
      return getProjectActionMenu({
        actionIds,
        actionsList,
        id: _.get(project, "node.id", ""),
        t,
        isCompleted: _.get(project, "node.isCompleted", false),
        isArchived: _.get(project, "node.isArchived", false),
        archivedById: _.get(project, "node.archivedBy.id", ""),
        disabled: disabled,
        projectGroupType: projectGroupType,
        reportStatus: _.get(project, "node.reportStatus", ""),
        isFinalReportSubmitted:
          _.size(_.get(project, "node.finalProjectReports", [])) > 0,
        updateProjectDetails,
        getPrintFile,
        updateProjectModalAndDialogueValue,
        nodeFields: _.get(project, "node.fields", []),
        goToRelativeRoute,
        courseId,
        getProjectFileUrl,
        getProjectFileFolderUrl,
        supervisors: _.get(project, "node.supervisors", []),
        students: _.get(project, "node.students", []),
        studentId: _.get(project, "node.student.id", ""),
        fileFolderConfig: _.get(actionsList, ["fileFolderConfig"], {}),
        projectCount:
          _.get(_.get(project, "node.projectCounts", {}), "projectsCount", 0) +
          _.get(
            _.get(project, "node.projectCounts", {}),
            "experiencesCount",
            0
          ),
        currentUserId,
        currentUserType,
        createdBy: _.get(project, "node.createdBy.id", ""),
        currentUserRole: role,
        studentName: getFormattedUserName({
          user: _.get(project, "node.student", {}),
        }),
        projectType: _.get(project, "node.type", ""),
        currentCurriculumProgramId,
        organizationId,
        portfolioDetails: _.get(project, "node.portfolio", {}),
        yearGroupName,
        projectGroupId,
        status: _.get(project, "node.status", ""),
        projectGroupCategoryType,
      });

    case "SUBJECT_LEVEL": {
      return getSubjectLevelTag({
        student: _.get(project, "node.students.0", {}),
      });
    }

    case "CRITERION_ASSESSMENT_RATING": {
      const tags = _.get(project, "node.students.0.courseMap.0.tags");
      const tag = _.find(tags, { type: "SUBJECT_LEVEL" });
      const subjectLevelId = getIsSubjectBasedGradingEnabled()
        ? _.get(
            project,
            "node.students.0.courseMap.0.subjectWiseLevel[0].level.id",
            ""
          )
        : tag?.id;
      const assessmentTool = _.find(assessmentTools, item =>
        _.some(item?.genericTags, item => _.isEqual(item?.id, subjectLevelId))
      );
      const criteria = _.get(assessmentTool, "criteria", []);
      const ibPYPElementRatings = _.filter(
        _.get(project, "node.ibPYPElementRatings", []),
        item => {
          return (
            !item?.academicCriteriaSet?.criteriaType ||
            item?.academicCriteriaSet?.criteriaType !==
              PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE
          );
        }
      );

      const { label } = getCriterionAssessmentRating({
        criteria,
        ibPYPElementRatings,
      });
      return label;
    }
    //IMPORTANT Use only for EE and TOK
    case "CRITERION_ASSESSMENT_RATING_V2": {
      const assessmentTool = _.find(assessmentTools, item =>
        //genericTags will be empty in EE tok
        _.isEmpty(item.genericTags)
      );
      const criteria = _.get(assessmentTool, "criteria", []);
      const ibPYPElementRatings = _.get(
        project,
        "node.ibPYPElementRatings",
        []
      );

      // after gradebook changes, ibPYPElementRatings has two objects
      // representing marks and grade, we want to use only marks one

      const elementRatingsForMarks = _.filter(ibPYPElementRatings, item => {
        const { academicCriteriaSet, academicCriteriaValue } = item;
        const { criteriaType } = academicCriteriaSet || {};

        if (
          (!academicCriteriaSet && !academicCriteriaValue) ||
          !_.includes(
            [PROJECT_FINAL_GRADE, PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE],
            criteriaType
          )
        ) {
          return true;
        }
        return false;
      });

      const { label } = getCriterionAssessmentRating({
        criteria,
        ibPYPElementRatings: elementRatingsForMarks,
      });
      return label ? label : "-";
    }

    case "MAP_SUPERVISOR_DROPDOWN":
    case "MAP_ADVISOR_DROPDOWN": {
      const isPortfolioInviteScreen = getIsProjectGroupTypePortfolio({
        projectGroupType,
        projectGroupCategoryType,
      });
      let supervisor = {};
      let studentId = "";
      let supervisorsList = [];

      if (isPortfolioInviteScreen) {
        supervisor = _.get(project, "node.staff", {});
        studentId = _.get(project, "node.student.id", "");
        supervisorsList = advisers;
      } else {
        supervisor = _.get(project, "node.supervisors[0]", {});
        studentId = _.get(project, "node.students[0].id", "");
        supervisorsList = orgSupervisorsStaff;
      }

      const allocatedSupervisor = [];

      if (!_.isEmpty(supervisor)) {
        const {
          firstName,
          lastName,
          middleName,
          id,
          profileImage,
        } = supervisor;
        allocatedSupervisor.push({
          firstName,
          lastName,
          value: id,
          profileImage: profileImage,
          id,
          middleName,
        });
      }

      return {
        allocatedSupervisor,
        supervisorsList,
        projectGroupId,
        studentId,
        id: _.get(project, "node.id"),
      };
    }

    case "RESTORE_PROJECT": {
      const deletedBy = _.get(project, "node.deletedBy.id", "");
      const projectId = _.get(project, "node.id", "");
      //logic to check if any of the student is already present in active projects group then disable restore
      const clashingStudents = findMappedCollaborators(
        _.map(project.node.studentCollaborators, item => item.student),
        allActiveProjectMappedStudents
      );
      const isButtonDisabled =
        disabled ||
        (_.isEqual(role, ROLE_STUDENT) &&
          !_.isEqual(deletedBy, currentUserId)) ||
        !_.isEmpty(clashingStudents);
      const buttonProps = {
        type: "inline",
        variant: "progressive",
        style: {
          textDecoration: "none",
          paddingLeft: 0,
        },
        disabled: isButtonDisabled,
      };

      const dialogueConfig = _.get(dataConfig, "dialogueConfig", {});
      const tooltipConfig = _.get(dataConfig, "tooltipConfig", "");
      const showIcon = _.get(dataConfig, "showIcon", false);
      const iconConfig = _.get(dataConfig, "iconConfig", {});
      const { title: dialogueTitle, body: dialogueBody } = dialogueConfig;
      const {
        value: tooltipValue = "",
        label: tooltipLabel = "",
      } = tooltipConfig;

      const nodeFields = _.get(project, "node.fields", []);
      const title = _.find(nodeFields, { uid: "title" });

      return {
        label: t("common:restore"),
        buttonProps,
        showIcon,
        iconConfig,
        clashingStudents,
        clickHandler: () => {
          updateProjectModalAndDialogueValue({
            projectId,
            displayDialogueBox: true,
            dialogueType: "RESTORE",
            dialogueDetails: {
              title: t(dialogueTitle),
              body: t(dialogueBody, {
                title: _.get(title, "value", ""),
              }),
            },
          });
        },
        showTooltip: isButtonDisabled,
        tooltip: t(tooltipValue, {
          label: t(tooltipLabel),
        }),
      };
    }

    case "DELETED_BY": {
      const deletedBy = _.get(project, "node.deletedBy", {});
      return {
        id: _.get(deletedBy, "id", ""),
        name: getFormattedUserName({
          user: deletedBy,
        }),
        type: _.get(deletedBy, "type", ""),
        alertTypes: _.get(deletedBy, "alertTypes", []),
      };
    }

    case "TOTAL_MARKS": {
      const criteriaValues = _.filter(
        _.get(project, "node.ibPYPElementRatings", []),
        ibPYPElementRating =>
          !_.isEmpty(ibPYPElementRating?.ibPYPElementId) &&
          _.isEqual(
            "PROJECT_CRITERIA_GRADE",
            _.get(ibPYPElementRating, "academicCriteriaSet.criteriaType", "")
          )
      );

      const { totalScore, grandTotal, isCriteriaValuesEmpty } = getTotalScore({
        criteria,
        criteriaValues,
      });

      return isCriteriaValuesEmpty ? null : `${totalScore}/${grandTotal}`;
    }

    case "FINAL_GRADE": {
      const ibPYPElementRatings = _.get(
        project,
        "node.ibPYPElementRatings",
        []
      );

      return _.find(ibPYPElementRatings, {
        academicCriteriaSet: {
          criteriaType: PROJECT_FINAL_GRADE,
        },
        ibPYPElementId: projectGroupId,
      })?.value;
    }

    default:
      return {};
  }
};

export const getStudentPortfolioFeedDataMemoized = _.memoize(
  params => getStudentPortfolioFeedData(params),
  params => {
    const {
      studentPortfolioDetails,
      columnConfig,
      studentNameOrderBy,
    } = params;
    return JSON.stringify({
      studentPortfolioDetails,
      columnConfig,
      studentNameOrderBy,
    });
  }
);

export const getStudentPortfolioFeedData = props => {
  const { studentPortfolioDetails, columnsConfig, ...rest } = props;

  return _.map(studentPortfolioDetails, portfolio => {
    return _.reduce(
      columnsConfig,
      (result, columnConfig) => {
        result[columnConfig.id] = getColumnData({
          project: portfolio,
          ...rest,
          ...columnConfig,
        });
        return result;
      },
      {}
    );
  });
};

export const getAchievedLosList = ({ casInsightDetails }) => {
  const achievedLosList = [0, 0, 0, 0, 0, 0, 0];

  _.map(casInsightDetails, edge => {
    const eachInsight = _.get(edge, "node", {});
    const plannerElementEvidences = _.get(
      eachInsight,
      "plannerElementEvidences",
      null
    );
    _.map(plannerElementEvidences, eachPlannerElement => {
      const status = _.get(eachPlannerElement, "isAchieved", false);
      const displaySequence = _.get(
        eachPlannerElement,
        "plannerElementNode.displaySequence",
        {}
      );
      if (status) {
        achievedLosList[displaySequence - 1]++;
      }
    });
  });
  return achievedLosList;
};

export const getCasInsightsFeedData = props => {
  const { casInsightDetails } = props;
  const feedData = _.map(casInsightDetails, edge => {
    const eachInsight = _.get(edge, "node", {});
    const achievedPlannerElements = _.get(
      eachInsight,
      "achievedPlannerElements",
      null
    );
    const plannerElementEvidences = _.get(
      eachInsight,
      "plannerElementEvidences",
      null
    );

    let losAchieved = 0;
    let tooltipArray = [];

    // Organizing sub column data and sorting Planner Element array
    const getSubColumnData = plannerElementEvidences => {
      const subColData = _.map(plannerElementEvidences, eachPlannerElement => {
        const projectTitles = _.map(
          _.get(eachPlannerElement, "projects.edges", []),
          eachProject => {
            return _.get(eachProject, "node.title.value");
          }
        );
        const status = _.get(eachPlannerElement, "isAchieved", false);
        if (status) {
          losAchieved++;
          tooltipArray = [
            ...tooltipArray,
            _.get(eachPlannerElement, "plannerElementNode.label", ""),
          ];
        }

        return {
          portfolioId: _.get(eachInsight, "id", ""),
          plannerElementNode: _.get(
            eachPlannerElement,
            "plannerElementNode",
            {}
          ),
          evidenceCount: _.get(eachPlannerElement, "evidence.totalCount", 0),
          projectsList: _.get(eachPlannerElement, "projects.edges", []),
          status,
          addressedCount: _.get(eachPlannerElement, "projects.totalCount", 0),
          projectTitles,
        };
      });
      return _.sortBy(subColData, eachSubCol => {
        return _.get(eachSubCol, "plannerElementNode.displaySequence", "");
      });
    };

    return {
      // Student Name Details
      studentName: getFormattedUserName({
        user: _.get(eachInsight, "student", {}),
        showStudentUID: true,
      }),
      imageUrl: _.get(eachInsight, "student.profileImage", ""),

      // Total achieved LO's count
      achievedLosCount: _.get(achievedPlannerElements, "totalCount", 0),

      // Tagged Count Evidence Count and Status
      plannerElementDetails: getSubColumnData(plannerElementEvidences),
      losAchieved,
      tooltipArray,

      portfolioId: _.get(eachInsight, "id", ""),
    };
  });
  return feedData;
};

export const getCasInsightsColumnData = props => {
  const { columnInfo } = props;
  const columnData = _.map(columnInfo, eachPlannerElement => {
    return {
      ..._.get(eachPlannerElement, "plannerElementNode", {}),
      subColumn: [
        "common:num_of_times_tagged",
        "common:num_of_times_evidence_collected",
        "common:status",
      ],
    };
  });

  return _.sortBy(columnData, eachColumn => {
    return _.get(eachColumn, "displaySequence", "");
  });
};

export const getProjectGroupFeedDataMemoized = _.memoize(
  params => getProjectGroupFeedData(params),
  params => {
    const {
      projects = [],
      template,
      deadlines = [],
      columnsConfig,
      assessmentTools,
    } = params;
    const { columnList = {}, tableConfig = {}, actionsList = {} } = _.get(
      template,
      "body",
      {}
    );
    return JSON.stringify({
      projects,
      actionsList,
      columnList,
      tableConfig,
      deadlines,
      columnsConfig,
      assessmentTools,
    });
  }
);

export const getProjectGroupFeedData = props => {
  const { columnsConfig, projects, ...rest } = props;
  return _.map(projects, project => {
    return _.reduce(
      columnsConfig,
      (result, columnConfig) => {
        result[columnConfig.id] = getColumnData({
          project,
          ...rest,
          //reason why we are pre-processing config here is because here we want to update config based on
          //subject level of each student. And subject level or each student is only accessible here. So, pre-processing here.
          ...getUpdatedConfig({
            fieldConfig: _.cloneDeep(columnConfig),
            subjectLevelTag: getSubjectLevelTag({
              student: _.get(project, "node.students.0", {}),
            }),
            projectFieldData: _.get(project, "node.fields", []),
          }),
        });
        if (!_.isEmpty(result?.restore_project)) {
          const deletedById = _.get(project, "node.deletedBy.id", "");
          const currentRole = _.get(rest, "role", "");
          const currentUserId = _.get(rest, "currentUserId", "");
          result.isCheckboxDisabled =
            _.isEqual(currentRole, ROLE_STUDENT) &&
            !_.isEqual(deletedById, currentUserId);
        }
        if (_.get(project, "node.isArchived", false)) {
          result.isCheckboxDisabled = !_.get(
            rest,
            "isPortfolioDownloadModal",
            false
          );
          result.isArchived = true;
        }
        return result;
      },
      {}
    );
  });
};

// Creating feedData using projectGroupStudents or projectGroupSupervisors (denoted as "user")

const getUsersActionsDetails = ({
  key,
  action,
  id,
  projectGroupId,
  t,
  currentSupervisorDetails,
  updateProjectModalAndDialogueValue,

  currentStudentDetails,
  user,
  updateStaffApprovalStatus,
  projectGroupType,
  disabled,
  triggerCasExternalInviteEmail,
  copyCasExternalInviteLink,
  toggleLoader = () => {},
  projectGroupCategoryType,
}) => {
  const {
    optionLabel,
    actionType,
    iconType,
    buttonVariant,
    entityType: actionEntityType,
    headerTitle,
    supervisorType,
  } = getUpdatedAction({ action, t, actionId: key });

  const isProjectGroupTypePortfolio = getIsProjectGroupTypePortfolio({
    projectGroupType,
    projectGroupCategoryType,
  });

  switch (actionType) {
    case "EDIT_STUDENTS_SUPERVISING":
    case "EDIT_STUDENTS_ADVISING": {
      let disabledAction =
        _.get(currentSupervisorDetails, "isArchived", false) &&
        _.size(_.get(user, "node.projects")) == 0;
      if (isProjectGroupTypePortfolio) {
        disabledAction =
          _.get(currentSupervisorDetails, "isArchived", false) &&
          _.size(_.get(user, "node.studentProjectPortfolios")) == 0;
      }

      return {
        key,
        disabled: disabledAction || disabled,
        label: optionLabel,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            projectGroupId,
            modalType: "EDIT_STUDENT_SUPERVISING_OR_ADVISING",
            displayModal: "true",
            modalDetails: {
              currentSupervisorDetails,
              headerTitle: optionLabel,
            },
          }),
      };
    }
    case "EDIT_EXPERIENCES_SUPERVISING":
    case "EDIT_ACTIVITIES_SUPERVISING": {
      const totalEntitiesCount = _.size(_.get(user, "node.projects", []));
      return {
        key,
        label: optionLabel,
        disabled: _.isEqual(totalEntitiesCount, 0) || disabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            projectGroupId,
            modalType: "EDIT_ENTITIES_SUPERVISING",
            displayModal: "true",
            modalDetails: {
              totalEntitiesCount,
              entities: _.get(user, "node.projects", []),
              entityType: actionEntityType,
              userDetails: currentSupervisorDetails,
              headerTitle,
            },
          }),
      };
    }

    case "EDIT_PROJECTS_SUPERVISING": {
      const totalEntitiesCount = _.size(_.get(user, "node.projects", []));
      return {
        key,
        label: optionLabel,
        disabled: totalEntitiesCount == 0 || disabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            projectGroupId,
            modalType: "EDIT_ENTITIES_SUPERVISING",
            displayModal: "true",
            modalDetails: {
              totalEntitiesCount,
              entities: _.get(user, "node.projects", []),
              entityType: "projects",
              userDetails: currentSupervisorDetails,
              headerTitle: t("project:edit_projects_supervising"),
            },
          }),
      };
    }

    case "DELETE_SUPERVISOR": {
      const supervisorName = getFormattedUserName({
        user: currentSupervisorDetails,
      });

      const bodyText =
        supervisorType === PROJECT_SUPERVISOR_TYPE_EXTERNAL
          ? t("project:remove_invited_external_supervisor_modal_body", {
              supervisorName,
            })
          : isProjectGroupTypePortfolio
          ? t(
              "project:remove_invited_portfolio_supervisor_modal_body_with_label",
              {
                supervisorName,
                label: t(
                  PORTFOLIO_INSIGHTS_PROJECT_GROUP_TYPE_MAPPING[
                    projectGroupType
                  ]?.projectLabelPlural
                ),
                action:
                  projectGroupType === PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT
                    ? t("project:mentoring")
                    : t("common:supervising"),
              }
            )
          : t("project:remove_invited_supervisor_modal_body", {
              supervisorName,
            });

      return {
        key,
        label: optionLabel,
        isDestructive: true,
        disabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            projectGroupId,
            displayDialogueBox: true,
            dialogueType: "REMOVE",
            successToastDetails: {
              msg: "toastMsgs:user_successfully_removed_with_exclamation",
              locale_params: [
                { key: "user", value: supervisorName, isPlainText: true },
              ],
            },
            dialogueDetails: {
              title: t("common:remove_subject_label", {
                label: supervisorName,
              }),
              body: bodyText,
            },
          }),
      };
    }
    case "DELETE_STUDENT": {
      const studentName = getFormattedUserName({
        user: currentStudentDetails,
      });
      return {
        key,
        id,
        iconType,
        buttonVariant,
        label: optionLabel,
        disabled,
        isDestructive: true,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            displayDialogueBox: true,
            dialogueType: "REMOVE",
            successToastDetails: {
              msg: "toastMsgs:user_successfully_removed_with_exclamation",
              locale_params: [
                { key: "user", value: studentName, isPlainText: true },
              ],
            },
            dialogueDetails: {
              title: t("common:remove_subject_label", {
                label: studentName,
              }),

              body: t("common:proceed_confirm"),
            },
          }),
      };
    }
    case "EDIT_SUPERVISOR": {
      return {
        key,
        id,
        label: optionLabel,
        disabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            modalType: "EDIT_SUPERVISOR",
            displayModal: true,
            modalDetails: {
              studentDetails: currentStudentDetails,
              currentProjectInfo: _.get(
                currentStudentDetails,
                "projects[0]",
                {}
              ),
              headerTitle: optionLabel,
            },
          }),
      };
    }
    case "REJECT_INVITE": {
      const supervisorName = getFormattedUserName({
        user: currentSupervisorDetails,
      });
      return {
        key,
        label: optionLabel,
        isDestructive: true,
        disabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            projectGroupId,
            displayDialogueBox: true,
            dialogueType: "REMOVE",
            dialogueDetails: {
              title: t("common:reject_with_label_raw", {
                label: supervisorName,
              }),
              body: t("project:reject_invited_supervisor_modal_body", {
                supervisorName,
                entity: t("project:supervisor"),
              }),
              actionType: "REJECT",
            },
          }),
      };
    }
    case "APPROVE_INVITE": {
      return {
        key,
        label: optionLabel,
        disabled:
          _.get(currentSupervisorDetails, "isArchived", false) || disabled,
        clickAction: () => {
          updateStaffApprovalStatus({
            supervisorIds: [id],
            approvalStatus: SUPERVISOR_APPROVAL_STATUS_APPROVED,
            projectGroupId: projectGroupId,
            projectGroupToSupervisorMappingId: _.get(user, "node.id", ""),
            extraParams: {
              type: isProjectGroupTypePortfolio
                ? "invite_supervisor_screen_portfolio"
                : "invite_supervisor_screen_saa",
              actionType: "approve",
              getProjectGroupSupervisorVars: {
                projectGroupId,
              },
            },
          });
        },
      };
    }
    case "EDIT_EXTERNAL_SUPERVISOR_DETAILS": {
      return {
        key,
        label: optionLabel,
        disabled:
          _.get(currentSupervisorDetails, "isArchived", false) || disabled,
        clickAction: () =>
          updateProjectModalAndDialogueValue({
            id,
            modalType: "EDIT_EXTERNAL_SUPERVISOR_DETAILS",
            displayModal: "true",
            modalDetails: {
              mode: "EDIT",
              userDetails: {
                organization: _.get(
                  currentSupervisorDetails,
                  "otherDetails.organizationName",
                  ""
                ),
                contact: _.get(
                  currentSupervisorDetails,
                  "otherDetails.phoneNumber",
                  ""
                ),
                approvalStatus: _.get(user, "node.approvalStatus", ""),
                ...currentSupervisorDetails,
              },
            },
          }),
      };
    }
    case "RE_SHARE_EXTERNAL_SUPERVISOR_INVITE_LINK": {
      return {
        key,
        label: optionLabel,
        disabled:
          _.get(currentSupervisorDetails, "isArchived", false) || disabled,
        clickAction: async () => {
          toggleLoader(true);
          await triggerCasExternalInviteEmail({
            projectGroupId,
            supervisorId: _.get(currentSupervisorDetails, "id"),
            supervisorEmail: _.get(currentSupervisorDetails, "email"),
          });
          toggleLoader(false);
        },
      };
    }
    case "COPY_EXTERNAL_SUPERVISOR_INVITE_LINK": {
      return {
        key,
        label: optionLabel,
        disabled:
          _.get(currentSupervisorDetails, "isArchived", false) || disabled,
        clickAction: async () => {
          toggleLoader(true);
          await copyCasExternalInviteLink({
            supervisorId: _.get(currentSupervisorDetails, "id"),
          });
          toggleLoader(false);
        },
      };
    }
  }
};

export const getUsersActionsMenu = props => {
  const { actionIds, actionsList, ...rest } = props;
  return _.reduce(
    actionIds,
    (result, key) => {
      const action = _.get(actionsList, `${key}`, {});
      result.push(
        getUsersActionsDetails({
          key,
          action,
          ...rest,
        })
      );
      return result;
    },
    []
  );
};

const getColumnDataForUsers = ({
  user,
  dataConfig,
  uiType,
  studentNameOrderBy,
  id,
  subjects,
  projectGroupType,
  orgSupervisorsStaff,
  projectGroupId,
  actionIds,
  actionsList,
  t,
  updateProjectModalAndDialogueValue,
  inviteScreenType,
  updateStaffApprovalStatus,
  disabled,
  triggerCasExternalInviteEmail,
  copyCasExternalInviteLink,
  toggleLoader,
  projectGroupCategoryType,
}) => {
  const { dataType = "", entityType } = dataConfig;

  const getFieldValue = ({ fieldType, fields }) => {
    const value = _.get(
      _.find(fields, field => field?.uid == fieldType),
      "value",
      ""
    );
    return value;
  };

  const currentStudentDetails = _.get(user, "node.student", {});

  const currentSupervisorDetails = _.get(user, "node.staff", {});

  const isProjectGroupTypePortfolio = getIsProjectGroupTypePortfolio({
    projectGroupType,
    projectGroupCategoryType,
  });

  let rowId = "";
  let studentId = "";

  rowId = isProjectGroupTypePortfolio
    ? _.get(currentStudentDetails, "studentProjectPortfolio.id")
    : _.get(
        currentStudentDetails,
        "projects[0].id",
        _.get(currentStudentDetails, "id")
      );

  studentId = _.get(currentStudentDetails, "id", "");

  switch (inviteScreenType) {
    case "student":
      {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_COMMUNITY:
            {
              rowId = _.get(currentStudentDetails, "id", "");
            }
            break;
          case PROJECT_GROUP_TYPE_PERSONAL:
          case PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION:
          case PROJECT_GROUP_TYPE_DP_TOK_ESSAY:
          case PROJECT_GROUP_TYPE_DP_EE:
          case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT: {
            rowId = _.get(currentStudentDetails, "projects[0].id", "");
            break;
          }
          default: {
            switch (projectGroupCategoryType) {
              case PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO: {
                if (
                  // REMOVE: this condition once SAA portfolio revamp is live for all
                  projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON &&
                  !ACLStore.can(SAA_PORTFOLIO_REVAMP_PERM)
                ) {
                  rowId = _.get(currentStudentDetails, "id", "");
                } else {
                  rowId = _.get(
                    currentStudentDetails,
                    "studentProjectPortfolio.id"
                  );
                }
                break;
              }
              default: {
                rowId = _.get(currentStudentDetails, "projects[0].id", "");
              }
            }
          }
        }
      }
      break;

    case "supervisor":
    case "externalSupervisor": {
      rowId = _.get(currentSupervisorDetails, "id");
      studentId = _.get(currentSupervisorDetails, "id");
    }
  }
  switch (dataType) {
    case "ID":
      return rowId;

    case "STUDENT_ID":
      return studentId;

    case "SUPERVISOR_ID":
      return _.get(currentSupervisorDetails, "id");

    case "PROJECT_STUDENT_NAME_WITH_AVATAR":
    case "PORTFOLIO_STUDENT_NAME_WITH_AVATAR": {
      switch (uiType) {
        default:
        case "NAME_WITH_AVATAR":
          return {
            id: _.get(currentStudentDetails, "id", null),
            name: getFormattedUserName({
              user: currentStudentDetails,
              showStudentUID: true,
              orderBy: studentNameOrderBy,
            }),
            profileImage: _.get(currentStudentDetails, "profileImage", null),
            studentAlertsConfig: {
              alertTypes: _.get(currentStudentDetails, "alertTypes"),
              studentId: _.get(currentStudentDetails, "id", null),
            },
          };
      }
    }
    case "FIELD":
      {
        const { fieldType } = dataConfig;
        const fields = _.get(currentStudentDetails, "projects[0].fields", []);

        const value = getFieldValue({
          fieldType,
          fields,
        });

        switch (uiType) {
          case "TEXT_OR_DASH": {
            switch (id) {
              case "subject": {
                return _.get(
                  _.find(subjects, subject => subject.id == value),
                  "name",
                  "-"
                );
              }
              case "subjectV2": {
                const selectedSubject = _.filter(subjects, subject => {
                  return _.includes(_.get(value, "[0]", []), subject.id);
                });

                const res = _.chain(selectedSubject)
                  .map("name")
                  .join(", ")
                  .value();
                return res;
              }
            }
            return value;
          }
        }
      }
      break;
    case "MAP_SUPERVISOR_DROPDOWN":
    case "MAP_ADVISOR_DROPDOWN": {
      let supervisor = {};
      let studentId = "";
      let supervisorsList = [];

      if (isProjectGroupTypePortfolio) {
        supervisor = _.get(
          currentStudentDetails,
          "studentProjectPortfolio.staff",
          {}
        );
        studentId = _.get(currentStudentDetails, "id", "");
        supervisorsList = orgSupervisorsStaff;
      } else {
        supervisor = _.get(
          currentStudentDetails,
          "projects[0].supervisors[0]",
          {}
        );
        studentId = _.get(currentStudentDetails, "id", "");
        supervisorsList = orgSupervisorsStaff;
      }

      const allocatedSupervisor = [];

      if (!_.isEmpty(supervisor)) {
        const {
          firstName,
          lastName,
          middleName,
          id,
          profileImage,
          isArchived,
          isArchivedV2,
        } = supervisor;
        allocatedSupervisor.push({
          firstName,
          lastName,
          value: id,
          profileImage,
          id,
          isArchived,
          isArchivedV2,
          middleName,
        });
      }

      return {
        allocatedSupervisor,
        supervisorsList,
        projectGroupId,
        studentId,
        id: isProjectGroupTypePortfolio
          ? _.get(currentStudentDetails, "studentProjectPortfolio.id")
          : _.get(currentStudentDetails, "projects[0].id"),
      };
    }
    case "PROJECT_SUPERVISOR_NAME_WITH_AVATAR": {
      const isPendingApproval = _.isEqual(
        _.get(user, "node.approvalStatus", ""),
        SUPERVISOR_APPROVAL_STATUS_PENDING
      );
      const isArchived = getUserArchivalStatus(currentSupervisorDetails);

      const isInviteScreenTypeSupervisor = _.includes(
        ["supervisor", "externalSupervisor"],
        inviteScreenType
      );

      const getInviteScreenSupervisorSubtext = () => {
        if (isInviteScreenTypeSupervisor && isArchived && isPendingApproval)
          return `${t("common:archived")} ${t("project:approval_pending")}`;
        else if (isArchived) return t("common:archived");
        else if (isInviteScreenTypeSupervisor && isPendingApproval)
          return t("project:approval_pending");
        else return "";
      };

      return {
        id: _.get(currentSupervisorDetails, `id`, null),
        name: getFormattedUserName({
          user: currentSupervisorDetails,
        }),
        profileImage: _.get(currentSupervisorDetails, `profileImage`, null),
        subText: getInviteScreenSupervisorSubtext(),
        subTextVariant: isArchived ? "warningV2" : "warning",
        maxWidth: "200px",
      };
    }
    case "MAP_STUDENTS": {
      return {
        totalProjectsCountSupervising: _.size(_.get(user, "node.projects", [])),
        totalPortfoliosCountAdvising: _.size(
          _.get(user, "node.studentProjectPortfolios", [])
        ),
        currentStaffId: _.get(currentSupervisorDetails, "id"),
        currentProjectsSupervising: _.get(user, "node.projects", []),
        currentPortfoliosAdvising: _.get(
          user,
          "node.studentProjectPortfolios",
          []
        ),
        currentSupervisorDetails: {
          ...currentSupervisorDetails,
          approvalStatus: _.get(user, "node.approvalStatus", ""),
        },
      };
    }
    case "EXPERIENCES_SUPERVISING":
    case "PROJECTS_SUPERVISING":
    case "ACTIVITIES_SUPERVISING": {
      return {
        totalEntitiesCount: _.size(_.get(user, "node.projects", [])),
        entities: _.get(user, "node.projects", []),
        entityType,
        currentUserDetails: currentSupervisorDetails,
      };
    }

    case "STUDENT_ACTIVITIES": {
      return {
        totalEntitiesCount: _.size(
          _.get(currentStudentDetails, "projects", [])
        ),
        entities: _.get(currentStudentDetails, "projects", []),
        entityType,
        currentUserDetails: currentStudentDetails,
      };
    }

    case "MAP_SUPERVISORS_MULTIPLE": {
      return {
        currentStudentDetails,
      };
    }
    case "SUPERVISOR_ACTIONS": {
      return getUsersActionsMenu({
        actionIds,
        actionsList,
        id: _.get(currentSupervisorDetails, "id", ""),
        projectGroupId,
        t,
        updateProjectModalAndDialogueValue,
        currentSupervisorDetails,
        user,
        entityType,
        updateStaffApprovalStatus,
        projectGroupType,
        disabled,
        triggerCasExternalInviteEmail,
        copyCasExternalInviteLink,
        toggleLoader,
        projectGroupCategoryType,
      });
    }
    case "SUTUDENT_ACTIONS": {
      return getUsersActionsMenu({
        actionIds,
        actionsList,
        id: _.get(currentStudentDetails, "id", ""),
        projectGroupId,
        t,
        updateProjectModalAndDialogueValue,
        currentStudentDetails,
        disabled,
        projectGroupCategoryType,
      });
    }
    case "REMOVE_STUDENT": {
      return _.get(
        getUsersActionsMenu({
          actionIds,
          actionsList,
          id: _.get(currentStudentDetails, "id", ""),
          projectGroupId,
          t,
          updateProjectModalAndDialogueValue,
          currentStudentDetails,
          projectGroupCategoryType,
        }),
        "0",
        {}
      );
    }
    case "STUDENTS_COLLABORATING_WITH": {
      const studentProjects = _.get(currentStudentDetails, "projects", []);

      const collaboratingStudentsList = [];

      _.forEach(studentProjects, project => {
        const students = _.reduce(
          _.get(project, "students", []),
          (res, student) => {
            if (student.id != _.get(currentStudentDetails, "id", "")) {
              res.push(student);
            }
            return res;
          },
          []
        );
        collaboratingStudentsList.push(...students);
      });

      const uniqStudentsListOfNames = _.map(
        _.uniqBy(collaboratingStudentsList, "id"),
        item => {
          return getFormattedUserName({
            user: item,
          });
        }
      );

      let label = t("project:no_collaborators");
      let labelVariant = "subtle";

      if (_.size(studentProjects) == 0) {
        label = t("project:project_not_created");
      }
      if (_.size(uniqStudentsListOfNames) != 0) {
        labelVariant = "";
        label = _.join(
          _.slice(uniqStudentsListOfNames, 0, 2),

          ", "
        );
      }
      const tailingUsers = _.slice(uniqStudentsListOfNames, 2);

      return {
        label,
        labelVariant,
        tailingUsers,
      };
    }
    case "PROJECT_SUPERVISOR_CURRICULUM": {
      const staffCurriculums = _.map(
        _.get(currentSupervisorDetails, "curriculumPrograms", []),
        item => item.acronym
      );
      return _.join(staffCurriculums, ", ");
    }
    case "INVITED_BY_USERS": {
      const supervisors = _.get(user, "node.invitedBy", []);
      const firstSupervisorInList = _.first(supervisors);
      const type = _.get(firstSupervisorInList, "type", null);
      const alertTypes = _.get(firstSupervisorInList, "alertTypes", null);
      return {
        emptyFieldLabel: _.get(dataConfig, "emptyFieldLabel", ""),
        isUsersListEmpty: _.isEmpty(supervisors),
        firstProfileName: getFormattedUserName({
          user: firstSupervisorInList,
        }),
        firstProfileImage: _.get(firstSupervisorInList, "profileImage", null),
        firstProfileId: _.get(firstSupervisorInList, "id", null),
        tailingUsers: _.map(_.tail(supervisors), supervisor =>
          getFormattedUserName({
            user: supervisor,
          })
        ),
        alertTypes,
        type,
      };
    }
    case "APPROVE_REJECT_STAFF_ACTIONS": {
      return {
        projectGroupSupervisorMapId: _.get(user, "node.id", ""),
        isArchived: getUserArchivalStatus(currentSupervisorDetails),
      };
    }
    case "EXTERNAL_SUPERVISOR_DETAILS": {
      switch (id) {
        case "external_supervisor_email": {
          return _.get(currentSupervisorDetails, "email", "-");
        }
        case "external_supervisor_organization": {
          return _.get(
            currentSupervisorDetails,
            "otherDetails.organizationName",
            "-"
          );
        }
        case "external_supervisor_contact_number": {
          return _.get(
            currentSupervisorDetails,
            "otherDetails.phoneNumber",
            "-"
          );
        }
        default:
          return "-";
      }
    }
    case "EDIT_EXTERNAL_SUPERVISOR_DETAILS": {
      return currentSupervisorDetails;
    }
  }
};

export const getProjectGroupUsersFeedData = props => {
  const { columnsConfig, users, userType, ...rest } = props;

  return _.map(users, user => {
    const columnData = _.reduce(
      columnsConfig,
      (result, columnConfig) => {
        result[columnConfig.id] = getColumnDataForUsers({
          user,
          ...getUpdatedConfig({
            fieldConfig: _.cloneDeep(columnConfig),
            supervisorApprovalStatus: _.get(user, "node.approvalStatus", ""),
          }),
          ...rest,
        });
        return result;
      },
      {}
    );
    return {
      ...columnData,
      isArchived: getUserArchivalStatus(_.get(user, `node.${userType}`, {})),
    };
  });
};

export const getSortMenuOptions = ({ type, entity }) => {
  switch (type) {
    case "name": {
      const nameSortList = [
        {
          key: "FIRST_NAME_AZ",
          sortEntity: `${entity}_FIRST_NAME`,
          direction: "ASC",
          label: "first_name_az",
          nameType: "FIRST_NAME",
        },
        {
          key: "FIRST_NAME_ZA",
          sortEntity: `${entity}_FIRST_NAME`,
          direction: "DESC",
          label: "first_name_za",
          nameType: "FIRST_NAME",
        },
        {
          key: "MIDDLE_NAME_AZ",
          sortEntity: `${entity}_MIDDLE_NAME`,
          direction: "ASC",
          label: "middle_name_az",
          nameType: "MIDDLE_NAME",
        },
        {
          key: "MIDDLE_NAME_ZA",
          sortEntity: `${entity}_MIDDLE_NAME`,
          direction: "DESC",
          label: "middle_name_za",
          nameType: "MIDDLE_NAME",
        },
        {
          key: "LAST_NAME_AZ",
          sortEntity: `${entity}_LAST_NAME`,
          direction: "ASC",
          label: "last_name_az",
          nameType: "LAST_NAME",
        },
        {
          key: "LAST_NAME_ZA",
          sortEntity: `${entity}_LAST_NAME`,
          direction: "DESC",
          label: "last_name_za",
          nameType: "LAST_NAME",
        },
        {
          key: "FULL_NAME_AZ",
          sortEntity: `${entity}_FULL_NAME`,
          direction: "ASC",
          label: "full_name_az",
          nameType: "FULL_NAME",
        },
        {
          key: "FULL_NAME_ZA",
          sortEntity: `${entity}_FULL_NAME`,
          direction: "DESC",
          label: "full_name_za",
          nameType: "FULL_NAME",
        },
      ];
      return getUserSortOptions({
        sortOptions: nameSortList,
        type: _.isEqual(entity, "STUDENT") ? "student" : "staff",
        keyToMap: "nameType",
      });
    }
    default:
      return [];
  }
};

export const updateGuidingQuestionsInTemplate = ({
  template,
  guidingQuestions,
  reflectionSubmissionMode,
}) => {
  const { body } = template;
  const nodes = { ...body.nodes };
  const field_list = { ...body.field_list };
  let guidingQuestionFields = [];

  guidingQuestionFields = _.map(guidingQuestions, question => {
    const fieldId = "guidingQuestion_" + question.id;
    const newField = {
      ...field_list.guidingQuestions,
      id: fieldId,
      config: {
        isDynamic: true,
        label: question.question,
        viewLabel: question.question,
        printLabel: question.question,
      },
      skipLocalisation: true,
    };

    return newField;
  });

  const guidingFieldIds = _.map(guidingQuestionFields, g => g.id);
  const guidingQuestionNode = {
    ...nodes.guidingQuestions,
    fieldIds: guidingFieldIds,
  };

  let guidingQuestionItemNode = {
    ...nodes.guidingQuestions_item,
  };

  if (_.isEqual(reflectionSubmissionMode, SUBMISSION_MODE_INDIVIDUAL)) {
    guidingQuestionItemNode = {
      ...guidingQuestionItemNode,
      fieldIds: guidingFieldIds,
    };
  }

  const guidingQuestionFieldsById = _.reduce(
    guidingQuestionFields,
    (result, questionField) => {
      result[questionField.id] = questionField;
      return result;
    },
    {}
  );

  const updatedTemplate = {
    ...template,
    body: {
      ...body,
      nodes: {
        ...nodes,
        guidingQuestions: guidingQuestionNode,
        guidingQuestions_item: guidingQuestionItemNode,
      },
      field_list: {
        ...field_list,
        ...guidingQuestionFieldsById,
      },
    },
  };
  return updatedTemplate;
};

export const getCanItemBeStarred = ({ projectGroupType }) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_PERSONAL:
    case PROJECT_GROUP_TYPE_COMMUNITY:
      return true;
    default:
      return false;
  }
};

export const getUpdatedFields = ({ fields, fieldsToRemove }) => {
  return _.filter(fields, field => _.indexOf(fieldsToRemove, field) < 0);
};

export const getCASProjectDetailsFilter = {
  uids: ["title", "dateDuration", "CASStrands", "image"],
};

export const getTemplateWithRemovedFields = ({
  template,
  nodesWithFieldsToRemove,
  summaryFieldsToRemove = [],
}) => {
  const { body } = template;
  const nodes = { ...body.nodes };
  const field_list = { ...body.field_list };
  const summary = { ...body.summary };
  let updatedSummary = summary;
  const updatedNodes = {};

  //removing fields from the specific node
  _.forEach(nodesWithFieldsToRemove, (nodeField, nodeId) => {
    updatedNodes[nodeId] = {
      ...nodes[nodeId],
      fieldIds: getUpdatedFields({
        fields: nodes[nodeId].fieldIds,
        fieldsToRemove: nodeField,
      }),
      mandatory: getUpdatedFields({
        fields: nodes[nodeId].mandatory || [],
        fieldsToRemove: nodeField,
      }),
    };
  });
  //removing fields from summary fields
  updatedSummary = getUpdatedFields({
    fields: updatedSummary,
    fieldsToRemove: summaryFieldsToRemove,
  });

  const updatedTemplate = {
    ...template,
    body: {
      ...body,
      nodes: {
        ...nodes,
        ...updatedNodes,
      },
      field_list: {
        ...field_list,
      },
      summary: updatedSummary,
    },
  };
  return updatedTemplate;
};

const getShouldRemoveDependentField = ({ dependencyField, dependentField }) => {
  switch (_.get(dependencyField, "uid", "")) {
    case "CASStrands": {
      const selectedStrands = _.get(
        dependencyField,
        "resolvedMinimalTree.nodes",
        []
      );

      switch (_.get(dependentField, "id", "")) {
        case "approachesCreativityDP_CAS":
          return _.find(
            selectedStrands,
            strand => _.get(strand, "metadata.subType", "") == "CREATIVITY"
          );
        case "approachesActivityDP_CAS":
          return _.find(
            selectedStrands,
            strand => _.get(strand, "metadata.subType", "") == "ACTIVITY"
          );

        default:
          return _.find(
            selectedStrands,
            strand => _.get(strand, "metadata.subType", "") == "SERVICE"
          );
      }
    }
    case "supervisorType": {
      const value = _.get(dependencyField, "value", "");

      if (_.isEqual(value, "INTERNAL")) {
        return _.includes(["internalSupervisor"], dependentField.id);
      } else if (_.isEqual(value, "EXTERNAL")) {
        return _.includes(
          [
            "supervisor",
            "supervisorOrganisation",
            "supervisorEmail",
            "supervisorPhone",
          ],
          dependentField.id
        );
      } else return false;
    }
    default:
      return isValidValue({
        value: _.get(dependencyField, "value", ""),
      });
  }
};

export const updateTemplateFieldsWithDependency = ({
  template,
  projectFieldData, //projectFieldData
}) => {
  const { body } = template;
  const field_list = { ...body.field_list };

  const summaryFieldsToRemove = [];
  //contains the node object with array of fields
  const parentNodeFieldsToRemove = {};

  //filtered out the dependent fields from the template field_List
  const dependentFields = _.filter(
    field_list,
    field => !_.isEmpty(_.get(field, "config.elementDependencyConfig", {}))
  );

  //created 2 array summaryfields to remove and nodes field to remove
  _.forEach(dependentFields, dependentField => {
    //fetch the dependency field and dependent parent node
    const {
      config: { elementDependencyConfig },
    } = dependentField;
    const dependentParentNodes = elementDependencyConfig.parentNodes;

    //fetch the value from the projectData fields of the dependency field
    const dependencyField = _.find(projectFieldData, {
      uid: elementDependencyConfig.field,
    });

    //added a key of dependent pareant node in the object
    _.forEach(dependentParentNodes, dependentParentNode => {
      if (!parentNodeFieldsToRemove[dependentParentNode]) {
        parentNodeFieldsToRemove[dependentParentNode] = [];
      }
    });

    const shouldRemoveDependentField = getShouldRemoveDependentField({
      dependencyField,
      dependentField,
    });

    //if falsy value than add the dependent field to both the array
    _.forEach(dependentParentNodes, dependentParentNode => {
      if (!shouldRemoveDependentField) {
        summaryFieldsToRemove.push(dependentField.id);
        parentNodeFieldsToRemove[dependentParentNode].push(dependentField.id);
      }
    });
  });

  return getTemplateWithRemovedFields({
    template,
    nodesWithFieldsToRemove: parentNodeFieldsToRemove,
    summaryFieldsToRemove,
  });
};

export const getRefinedProjectsAndExperiences = ({ data }) => {
  const refinedData = _.map(data, item => {
    const { fields } = item.node;

    const getField = params => {
      return _.find(fields, { ...params });
    };

    const casStrands = _.map(
      _.get(getField({ uid: "CASStrands" }), "resolvedMinimalTree.nodes", []),
      item => item.label
    ).join(", ");

    const title = _.get(getField({ uid: "title" }), "value", "");

    const dateDuration = getField({ uid: "dateDuration" });
    const date = `${formatDate({
      date: _.get(dateDuration, "value.startDate", ""),
      format: DATE_TIME_CONSTANTS.D_MMM_YYYY,
    })} - ${formatDate({
      date: _.get(dateDuration, "value.endDate", ""),
      format: DATE_TIME_CONSTANTS.D_MMM_YYYY,
    })}`;

    const image = _.get(getField({ uid: "image" }), "value");

    return { ..._.omit(item.node, "fields"), casStrands, title, date, image };
  });

  const projects = _.filter(refinedData, { type: "PROJECT" });
  const experiences = _.filter(refinedData, { type: "EXPERIENCE" });
  return [projects, experiences];
};

export const getNodeWithFieldsToRemove = ({ fieldsToRemove, nodes }) => {
  const nodesWithFieldsToRemove = {};
  _.forEach(nodes, (node, id) => {
    const fieldsToRemoveFromNode = _.intersection(
      node.fieldIds,
      fieldsToRemove
    );
    if (!_.isEmpty(fieldsToRemoveFromNode)) {
      nodesWithFieldsToRemove[id] = fieldsToRemoveFromNode;
    }
  });
  return nodesWithFieldsToRemove;
};

export const getFieldsToRemove = ({ removeFieldsWithValue }) => {
  const fieldsToRemove = [];
  _.forEach(removeFieldsWithValue, (value, field) => {
    if (_.size(value) <= 1) fieldsToRemove.push(field);
  });
  return fieldsToRemove;
};

export const getTemplateWithRemovedChildIds = ({
  template,
  childIdsToRemove,
}) => {
  const {
    body: { nodes },
  } = template;
  // checking all the nodes from body and filtering the childIds which is in the childIdsToRemove.
  const updatedNodes = _.reduce(
    nodes,
    (result, val, key) =>
      update(result, {
        [key]: {
          $set: update(val, {
            //filtering childIds
            childIds: childIds =>
              update(childIds || [], {
                $set: _.filter(
                  childIds,
                  childId => !_.includes(childIdsToRemove, childId)
                ),
              }),
          }),
        },
      }),
    {}
  );

  return update(template, {
    body: {
      nodes: { $set: updatedNodes },
    },
  });
};

export const projectAssessmentBulkDownload = ({
  projectGroup,
  projectIds,
  fileName,
}) => {
  return async (dispatch, getState) => {
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);
    try {
      const result = await client.query({
        query: getProjectAssessmentBulkDownloadQuery,
        variables: {
          id: projectGroup,
          projectIds,
          academicYearIds,
        },
        fetchPolicy: "network-only",
      });

      const projectAssessmentData = _.get(
        result,
        "data.node.assessmentCsvExport",
        []
      );
      return exportData({
        fileName,
        outputFormat: "XLSX",
        data: projectAssessmentData,
        fileType: "projectAssessment",
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      console.error(e);
      return null;
    }
  };
};

export const getOldCasExternalSupervisorDetails = ({
  supervisorFieldDetails = {},
  supervisorEmailFieldDetails = {},
  supervisorOrganisationFieldDetails = {},
  supervisorPhoneFieldDetails = {},
}) => {
  return {
    id: _.get(supervisorFieldDetails, "id", ""),
    firstName: _.get(supervisorFieldDetails, "value", ""),
    lastName: "",
    email: _.get(supervisorEmailFieldDetails, "value", ""),
    profileImage: null,
    isExternalOldData: true,
    otherDetails: {
      organizationName: _.get(supervisorOrganisationFieldDetails, "value", ""),
      phoneNumber: _.get(supervisorPhoneFieldDetails, "value", ""),
    },
  };
};

export const getProjectDetailsValueFromFieldKey = ({
  projectDetails = {},
  key,
  projectGroupType,
}) => {
  switch (key) {
    case "portfolioProjectType": {
      const { projectType } = projectDetails;
      if (projectType === "PROJECT") return ["PROJECT"];
      return [];
    }
    case "supervisor":
    case "projectSupervisors": {
      const { supervisorsList = [] } = projectDetails;

      if (
        _.isEqual(projectGroupType, PROJECT_GROUP_TYPE_DP_CAS) &&
        ACLStore.can("FeatureFlag:CASExternalSupervisor") &&
        _.isEqual(
          _.get(projectDetails, "supervisorTypeFieldDetails.value", ""),
          "EXTERNAL"
        ) &&
        !_.get(projectDetails, "isCasExternalPortingDone", false)
      ) {
        const externalSupervisorDetails = getOldCasExternalSupervisorDetails(
          projectDetails
        );
        return [
          ...(supervisorsList ? supervisorsList : []),
          externalSupervisorDetails,
        ];
      }

      return supervisorsList;
    }
    case "students": {
      const { studentsList = [] } = projectDetails;
      return studentsList;
    }
    case "projectCollaborators": {
      const { studentCollaborators = [], studentsList } = projectDetails;
      return [_.first(studentsList), ...studentCollaborators];
    }

    default:
      return null;
  }
};

export const updateProjectDetailsField = ({
  fieldUID,
  fieldValue,
  projectId,
  projectDetails,
  projectGroupId,
}) => {
  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());
    const {
      type: projectGroupType,
      category: projectGroupCategoryType,
    } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    switch (fieldUID) {
      case "portfolioProjectType":
        dispatch(
          updateProjectDetails({
            projectId,
            projectType: _.includes(fieldValue, "PROJECT")
              ? "PROJECT"
              : "EXPERIENCE",
          })
        );
        break;
      case "students":
        {
          const previousStudents = _.get(projectDetails, "studentsList", []);
          const currentStudents = fieldValue ?? [];
          dispatch(
            editProject({
              projectId,
              previousStudents,
              updatedStudents: currentStudents,
              isProjectWithMultipleSupervisors: true,
              extraParams: {
                type: "saa_project_and_header",
                queryVariables: {
                  projectInfoQueryVar: getProjectHeaderInfoVariables({
                    projectId,
                    projectGroupType,
                    academicYearId,
                    projectGroupCategoryType,
                  }),
                  projectDetailsQuerVars: {
                    id: projectId,
                    academicYearId,
                    studentProjectPortfolioFilter: {
                      projectGroupTypes: [projectGroupType],
                    },
                    completionStatusFilters: {
                      academicYearIds: [academicYearId],
                    },
                  },
                  projectStudentCollaboratorsForSplittingQueryVars: {
                    id: projectId,
                  },
                },
              },
            })
          );
        }
        break;
      case "projectCollaborators":
        {
          const previousStudentCollaborators = _.get(
            projectDetails,
            "studentCollaborators",
            []
          );
          const updatedStudentCollaborators = fieldValue ?? [];
          dispatch(
            editProject({
              projectId,
              previousStudentCollaborators,
              updatedStudentCollaborators,
              isProjectWithMultipleSupervisors: true,
              extraParams: {
                type: "cas_project_and_header",
                queryVariables: {
                  projectInfoQueryVar: getProjectHeaderInfoVariables({
                    projectId,
                    projectGroupType,
                    academicYearId,
                    projectGroupCategoryType,
                  }),
                  projectDetailsQuerVars: {
                    id: projectId,
                    academicYearId,
                    studentProjectPortfolioFilter: {
                      projectGroupTypes: [projectGroupType],
                    },
                    completionStatusFilters: {
                      academicYearIds: [academicYearId],
                    },
                  },
                  projectStudentCollaboratorsForSplittingQueryVars: {
                    id: projectId,
                  },
                },
              },
            })
          );
        }
        break;
      case "supervisor":
      case "projectSupervisors": {
        const previousSupervisor = _.get(projectDetails, "supervisorsList", []);

        // filter cas external old data entry
        const currentSupervisor = fieldValue
          ? _.filter(fieldValue, item => !item.isExternalOldData)
          : [];
        const hasOldExternalDataEntry = _.find(fieldValue, {
          isExternalOldData: true,
        });

        // will set isPortingDone to true when
        // 1. supervisorType is external
        // 2. isCasExternalPortingDone from projectDetails is false
        // 3. supervisorTypeFieldValue is set to external

        // all of the above means that there was an oldExternal entry shown before but in currentValue(fieldValue) it does not exist, hence is removed

        if (
          _.isEqual(_.get(projectDetails, "isCasExternalPortingDone"), null) &&
          _.isEqual(
            _.get(projectDetails, "supervisorTypeFieldDetails.value"),
            "EXTERNAL"
          ) &&
          !hasOldExternalDataEntry
        ) {
          dispatch(
            updateProject({
              projectId: projectId,
              isCasExternalPortingDone: true,
            })
          );
        }

        dispatch(
          editProject({
            projectId,
            previousSupervisor,
            updatedSupervisor: currentSupervisor,
            isProjectWithMultipleSupervisors: true,
            extraParams: {
              type: _.isEqual(fieldUID, "supervisor")
                ? "saa_project_and_header_supervisor"
                : "cas_project_and_header_supervisor_external",
              queryVariables: {
                projectInfoQueryVar: getProjectHeaderInfoVariables({
                  projectId,
                  projectGroupType,
                  academicYearId,
                  projectGroupCategoryType,
                }),
                projectDetailsQuerVars: {
                  id: projectId,
                  academicYearId,
                  studentProjectPortfolioFilter: {
                    projectGroupTypes: [projectGroupType],
                  },
                  completionStatusFilters: {
                    academicYearIds: [academicYearId],
                  },
                },
                projectApprovedSupervisorsQueryVars: {
                  projectGroupId,
                  filters: {
                    approvalStatus: SUPERVISOR_APPROVAL_STATUS_APPROVED,
                    projectIds: [projectId],
                  },
                },
              },
            },
          })
        );
      }
    }
  };
};

const getFilteredArray = ({ nodeIdToRemove, arrayOfEvidences }) => {
  return arrayOfEvidences.filter(eachEvidence => {
    return _.get(eachEvidence, "node.id", "") !== nodeIdToRemove;
  });
};

export const updateAchievedPlannerElements = ({
  input,
  portfolioId,
  projectGroupType,
  loDisplayName,
  isCustom,
}) => {
  return async (dispatch, getState) => {
    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );
    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const cachedData = getLearningOutcomesWithEvidencesFromCache({
      id: portfolioId,
      plannerElementEvidenceFilters: {
        projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
        plannerElement: {
          type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
        },
        academicYearIds: _.isEmpty(academicYearFilterIds)
          ? [academicYearId]
          : academicYearFilterIds,
      },
      isServiceAsAction:
        projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
    });

    const portfolioCachedData = getStudentProjectPortfolioProgressFragmentInCache(
      {
        id: portfolioId,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      }
    );

    let plannerElementEvidences = [];
    let achievedPlannerElementEdges = _.get(
      portfolioCachedData,
      "achievedPlannerElements.edges",
      []
    );

    const totalCountOfAchievedPlannerElement =
      _.get(portfolioCachedData, "achievedPlannerElements.totalCount", 0) +
      _.size(_.get(input, "addedAchievedPlannerElementIds", [])) -
      _.size(_.get(input, "removedAchievedPlannerElementIds", []));

    if (!_.isEmpty(input.addedAchievedPlannerElementIds)) {
      plannerElementEvidences = _.map(
        _.get(cachedData, "node.plannerElementEvidences", []),
        evidence => {
          if (
            _.includes(
              input.addedAchievedPlannerElementIds,
              _.get(evidence, "plannerElementNode.id", null)
            )
          ) {
            const nodeToAdd = {
              node: _.get(evidence, "plannerElementNode", {}),
              __typename: "PlannerElementEdge",
            };

            achievedPlannerElementEdges = [
              ...achievedPlannerElementEdges,
              nodeToAdd,
            ];

            const { academicYear, isAchieved } = evidence;

            const updatedIsAchieved =
              _.isEmpty(academicYear) || academicYear?.id === academicYearId
                ? true
                : isAchieved;

            return { ...evidence, isAchieved: updatedIsAchieved };
          }
          return evidence;
        }
      );
    }

    if (!_.isEmpty(input.removedAchievedPlannerElementIds)) {
      plannerElementEvidences = _.map(
        _.get(cachedData, "node.plannerElementEvidences", []),
        evidence => {
          if (
            _.includes(
              input.removedAchievedPlannerElementIds,
              _.get(evidence, "plannerElementNode.id", null)
            )
          ) {
            const nodeIdToRemove = _.get(evidence, "plannerElementNode.id", {});
            achievedPlannerElementEdges = getFilteredArray({
              nodeIdToRemove,
              arrayOfEvidences: achievedPlannerElementEdges,
            });

            const { academicYear, isAchieved } = evidence;

            const updatedIsAchieved =
              _.isEmpty(academicYear) || academicYear?.id === academicYearId
                ? false
                : isAchieved;

            return { ...evidence, isAchieved: updatedIsAchieved };
          }
          return evidence;
        }
      );
    }

    writeStudentProjectPortfolioProgressFragmentInCache({
      id: portfolioId,
      data: update(portfolioCachedData, {
        achievedPlannerElements: {
          $set: {
            totalCount: totalCountOfAchievedPlannerElement,
            __typename: "PlannerElementConnection",
            edges: achievedPlannerElementEdges,
          },
        },
      }),
      variables: {
        completionStatusFilters: {
          academicYearIds: [academicYearId],
        },
      },
    });

    try {
      writeLearningOutcomesWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: {
          node: {
            id: portfolioId,
            __typename: "StudentProjectPortfolio",
            plannerElementEvidences,
          },
        },
      });
      await client.mutate({
        mutation: updateAchievedPlannerElementMutation,
        variables: {
          input,
        },
      });

      const shouldMarkAsAchieved = !_.isEmpty(
        input.addedAchievedPlannerElementIds
      );

      dispatch(
        setToastMsg({
          type: "success",
          msg: shouldMarkAsAchieved
            ? "toastMsgs:marked_as_achieved_with_label"
            : "toastMsgs:unmarked_as_achieved_with_label",
          locale_params: [
            {
              key: "label",
              value: isCustom ? "LO" : loDisplayName,
              isPlainText: isCustom ? true : false,
            },
          ],
        })
      );
    } catch (e) {
      writeLearningOutcomesWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: cachedData,
      });
      writeStudentProjectPortfolioProgressFragmentInCache({
        id: portfolioId,
        data: portfolioCachedData,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updatedPlannerElementAchievementLevel = ({
  learningOutcomeIndicators,
  selectedOutcomeId,
  plannerElementEvidence,
  students,
  portfolioId,
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    const { achievedPlannerElementId: evidenceId } = plannerElementEvidence;
    const input = [];
    const createdBy = getUserInfo();
    const selectedOutcome = _.find(learningOutcomeIndicators, {
      id: selectedOutcomeId,
    });

    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );
    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const {
      id: createdById,
      first_name: firstName,
      last_name: lastName,
      middle_name: middleName,
      profile_image: profileImage = null,
      user_type: type,
    } = createdBy;

    cache.updateQuery(
      {
        query: getLearningOutcomesWithEvidencesQuery,
        variables: {
          id: portfolioId,
          plannerElementEvidenceFilters: {
            projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
            plannerElement: {
              type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
            },
            academicYearIds: _.isEmpty(academicYearFilterIds)
              ? [academicYearId]
              : academicYearFilterIds,
          },
          isServiceAsAction:
            projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        },
      },
      cachedData => {
        const plannerElementEvidences =
          cachedData?.node?.plannerElementEvidences || [];

        const updatedPlannerElementEvidences = plannerElementEvidences.map(
          evidence => {
            if (evidence.id === evidenceId) {
              let updatedIBPypRatings = evidence.ibPYPElementRatings;

              // Find existing rating for this criteria type
              const existingRatingItem = _.find(
                evidence.ibPYPElementRatings,
                item =>
                  item?.academicCriteriaSet?.criteriaType ===
                  "LEARNING_OUTCOME_LEVEL"
              );

              if (existingRatingItem) {
                // Create new rating item and add it at index 0
                const newRatingItem = {
                  ...existingRatingItem,
                  id: generateRandomId(),
                  createdAt: moment().toISOString(),
                  createdByV2: {
                    id: createdById,
                    firstName,
                    middleName,
                    lastName,
                    profileImage,
                    type,
                  },

                  academicCriteriaValue: {
                    id: selectedOutcome?.id,
                    label: selectedOutcome?.label,
                    abbreviation: selectedOutcome?.abbreviation,
                    color: selectedOutcome?.color,
                    createdBy: {
                      id: createdById,
                      firstName,
                      middleName,
                      lastName,
                      profileImage,
                      type,
                      __typename: "Staff",
                    },
                    __typename: "AcademicCriteriaValue",
                  },
                  __typename: "IBPYPElementRating",
                };

                // Add new item at index 0 (most recent first)
                updatedIBPypRatings = [newRatingItem, ...updatedIBPypRatings];
              }

              return {
                ...evidence,
                ibPYPElementRatings: updatedIBPypRatings,
              };
            }
            return evidence;
          }
        );

        const updatedCachedData = update(cachedData, {
          node: {
            plannerElementEvidences: {
              $set: updatedPlannerElementEvidences,
            },
          },
        });

        return updatedCachedData;
      }
    );

    _.forEach(students, student => {
      input.push({
        studentId: student?.id,
        parentType: "OBSERVATION",
        ibPYPElementType: "ACHIEVED_PLANNER_ELEMENT_MAP",
        ibPYPElementId: evidenceId,
        createdBy: createdById,
        isPublished: true,
        academicCriteriaSetId: selectedOutcome?.academicCriteriaSetId,
        academicCriteriaValueId: selectedOutcome?.id,
      });
    });

    try {
      await client.mutate({
        mutation: PlannerCreateIBPYPElementRatingsMutation,
        variables: { input },
        update: (cache, { data }) => {
          const {
            planner: { createIBPYPElementRatings },
          } = data;

          cache.updateQuery(
            {
              query: getLearningOutcomesWithEvidencesQuery,
              variables: {
                id: portfolioId,
                plannerElementEvidenceFilters: {
                  projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
                  plannerElement: {
                    type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
                  },
                  academicYearIds: _.isEmpty(academicYearFilterIds)
                    ? [academicYearId]
                    : academicYearFilterIds,
                },
                isServiceAsAction:
                  projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
              },
            },
            cachedData => {
              const plannerElementEvidences =
                cachedData?.node?.plannerElementEvidences || [];

              const updatedPlannerElementEvidences = _.map(
                plannerElementEvidences,
                evidence => {
                  if (evidence.id === evidenceId) {
                    let updatedIBPypRatings = _.get(
                      evidence,
                      "ibPYPElementRatings",
                      []
                    );

                    const isLearningOutcomeLevelType = item =>
                      _.isEqual(
                        _.get(item, "academicCriteriaSet.criteriaType"),
                        "LEARNING_OUTCOME_LEVEL"
                      );

                    // Replace the randomly generated ID with the actual ID from mutation response
                    updatedIBPypRatings = _.map(
                      updatedIBPypRatings,
                      (item, index) => {
                        const matchingRating = _.first(
                          createIBPYPElementRatings
                        );

                        if (
                          _.isEqual(index, 0) &&
                          matchingRating &&
                          isLearningOutcomeLevelType(item)
                        ) {
                          return {
                            ...item,
                            id: _.get(matchingRating, "id"),
                          };
                        }
                        return item;
                      }
                    );

                    return {
                      ...evidence,
                      ibPYPElementRatings: updatedIBPypRatings,
                    };
                  }
                  return evidence;
                }
              );

              const updatedCachedData = update(cachedData, {
                node: {
                  plannerElementEvidences: {
                    $set: updatedPlannerElementEvidences,
                  },
                },
              });

              return updatedCachedData;
            }
          );
        },
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const deletePlannerElementAchievementLevel = ({
  deletedRatingId,
  plannerElementEvidence,
  portfolioId,
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    const { achievedPlannerElementId: evidenceId } = plannerElementEvidence;

    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );
    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    cache.updateQuery(
      {
        query: getLearningOutcomesWithEvidencesQuery,
        variables: {
          id: portfolioId,
          plannerElementEvidenceFilters: {
            projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
            plannerElement: {
              type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
            },
            academicYearIds: _.isEmpty(academicYearFilterIds)
              ? [academicYearId]
              : academicYearFilterIds,
          },
          isServiceAsAction:
            projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        },
      },
      cachedData => {
        const plannerElementEvidences =
          cachedData?.node?.plannerElementEvidences || [];

        const updatedPlannerElementEvidences = plannerElementEvidences.map(
          evidence => {
            if (evidence.id === evidenceId) {
              // Filter out the deleted rating
              const filteredRatings = _.filter(
                evidence.ibPYPElementRatings,
                rating => rating.id !== deletedRatingId
              );

              return {
                ...evidence,
                ibPYPElementRatings: filteredRatings,
              };
            }
            return evidence;
          }
        );

        const updatedCachedData = update(cachedData, {
          node: {
            plannerElementEvidences: {
              $set: updatedPlannerElementEvidences,
            },
          },
        });

        return updatedCachedData;
      }
    );

    try {
      await client.mutate({
        mutation: deleteProjectRatingsByIdsMutation,
        variables: {
          ids: [deletedRatingId],
        },
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const updateAchievedInsightsPlannerElements = ({
  input,
  portfolioId,
  projectGroupType,
  loDisplayName,
  isCustom,
}) => {
  return async (dispatch, getState) => {
    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );

    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const variables = {
      id: portfolioId,
      plannerElementEvidenceFilters: {
        projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
        plannerElement: {
          type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
        },
        academicYearIds: _.isEmpty(academicYearFilterIds)
          ? [academicYearId]
          : academicYearFilterIds,
      },
      isServiceAsAction:
        projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
    };

    const cachedData = getStudentLearningOutcomesInsightsFromCache({
      variables,
    });

    const portfolioCachedData = getStudentProjectPortfolioProgressFragmentInCache(
      {
        id: portfolioId,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      }
    );

    let plannerElementEvidences = [];
    let achievedPlannerElementEdges = _.get(
      portfolioCachedData,
      "achievedPlannerElements.edges",
      []
    );

    const totalCountOfAchievedPlannerElement =
      _.get(portfolioCachedData, "achievedPlannerElements.totalCount", 0) +
      _.size(_.get(input, "addedAchievedPlannerElementIds", [])) -
      _.size(_.get(input, "removedAchievedPlannerElementIds", []));

    if (!_.isEmpty(input.addedAchievedPlannerElementIds)) {
      plannerElementEvidences = _.map(
        _.get(cachedData, "node.plannerElementEvidences", []),
        evidence => {
          if (
            _.includes(
              input.addedAchievedPlannerElementIds,
              _.get(evidence, "plannerElementNode.id", null)
            )
          ) {
            const nodeToAdd = {
              node: _.get(evidence, "plannerElementNode", {}),
              __typename: "PlannerElementEdge",
            };
            achievedPlannerElementEdges = [
              ...achievedPlannerElementEdges,
              nodeToAdd,
            ];

            const { academicYear, isAchieved } = evidence;

            const updatedIsAchieved =
              _.isEmpty(academicYear) || academicYear?.id === academicYearId
                ? true
                : isAchieved;

            return {
              ...evidence,
              isAchieved: updatedIsAchieved,
            };
          }
          return evidence;
        }
      );
    }

    if (!_.isEmpty(input.removedAchievedPlannerElementIds)) {
      plannerElementEvidences = _.map(
        _.get(cachedData, "node.plannerElementEvidences", []),
        evidence => {
          if (
            _.includes(
              input.removedAchievedPlannerElementIds,
              _.get(evidence, "plannerElementNode.id", {})
            )
          ) {
            const nodeIdToRemove = _.get(evidence, "plannerElementNode.id", {});
            achievedPlannerElementEdges = getFilteredArray({
              nodeIdToRemove,
              arrayOfEvidences: achievedPlannerElementEdges,
            });

            const { academicYear, isAchieved } = evidence;

            const updatedIsAchieved =
              _.isEmpty(academicYear) || academicYear?.id === academicYearId
                ? false
                : isAchieved;

            return {
              ...evidence,
              isAchieved: updatedIsAchieved,
            };
          }
          return evidence;
        }
      );
    }

    writeStudentProjectPortfolioProgressFragmentInCache({
      id: portfolioId,
      data: update(portfolioCachedData, {
        achievedPlannerElements: {
          $set: {
            totalCount: totalCountOfAchievedPlannerElement,
            __typename: "PlannerElementConnection",
            edges: achievedPlannerElementEdges,
          },
        },
      }),
      variables: {
        completionStatusFilters: {
          academicYearIds: [academicYearId],
        },
      },
    });

    try {
      writeLearningOutcomesInsightsWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: {
          node: {
            ...cachedData.node,
            id: portfolioId,
            __typename: "StudentProjectPortfolio",
            plannerElementEvidences,
          },
        },
      });

      await client.mutate({
        mutation: updateAchievedPlannerElementMutation,
        variables: {
          input,
        },
      });

      const shouldMarkAsAchieved = !_.isEmpty(
        input.addedAchievedPlannerElementIds
      );

      dispatch(
        setToastMsg({
          type: "success",
          msg: shouldMarkAsAchieved
            ? "toastMsgs:marked_as_achieved_with_label"
            : "toastMsgs:unmarked_as_achieved_with_label",
          locale_params: [
            {
              key: "label",
              value: isCustom ? "LO" : loDisplayName,
              isPlainText: isCustom ? true : false,
            },
          ],
        })
      );
    } catch (e) {
      const academicYearFilterIds = _.get(
        getState(),
        "project.academicYearFilterDetails.academicYearIds",
        []
      );
      writeLearningOutcomesInsightsWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: cachedData,
      });

      writeStudentProjectPortfolioProgressFragmentInCache({
        id: portfolioId,
        data: portfolioCachedData,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      });

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateAchievedInsightsPlannerElementsLevel = ({
  learningOutcomeIndicators,
  selectedOutcomeId,
  evidenceId,
  students,
  portfolioId,
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    const input = [];
    const createdBy = getUserInfo();
    const selectedOutcome = _.find(learningOutcomeIndicators, {
      id: selectedOutcomeId,
    });

    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );
    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const {
      id: createdById,
      first_name: firstName,
      last_name: lastName,
      middle_name: middleName,
      profile_image: profileImage = null,
      user_type: type,
    } = createdBy;

    const variables = {
      id: portfolioId,
      plannerElementEvidenceFilters: {
        projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
        plannerElement: {
          type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
        },
        academicYearIds: _.isEmpty(academicYearFilterIds)
          ? [academicYearId]
          : academicYearFilterIds,
      },
      isServiceAsAction:
        projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
    };

    const cachedData = getStudentLearningOutcomesInsightsFromCache({
      variables,
    });

    const plannerElementEvidences = _.get(
      cachedData,
      "node.plannerElementEvidences",
      []
    );

    const updatedPlannerElementEvidences = _.map(
      plannerElementEvidences,
      evidence => {
        if (evidence.id === evidenceId) {
          let updatedIBPypRatings = evidence.ibPYPElementRatings;

          // Find existing rating for this criteria type
          const existingRatingItem = _.find(
            evidence.ibPYPElementRatings,
            item =>
              _.get(item, "academicCriteriaSet.criteriaType") ===
              "LEARNING_OUTCOME_LEVEL"
          );

          if (existingRatingItem) {
            // Create new rating item and add it at index 0
            const newRatingItem = {
              ...existingRatingItem,
              id: generateRandomId(),
              createdAt: moment().toISOString(),
              createdByV2: {
                id: createdById,
                firstName,
                middleName,
                lastName,
                profileImage,
                type,
              },

              academicCriteriaValue: {
                id: selectedOutcome?.id,
                label: selectedOutcome?.label,
                abbreviation: selectedOutcome?.abbreviation,
                color: selectedOutcome?.color,
                createdBy: {
                  id: createdById,
                  firstName,
                  middleName,
                  lastName,
                  profileImage,
                  type,
                  __typename: "Staff",
                },
                __typename: "AcademicCriteriaValue",
              },
              __typename: "IBPYPElementRating",
            };

            updatedIBPypRatings = [newRatingItem, ...updatedIBPypRatings];
          }

          return {
            ...evidence,
            ibPYPElementRatings: updatedIBPypRatings,
          };
        }
        return evidence;
      }
    );

    try {
      writeLearningOutcomesInsightsWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: {
          node: {
            ...cachedData.node,
            id: portfolioId,
            __typename: "StudentProjectPortfolio",
            plannerElementEvidences: updatedPlannerElementEvidences,
          },
        },
      });
      _.forEach(students, student => {
        input.push({
          studentId: student?.id,
          parentType: "OBSERVATION",
          ibPYPElementType: "ACHIEVED_PLANNER_ELEMENT_MAP",
          ibPYPElementId: evidenceId,
          createdBy: createdById,
          isPublished: true,
          academicCriteriaSetId: selectedOutcome?.academicCriteriaSetId,
          academicCriteriaValueId: selectedOutcome?.id,
        });
      });
      await client.mutate({
        mutation: PlannerCreateIBPYPElementRatingsMutation,
        variables: { input },
        update: (cache, { data }) => {
          const {
            planner: { createIBPYPElementRatings },
          } = data;

          const updatedPlannerElementEvidencesWithActualId = _.map(
            updatedPlannerElementEvidences,
            evidence => {
              if (evidence.id === evidenceId) {
                let updatedIBPypRatings = _.get(
                  evidence,
                  "ibPYPElementRatings",
                  []
                );

                const isLearningOutcomeLevelType = item =>
                  _.get(item, "academicCriteriaSet.criteriaType") ===
                  "LEARNING_OUTCOME_LEVEL";

                updatedIBPypRatings = _.map(
                  updatedIBPypRatings,
                  (item, index) => {
                    const matchingRating = _.first(createIBPYPElementRatings);

                    if (
                      index === 0 &&
                      matchingRating &&
                      isLearningOutcomeLevelType(item)
                    ) {
                      return {
                        ...item,
                        id: _.get(matchingRating, "id"),
                      };
                    }
                    return item;
                  }
                );

                return {
                  ...evidence,
                  ibPYPElementRatings: updatedIBPypRatings,
                };
              }
              return evidence;
            }
          );

          writeLearningOutcomesInsightsWithEvidencesInCache({
            id: portfolioId,
            plannerElementEvidenceFilters: {
              projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
              plannerElement: {
                type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
              },
              academicYearIds: _.isEmpty(academicYearFilterIds)
                ? [academicYearId]
                : academicYearFilterIds,
            },
            isServiceAsAction:
              projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
            data: {
              node: {
                ...cachedData.node,
                id: portfolioId,
                __typename: "StudentProjectPortfolio",
                plannerElementEvidences: updatedPlannerElementEvidencesWithActualId,
              },
            },
          });
        },
      });
    } catch (e) {
      console.error(e);

      // Rollback cache changes on error
      writeLearningOutcomesInsightsWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: cachedData,
      });
    }
  };
};

export const deleteAchievedInsightsPlannerElementsLevel = ({
  deletedRatingId,
  evidenceId,
  portfolioId,
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );
    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const variables = {
      id: portfolioId,
      plannerElementEvidenceFilters: {
        projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
        plannerElement: {
          type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
        },
        academicYearIds: _.isEmpty(academicYearFilterIds)
          ? [academicYearId]
          : academicYearFilterIds,
      },
      isServiceAsAction:
        projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
    };

    const cachedData = getStudentLearningOutcomesInsightsFromCache({
      variables,
    });

    const plannerElementEvidences = _.get(
      cachedData,
      "node.plannerElementEvidences",
      []
    );

    const updatedPlannerElementEvidences = plannerElementEvidences.map(
      evidence => {
        if (evidence.id === evidenceId) {
          // Filter out the deleted rating
          const filteredRatings = _.filter(
            evidence.ibPYPElementRatings,
            rating => rating.id !== deletedRatingId
          );

          return {
            ...evidence,
            ibPYPElementRatings: filteredRatings,
          };
        }
        return evidence;
      }
    );

    try {
      writeLearningOutcomesInsightsWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: {
          node: {
            ...cachedData.node,
            id: portfolioId,
            __typename: "StudentProjectPortfolio",
            plannerElementEvidences: updatedPlannerElementEvidences,
          },
        },
      });

      await client.mutate({
        mutation: deleteProjectRatingsByIdsMutation,
        variables: {
          ids: [deletedRatingId],
        },
      });
    } catch (e) {
      console.error(e);

      // Rollback cache changes on error
      writeLearningOutcomesInsightsWithEvidencesInCache({
        id: portfolioId,
        plannerElementEvidenceFilters: {
          projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
          plannerElement: {
            type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
          },
          academicYearIds: _.isEmpty(academicYearFilterIds)
            ? [academicYearId]
            : academicYearFilterIds,
        },
        isServiceAsAction:
          projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
        data: cachedData,
      });

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const getHelpTextLabel = ({ uid, template }) => {
  const {
    body: { field_list = {}, nodes = {} } = {},
    helpEnabledFields,
  } = template;

  const type = _.get(_.find(helpEnabledFields, { uid }), "type", "FIELD");

  switch (type) {
    case "FIELD": {
      const { config: { label = "", viewLabel = "" } = {} } =
        field_list[uid] ?? {};

      return viewLabel ? viewLabel : label;
    }
    case "STEP": {
      const { label = "" } = nodes[uid] ?? {};
      return label;
    }
    default:
      return "";
  }
};

const areConfigConditionsMet = ({
  conditionList = [],
  subjectLevelTag,
  role,
  projectFieldData,
  subjects,
  userSettingEntities = {},
  courseCollaborators,
  supervisorApprovalStatus,
  currentProjectGroupConfigurationSettings,
}) => {
  //if there is no condition to evaluate then developer must wanted to overwrite configs
  if (_.isEmpty(conditionList)) {
    return true;
  }

  const listObj = {
    courseCollaborators,
  };

  return _.every(conditionList, conditionInfo => {
    const {
      type = "",
      value,
      values = [],
      fieldValue = "",
      fieldUids = [],
      size,
    } = conditionInfo;

    switch (type) {
      case "subjectLevel":
        //assuming that subjectLevelTag will be same in all languages
        return _.isEqual(subjectLevelTag, value);
      case "role":
        return ROLE_SUPERVISOR === role
          ? _.isEqual("staff", value)
          : _.isEqual(role, value);
      case "featureFlag":
        return ACLStore.can(value);
      case "fieldValue":
        return !_.isEmpty(
          _.get(_.find(projectFieldData, { uid: value }), "value", null)
        );
      case "checkFieldValue":
        return _.isEqual(
          _.upperCase(
            _.get(_.find(projectFieldData, { uid: value }), "value", null)
          ),
          _.upperCase(fieldValue)
        );
      case "checkCategory":
        return _.some(fieldUids, value => {
          const subject = _.find(subjects, {
            id: _.get(
              _.find(projectFieldData, { uid: value }),
              "value.0",
              null
            ),
          });

          const categories = _.filter(
            _.get(subject, "associatedChildPlannerElementNodes", []),
            item => _.isEqual(item.type, PLANNER_ELEMENT_TYPE_DP_EE_CATEGORY)
          );

          return !_.isEmpty(categories);
        });
      case "listSize": {
        return !(_.size(listObj[value]) > size);
      }
      case "worldStudies":
        return _.find(subjects, {
          id: _.get(_.find(projectFieldData, { uid: value }), "value.0", null),
        })?.metadata?.is_world_studies;
      case "fieldValues":
        return _.some(
          values,
          value =>
            !_.isEmpty(
              _.get(_.find(projectFieldData, { uid: value }), "value", null)
            )
        );
      case "fieldValueBool":
        return _.get(_.find(projectFieldData, { uid: value }), "value", false);
      case "userSettings":
        return getSettingValue({
          ...userSettingEntities,
          name: value,
        });
      case "supervisorApprovalStatus": {
        return _.isEqual(supervisorApprovalStatus, value);
      }

      case "splitSettings": {
        return _.isEqual(
          _.get(currentProjectGroupConfigurationSettings, value),
          SUBMISSION_MODE_INDIVIDUAL
        );
      }
      case "durationSettings": {
        return currentProjectGroupConfigurationSettings[value];
      }

      case "projectGroupConfigurationSettings": {
        return _.get(
          _.find(currentProjectGroupConfigurationSettings, obj =>
            _.has(obj, value)
          ),
          value
        );
      }
      default:
        return false;
    }
  });
};

export const getUpdatedConfig = ({
  fieldConfig,
  subjectLevelTag,
  role,
  projectFieldData,
  keepConditionalConfiguration = false,
  subjects,
  courseCollaborators,
  userSettingEntities,
  supervisorApprovalStatus,
  currentProjectGroupConfigurationSettings,
}) => {
  const conditionalConfigurations = _.get(
    fieldConfig,
    "conditionalConfigurations",
    []
  );
  let updatedConfig = fieldConfig;

  if (!keepConditionalConfiguration) {
    updatedConfig = _.omit(fieldConfig, ["conditionalConfigurations"]);
  }

  _.forEach(conditionalConfigurations, conditionalConfiguration => {
    const { configuration = {}, conditionList = [] } = conditionalConfiguration;

    if (
      areConfigConditionsMet({
        conditionList,
        subjectLevelTag,
        role,
        projectFieldData,
        subjects,
        userSettingEntities,
        courseCollaborators,
        supervisorApprovalStatus,
        currentProjectGroupConfigurationSettings,
      })
    ) {
      updatedConfig = _.mergeWith(
        updatedConfig,
        configuration,
        (objValue, srcValue) => {
          if (_.isArray(objValue)) {
            return srcValue;
          }
        }
      );
    }
  });

  return updatedConfig;
};

const updateTemplateWithTableConfig = ({
  template,
  role,
  currentProjectGroupConfigurationSettings,
}) => {
  const { body } = template;

  let updatedBody = _.cloneDeep(body);
  const templateProperties = [
    "tableConfig",
    "projectExperienceTableConfig",
    "insightsTabConfig",
    "studentInsightsTableConfig",
    "studentInsightsColumnList",
    "setupConfig",
  ];

  _.forEach(templateProperties, templateProperty => {
    if (updatedBody[templateProperty]) {
      let updatedConfig = _.omit(updatedBody[templateProperty], [
        "conditionalConfigurations",
      ]);
      const conditionalConfigurations = _.get(
        updatedBody[templateProperty],
        "conditionalConfigurations",
        []
      );

      _.forEach(conditionalConfigurations, conditionalConfiguration => {
        const {
          configuration = {},
          conditionList = [],
        } = conditionalConfiguration;

        if (
          areConfigConditionsMet({
            conditionList,
            role,
            currentProjectGroupConfigurationSettings,
          })
        ) {
          updatedConfig = _.mergeWith(
            updatedConfig,
            configuration,
            (objValue, srcValue) => {
              if (_.isArray(objValue)) {
                return srcValue;
              }
            }
          );
        }
      });

      updatedBody = update(updatedBody, {
        [templateProperty]: { $set: updatedConfig },
      });
    }
  });

  const updatedTemplate = update(template, {
    body: { $set: updatedBody },
  });

  return updatedTemplate;
};

//In this function we are updating configs of template
const updateTemplateWithConfigs = ({
  template,
  role,
  subjectLevelTag,
  projectFieldData,
  templatePropertiesToUpdate,
  keepConditionalConfiguration,
  subjects,
  courseCollaborators,
  userSettingEntities,
  currentProjectGroupConfigurationSettings,
}) => {
  const { body } = _.cloneDeep(template);
  let updatedBody = body;

  _.forEach(templatePropertiesToUpdate, templateProperty => {
    //assuming all the template properties to be updated will be an object
    const updatedProperty = {};
    _.forEach(body[templateProperty], (fieldConfig, fieldUid) => {
      updatedProperty[fieldUid] = getUpdatedConfig({
        fieldConfig,
        subjectLevelTag,
        role,
        projectFieldData,
        keepConditionalConfiguration,
        subjects,
        courseCollaborators,
        userSettingEntities,
        currentProjectGroupConfigurationSettings,
      });
    });

    updatedBody = update(updatedBody, {
      [templateProperty]: { $set: updatedProperty },
    });
  });

  const updatedTemplate = update(template, {
    body: { $set: updatedBody },
  });

  return updatedTemplate;
};

export const getUpdatedTemplateMemoize = _.memoize(
  ({
    template,
    projectFieldData,
    guidingQuestions,
    t,
    language,
    childIdsToRemove,
    role,
    subjectLevelTag,
    templatePropertiesToUpdate,
    skipLocalisation,
    updateTableConfig,
    keepConditionalConfiguration,
    subjects,
    courseCollaborators,
    userSettingEntities,
    currentProjectGroupConfigurationSettings = {},
  }) =>
    updateTemplate({
      template,
      projectFieldData,
      childIdsToRemove,
      guidingQuestions,
      t,
      language /* DO NOT REMOVE THIS
  it is not used anywhere but added as a hack because in case when we are changing the language update template
  is not called so to call update template and localise the template with specific language it is added*/,
      role,
      subjectLevelTag,
      templatePropertiesToUpdate,
      skipLocalisation,
      updateTableConfig,
      keepConditionalConfiguration,
      subjects,
      courseCollaborators,
      userSettingEntities,
      currentProjectGroupConfigurationSettings,
    }),
  params => JSON.stringify(params)
);

export const updateTemplate = ({
  t,
  template,
  guidingQuestions,
  projectFieldData,
  fieldsToRemove = [],
  childIdsToRemove, //if u want to remove child from node, u can pass just childIds which u want to remove from node and it will be removed from all the node which contain the given childIds.
  removeFieldsWithValue, //should contain the field name with its value used when we want to remove fields on array based condition,
  role,
  subjectLevelTag,
  templatePropertiesToUpdate,
  skipLocalisation = false,
  updateTableConfig = false,
  keepConditionalConfiguration = false,
  subjects,
  courseCollaborators,
  userSettingEntities,
  currentProjectGroupConfigurationSettings,
}) => {
  //Updating template configs based on provided conditions
  template = updateTemplateWithConfigs({
    template,
    role,
    subjectLevelTag,
    projectFieldData,
    templatePropertiesToUpdate,
    keepConditionalConfiguration,
    subjects,
    courseCollaborators,
    userSettingEntities,
    currentProjectGroupConfigurationSettings,
  });

  if (updateTableConfig) {
    template = updateTemplateWithTableConfig({
      template,
      role,
      currentProjectGroupConfigurationSettings,
    });
  }

  //condition to add and remove the dependent fields
  if (!_.isEmpty(projectFieldData)) {
    template = updateTemplateFieldsWithDependency({
      template,
      projectFieldData,
    });
  }

  //handled for service as action guiding question where template will be updated according to the guiding questions available
  if (_.size(guidingQuestions) > 0) {
    template = updateGuidingQuestionsInTemplate({
      template,
      guidingQuestions,
      reflectionSubmissionMode:
        currentProjectGroupConfigurationSettings["REFLECTION"],
    });
  }

  //remove the fields with array size 1
  if (removeFieldsWithValue) {
    fieldsToRemove = [
      ...fieldsToRemove,
      ...getFieldsToRemove({ removeFieldsWithValue }),
    ];
  }

  //remove the given fields from the template
  if (fieldsToRemove) {
    const {
      body: { nodes },
    } = template;
    const nodesWithFieldsToRemove = getNodeWithFieldsToRemove({
      fieldsToRemove,
      nodes,
    });
    template = getTemplateWithRemovedFields({
      template,
      nodesWithFieldsToRemove,
    });
  }

  // removing childIds from node
  if (!_.isEmpty(childIdsToRemove)) {
    template = getTemplateWithRemovedChildIds({
      template,
      childIdsToRemove,
    });
  }

  return skipLocalisation ? template : getLocalisedTemplate({ template, t });
};

export const deleteDeadlineItem = ({ deadlineItem }) => async dispatch => {
  const [error] = await asyncWrap(
    client.mutate({
      mutation: deleteProjectDeadlineMutation,
      variables: {
        input: {
          id: deadlineItem.id,
        },
      },
    })
  );
  if (error) {
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
  return { error };
};

export const createDeadlineItem = ({
  deadlineItem,
  projectGroupId,
  showSuccessToast = true,
  fetchStatusWiseProjects = false,
}) => async dispatch => {
  const {
    title,
    deadlineDate,
    description,
    isDeadlineAllDay = undefined,
  } = deadlineItem;

  const [error] = await asyncWrap(
    client.mutate({
      mutation: createProjectDeadlineMutation,
      variables: {
        input: {
          title,
          deadlineDate: moment(deadlineDate).utc(),
          description,
          projectGroupId,
          isDeadlineAllDay,
        },
        fetchStatusWiseProjects,
      },
    })
  );
  if (error) {
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  } else if (showSuccessToast) {
    dispatch(
      setToastMsg({
        type: "success",
        msg: "toastMsgs:successfully_with_label",
        locale_params: [
          { key: "label", value: "toastMsgs:added", isPlainText: false },
        ],
      })
    );
  }
  return { error };
};

export const updateDeadlineItem = ({
  deadlineItem,
  fetchStatusWiseProjects = false,
}) => async dispatch => {
  const {
    id,
    title,
    deadlineDate,
    description,
    isDeadlineAllDay = undefined,
  } = deadlineItem;
  const [error] = await asyncWrap(
    client.mutate({
      mutation: updateProjectDeadlineMutation,
      variables: {
        input: {
          id,
          title,
          description,
          deadlineDate: moment(deadlineDate).utc(),
          isDeadlineAllDay,
        },
        fetchStatusWiseProjects,
      },
      update: (cache, result) => {
        writeProjectGroupDeadlineInCache({
          projectDeadlineId: id,
          data: deadlineItem,
        });
      },
    })
  );

  if (error) {
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
  return { error };
};

//FIXME: not used anymore

export const createProjectTemplateCopy = async ({
  projectId,
  projectGroupReportTemplateId,
  projectGroupId,
}) => {
  const [error, result] = await asyncWrap(
    client.mutate({
      mutation: createProjectTemplateCopyMutation,
      variables: {
        input: {
          projectId,
          projectGroupReportTemplateId,
          projectGroupId,
        },
      },
    })
  );
  return {
    error,
    attachment: result?.data?.documentation?.createProjectTemplateCopy,
  };
};
//For re-ordering lists
export const getDragEndValues = ({
  droppableId,
  draggableId,
  items,
  params,
}) => {
  const _droppableId = _.get(params, "destination.droppableId", "");
  const destinationIndex = _.get(params, "destination.index", null);
  const _draggableId = _.split(_.get(params, "draggableId", ""), ":");
  const toIndex = _.get(params, "destination.index", null);
  const fromIndex = _.get(params, "source.index", null);

  if (_droppableId == droppableId && _draggableId[0] == draggableId) {
    const putAfterItemIndex =
      toIndex <= fromIndex ? destinationIndex - 1 : destinationIndex;
    const putAfterItemId = _.get(items, `${[putAfterItemIndex]}.id`, null);

    const id = _draggableId[1];
    return {
      fromIndex,
      toIndex,
      id,
      putAfterItemId,
    };
  }
};

export const updateStudentProjectPortfolio = ({ status, id, isCompleted }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();

    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const cachedData = getStudentProjectPortfolioProgressFragmentInCache({
      id,
      variables: {
        completionStatusFilters: {
          academicYearIds: [academicYearId],
        },
      },
    });

    writeStudentProjectPortfolioProgressFragmentInCache({
      id,
      data: {
        ...cachedData,
        ...(!!status && { status }),
        completionStatus: {
          ...(!_.isUndefined(isCompleted) && { isComplete: isCompleted }),
          markedCompletedBy: {
            id: _.get(userInfo, "id", ""),
            firstName: _.get(userInfo, "first_name", ""),
            lastName: _.get(userInfo, "last_name", ""),
            middleName: _.get(userInfo, "middle_name", ""),
            __typename: "Staff",
          },
          markedCompletedAt: moment(),
        },
      },
      variables: {
        completionStatusFilters: {
          academicYearIds: [academicYearId],
        },
      },
    });

    try {
      return await client.mutate({
        mutation: updateStudentPortfolioStatusMutation,
        variables: {
          id,
          ...(!!status && { status }),
          ...(!_.isUndefined(isCompleted) && { isComplete: isCompleted }),
        },
      });
    } catch (e) {
      writeStudentProjectPortfolioProgressFragmentInCache({
        id,
        data: cachedData,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateProjectFieldInCache = ({
  fieldUID,
  params,
  fieldObj,
  extraParams,
  fieldTemplateObj,
}) => {
  return (dispatch, getState) => {
    const data = {
      ...fieldObj,
      value: params.value,
      isComplete: params?.isComplete,
      attachments: _.includes(
        ["SubmissionItem", "ReportItem"],
        fieldTemplateObj?.type
      )
        ? _.map(params?.value, item => {
            return {
              ...ATTACHMENT_CREATE_ATTRIBUTES,
              signedUrl: null,
              ...item,
            };
          })
        : [],
      resolvedMinimalTree: getResolvedOptimisticValue({
        resolvedValue: _.get(fieldObj, "resolvedMinimalTree", {}),
        fieldUID,
        fieldTemplateObj,
        params: extraParams,
        value: _.get(params, "value", ""),
      }),
      updatedAt: moment().format(),
    };

    client.writeFragment({
      id: `PlannerField:${params.id}`,
      fragment: projectFieldItemFragment.projectFieldItem,
      fragmentName: "projectFieldItem",
      data: data,
    });
  };
};

export const updateProjectField = params => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateProjectFieldMutation,
        variables: params,
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const getToastMsgValue = ({ lockingState }) => {
  switch (lockingState) {
    case ENTITY_LOCKED_STATE: {
      return "toastMsgs:locked";
    }
    case ENTITY_UNLOCKED_STATE: {
      return "toastMsgs:unlocked";
    }
    default:
      break;
  }
};

export const bulkUpdateProjectField = ({ params, refetchQueries = [] }) => {
  const toastMsgValue = _.get(params, "toastMsgValue", "");
  const localeParams = _.get(params, "locale_params", []);

  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: bulkUpdateEntityLockingStatusMutation,
        variables: params,
        awaitRefetchQueries: true,
        refetchQueries,
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: toastMsgValue
            ? toastMsgValue
            : "toastMsgs:successfully_with_label",
          locale_params: [
            ...localeParams,
            {
              key: "label",
              value: getToastMsgValue({
                lockingState: _.get(params, "input.state", ""),
              }),
              isPlainText: false,
            },
          ],
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const markProjectDeadlinesComplete = ({
  projectId,
  addedArray,
  removedArray,
}) => {
  return async (dispatch, getState) => {
    const projectInfo = getProjectInfoFromCache({ projectId });
    //removing from Completed List
    const updatedCompletedDeadlines = _.filter(
      projectInfo.node.completedDeadlines,
      completedDeadline =>
        !_.find(
          removedArray,
          itemId => itemId === completedDeadline.deadline.id
        )
    );
    //adding in completed list
    if (addedArray.length > 0) {
      _.forEach(addedArray, itemId => {
        updatedCompletedDeadlines.push({
          deadline: {
            id: itemId,
            __typename: "ProjectGroupDeadline",
          },
          __typename: "CompletedDeadlines",
        });
      });
    }

    writeProjectInfoInCache({
      projectId,
      data: {
        ...projectInfo.node,
        completedDeadlines: updatedCompletedDeadlines,
      },
    });

    try {
      await client.mutate({
        mutation: markProjectDeadlinesCompleteMutation,
        variables: {
          projectId,
          addedArray,
          removedArray,
        },
      });
    } catch (e) {
      writeProjectInfoInCache({
        projectId,
        data: projectInfo.node,
      });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateProject = ({
  projectId,
  statusToUpdate,
  projectGroupType,
  projectGroupId,
  currentStatus,
  statusMessage,
  useMutationWithoutFields = false,
  fields,
  isProjectMarkedCompleted = false,
  isCasExternalPortingDone = null,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    // FIX ME: for some reason, projectInfo is not being fetched from cache for SAA
    const projectInfo = getProjectInfoFromCache({ projectId });
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);

    const userObject = {
      id: _.get(userInfo, "id", ""),
      firstName: _.get(userInfo, "first_name", ""),
      lastName: _.get(userInfo, "last_name", ""),
      middleName: _.get(userInfo, "middle_name", ""),
      type: _.get(userInfo, "user_type", ""),
      __typename: "Staff",
    };

    writeProjectInfoInCache({
      projectId,
      data: {
        ...projectInfo.node,
        ...statusToUpdate,
        ...(fields && { fields }),
        ...(isProjectMarkedCompleted && {
          markedCompletedBy: userObject,
          markedCompletedAt: moment(),
          ...(isCasExternalPortingDone !== null && {
            isCasExternalPortingDone,
          }),
        }),
        updatedBy: userObject,
        updatedAt: moment(),
      },
    });

    try {
      await client.mutate({
        mutation: useMutationWithoutFields
          ? updateProjectWithoutResponseFieldsMutation
          : updateProjectMutation,
        variables: {
          projectId,
          statusMessage,
          ...statusToUpdate,
          ...(fields && {
            fields: _.map(fields, field => {
              return { id: field.id, value: field.value || "" };
            }),
          }),
          isCasExternalPortingDone:
            isCasExternalPortingDone !== null
              ? isCasExternalPortingDone
              : undefined,
        },
        update: () => {
          // here projectGroupType is undefined, so this can be removed
          switch (projectGroupType) {
            case PROJECT_GROUP_TYPE_DP_CAS:
            case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING:
            case PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT: {
              const { status } = statusToUpdate;
              if (
                !(
                  currentStatus === status &&
                  status === PROJECT_STATUS_PENDING_FOR_APPROVAL
                )
              ) {
                const data = getProjectGroupProjectCountFromCache({
                  id: projectGroupId,
                  filters: {
                    status: PROJECT_STATUS_PENDING_FOR_APPROVAL,
                    academicYearIds,
                  },
                });
                let newCount = null;
                if (status === PROJECT_STATUS_PENDING_FOR_APPROVAL)
                  newCount = _.get(data, "node.projects.totalCount", null) + 1;
                else
                  newCount = _.get(data, "node.projects.totalCount", null) - 1;
                if (newCount >= 0)
                  writeProjectGroupProjectCountInCache({
                    id: projectGroupId,
                    filters: {
                      status: PROJECT_STATUS_PENDING_FOR_APPROVAL,
                      academicYearIds,
                    },
                    data: update(data, {
                      node: {
                        projects: {
                          totalCount: { $set: newCount },
                        },
                      },
                    }),
                  });
              }
              break;
            }
            default:
              return null;
          }
        },
      });
    } catch (error) {
      writeProjectInfoInCache({
        projectId,
        data: projectInfo.node,
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateOverallProgress = ({
  selectedOverallProgress,
  projectId,
  students,
}) => {
  return async (dispatch, getState) => {
    const {
      type: projectGroupType,
      id: projectGroupId,
      category: projectGroupCategoryType,
    } = getCurrentProjectGroupDetails({
      state: getState(),
    });

    const createdBy = getUserInfo();

    const {
      id: createdById,
      first_name: firstName,
      last_name: lastName,
      middle_name: middleName,
      profile_image: profileImage = null,
      user_type: type,
      prefix: prefix,
      pronouns: pronouns,
      preferred_name: preferredName,
      suffix: suffix,
    } = createdBy;

    const academicYearId = getSelectedAcademicYearId(getState());
    const isOverallProgressIndicatorHistoryEnabled = getIsOverallProgressIndicatorsEnabled();
    cache.updateQuery(
      {
        query: getProjectHeaderInfoQuery,
        variables: getProjectHeaderInfoVariables({
          projectId,
          projectGroupType,
          projectGroupCategoryType,
          academicYearId,
        }),
      },
      cachedData => {
        let updatedIBPypRatings = cachedData?.node?.ibPYPElementRatings;
        if (isOverallProgressIndicatorHistoryEnabled) {
          const existingOverallProgressItem = _.find(
            _.get(cachedData, "node.ibPYPElementRatings", []),
            item =>
              _.get(item, "academicCriteriaSet.criteriaType") ===
              PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE
          );

          if (existingOverallProgressItem) {
            const newItem = {
              ...existingOverallProgressItem,
              id: generateRandomId(),
              createdAt: moment().toISOString(),
              createdByV2: {
                id: createdById,
                firstName,
                middleName,
                lastName,
                profileImage,
                type,
                prefix,
                pronouns,
                preferredName,
                suffix,
                __typename: "Staff",
              },
              academicCriteriaValue: {
                id: _.get(selectedOverallProgress, "id"),
                label: _.get(selectedOverallProgress, "label"),
                abbreviation: _.get(selectedOverallProgress, "abbreviation"),
                color: _.get(selectedOverallProgress, "color"),
                createdBy: {
                  id: createdById,
                  firstName,
                  middleName,
                  lastName,
                  profileImage,
                  type,
                },
                __typename: "AcademicCriteriaValue",
              },
            };

            updatedIBPypRatings = [newItem, ...updatedIBPypRatings];
          }
        } else {
          updatedIBPypRatings = _.map(
            _.get(cachedData, "node.ibPYPElementRatings", []),
            item => {
              if (
                _.get(item, "academicCriteriaSet.criteriaType") ===
                PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE
              ) {
                return {
                  ...item,
                  academicCriteriaValue: {
                    id: selectedOverallProgress?.id,
                    label: selectedOverallProgress?.label,
                    abbreviation: selectedOverallProgress?.abbreviation,
                    color: selectedOverallProgress?.color,
                    createdBy: {
                      id: createdById,
                      firstName,
                      middleName,
                      lastName,
                      profileImage,
                      type,
                    },

                    __typename: "AcademicCriteriaValue",
                  },
                };
              }
              return item;
            }
          );
        }

        const updatedData = update(cachedData, {
          node: {
            ibPYPElementRatings: {
              $set: updatedIBPypRatings,
            },
          },
        });

        return updatedData;
      }
    );

    const input = [];
    _.forEach(students, student => {
      input.push({
        studentId: student?.id,
        parentType: isOverallProgressIndicatorHistoryEnabled
          ? "OBSERVATION"
          : "PROJECT",
        parentId: isOverallProgressIndicatorHistoryEnabled
          ? undefined
          : projectId,
        ibPYPElementType: isOverallProgressIndicatorHistoryEnabled
          ? "PROJECT"
          : "PROJECT_GROUP",
        ibPYPElementId: isOverallProgressIndicatorHistoryEnabled
          ? projectId
          : projectGroupId,
        createdBy: createdById,
        isPublished: true,
        academicCriteriaSetId: selectedOverallProgress?.academicCriteriaSetId,
        academicCriteriaValueId: selectedOverallProgress?.id,
      });
    });
    try {
      await client.mutate({
        mutation: PlannerCreateIBPYPElementRatingsMutation,
        variables: { input },
        update: (cache, { data }) => {
          const {
            planner: { createIBPYPElementRatings },
          } = data;

          cache.updateQuery(
            {
              query: getProjectHeaderInfoQuery,
              variables: getProjectHeaderInfoVariables({
                projectId,
                projectGroupType,
                projectGroupCategoryType,
                academicYearId,
              }),
            },
            cachedData => {
              let updatedIBPypRatings = _.get(
                cachedData,
                "node.ibPYPElementRatings",
                []
              );

              const isOverallProgressType = item =>
                _.get(item, "academicCriteriaSet.criteriaType") ===
                PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE;

              if (isOverallProgressIndicatorHistoryEnabled) {
                // Replace the randomly generated ID with the actual ID from mutation response
                updatedIBPypRatings = _.map(
                  updatedIBPypRatings,
                  (item, index) => {
                    // Find the corresponding rating from the mutation response
                    const matchingRating = _.first(createIBPYPElementRatings);

                    if (
                      index === 0 &&
                      matchingRating &&
                      isOverallProgressType(item)
                    ) {
                      return {
                        ...item,
                        id: _.get(matchingRating, "id"), // Replace random ID with actual ID
                      };
                    }
                    return item;
                  }
                );
              } else {
                // For non-history mode, update the existing rating with actual ID
                updatedIBPypRatings = _.map(updatedIBPypRatings, item => {
                  if (isOverallProgressType(item)) {
                    const matchingRating = _.first(createIBPYPElementRatings);
                    if (matchingRating) {
                      return {
                        ...item,
                        id: _.get(matchingRating, "id"), // Replace with actual ID
                      };
                    }
                  }
                  return item;
                });
              }

              const updatedCachedData = update(cachedData, {
                node: {
                  ibPYPElementRatings: {
                    $set: updatedIBPypRatings,
                  },
                },
              });

              return updatedCachedData;
            }
          );
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteOverallProgress = ({
  deletedOverallProgressId,
  projectId,
}) => {
  return async (dispatch, getState) => {
    const {
      type: projectGroupType,
      category: projectGroupCategoryType,
    } = getCurrentProjectGroupDetails({
      state: getState(),
    });

    const academicYearId = getSelectedAcademicYearId(getState());
    cache.updateQuery(
      {
        query: getProjectHeaderInfoQuery,
        variables: getProjectHeaderInfoVariables({
          projectId,
          projectGroupType,
          projectGroupCategoryType,
          academicYearId,
        }),
      },
      cachedData => {
        const filteredRatings = _.filter(
          cachedData?.node?.ibPYPElementRatings,
          rating => rating.id !== deletedOverallProgressId
        );

        const returnedData = update(cachedData, {
          node: {
            ibPYPElementRatings: {
              $set: filteredRatings,
            },
          },
        });

        return returnedData;
      }
    );

    try {
      await client.mutate({
        mutation: deleteProjectRatingsByIdsMutation,
        variables: {
          ids: [deletedOverallProgressId],
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateProjectDetails = ({
  projectId,
  projectType,
  isCompleted,
}) => {
  return async (dispatch, getState) => {
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    const academicYearId = getSelectedAcademicYearId(getState());
    const projectDetails = getProjectDetailsFromCache({
      projectId,
      projectGroupType,
      academicYearId,
    });
    writeProjectDetailsInCache({
      projectId,
      academicYearId,
      data: {
        node: {
          ...projectDetails.node,
          ...(!!projectType && { type: projectType }),
          ...(!_.isUndefined(isCompleted) && { isCompleted }),
        },
      },
      projectGroupType,
    });

    try {
      await client.mutate({
        mutation: updateProjectMutation,
        variables: {
          projectId,
          ...(!!projectType && { type: projectType }),
          ...(!_.isUndefined(isCompleted) && { isCompleted }),
        },
      });
    } catch (error) {
      writeProjectDetailsInCache({
        projectId,
        academicYearId,
        data: projectDetails.node,
        projectGroupType,
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const createAttachment = ({
  name,
  url,
  thumbUrl,
  mimeType,
  type,
  parentId,
  parentType,
  metadata,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const state = getState();
    const currentCurriculumType = getCurrentCurriculumProgramType(state);
    const userId = userInfo.id;
    try {
      return await client.mutate({
        mutation: createAttachmentMutation,
        variables: {
          name,
          url,
          thumbUrl,
          mimeType,
          type,
          parentId,
          createdBy: userId,
          parentType,
          metadata,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectReportTemplateDetailsQuery,
            variables: {
              id: parentId,
              filters: {
                curriculumType: currentCurriculumType,
              },
            },
          },
        ],
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const getUpdatedDataForAssessmentCriteriaRating = params => {
  const {
    parentId,
    ibPYPElementId,
    value,
    studentCourseFilters,
    academicCriteriaSetId = null,
    isAssessmentGradebookNewApi,
    getProjectStudentCriteriaDetailsQueryVars,
    actionType,
    ibPYPElementType,
    academicCriteriaSet,
    isFinalGradeDynamic,
  } = params;
  let updatedData = {};
  if (isAssessmentGradebookNewApi) {
    const data = getProjectStudentCriteriaDetailsFromCache({
      variables: getProjectStudentCriteriaDetailsQueryVars,
    });
    const index = _.findIndex(
      _.get(data, "students[0].ibPYPElementRatings"),
      item => {
        const itemAcademicCriteriaSetId = _.get(
          item,
          "academicCriteriaSet.id",
          null
        );
        return (
          itemAcademicCriteriaSetId == academicCriteriaSetId &&
          item.ibPYPElementId == ibPYPElementId
        );
      }
    );
    switch (actionType) {
      case "CREATE":
        {
          if (!_.isEqual(index, -1)) {
            updatedData = update(data, {
              students: {
                [0]: {
                  ibPYPElementRatings: {
                    [index]: {
                      value: { $set: value },
                    },
                  },
                },
              },
            });
          } else {
            const newIbPYPElementType = {
              value,
              id: generateRandomId(),
              ibPYPElementId,
              isPublished: true,
              academicCriteriaSet: {
                id: academicCriteriaSetId,
                criteriaType: "PROJECT_FINAL_SCORE",
                __typename: "AcademicCriteriaSet",
              },
              academicCriteriaValue: null,
              isComputedRating: false,
              __typename: "IBPYPElementRating",
            };

            updatedData = update(data, {
              students: {
                [0]: {
                  ibPYPElementRatings: {
                    $push: [newIbPYPElementType],
                  },
                },
              },
            });
          }
        }
        break;
      case "DELETE": {
        updatedData = update(data, {
          students: {
            [0]: {
              ibPYPElementRatings: { $splice: [[index, 1]] },
            },
          },
        });
      }
    }
    return { data, updatedData };
  } else {
    const data = getProjectCriteriaDetailsFromCache({
      id: parentId,
      studentCourseFilters,
    });
    const index = _.findIndex(data?.ibPYPElementRatings, item => {
      if (isFinalGradeDynamic) {
        return (
          item?.academicCriteriaSet?.criteriaType ===
            CRITERIA_RUBRIC_FINAL_GRADE &&
          item?.ibPYPElementId === ibPYPElementId &&
          item?.ibPYPElementType === ibPYPElementType
        );
      }

      return item?.ibPYPElementId === ibPYPElementId;
    });
    switch (actionType) {
      case "CREATE":
        {
          if (!_.isEqual(index, -1)) {
            updatedData = update(data, {
              ibPYPElementRatings: {
                [index]: {
                  value: { $set: value },
                },
              },
            });
          } else {
            const newIbPYPElementType = {
              value,
              id: generateRandomId(),
              ibPYPElementId,
              academicCriteriaSet,
              academicCriteriaValue: null,
              ibPYPElementType,
              isComputedRating: false,
              isPublished: true,
              __typename: "IBPYPElementRating",
            };

            updatedData = update(data, {
              ibPYPElementRatings: {
                $push: [newIbPYPElementType],
              },
            });
          }
        }
        break;
      case "DELETE": {
        updatedData = update(data, {
          ibPYPElementRatings: { $splice: [[index, 1]] },
        });
      }
    }
    return { updatedData, data };
  }
};

export const createRubricAssessmentCriteriaRating = ({
  parentType,
  parentId,
  ibPYPElementType,
  ibPYPElementId,
  value,
  studentCourseFilters,
  academicCriteriaSetId = null,
  isAssessmentGradebookNewApi,
  extraParams: { getProjectStudentCriteriaDetailsQueryVars = {} } = {},
  projectId,
  academicCriteriaSet = null,
  isFinalGradeDynamic,
}) => {
  return async (dispatch, getState) => {
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    const userInfo = getUserInfo();
    const createdBy = userInfo.id;
    const academicYearId = getSelectedAcademicYearId(getState());
    const { node: { students = [] } = {} } = getProjectDetailsFromCache({
      projectId: projectId,
      projectGroupType,
      academicYearId,
    });
    const studentId = _.first(students)?.id;

    const { updatedData, data } = getUpdatedDataForAssessmentCriteriaRating({
      actionType: "CREATE",
      isAssessmentGradebookNewApi,
      parentId,
      ibPYPElementId,
      value,
      studentCourseFilters,
      academicCriteriaSetId,
      getProjectStudentCriteriaDetailsQueryVars,
      ibPYPElementType,
      academicCriteriaSet,
      isFinalGradeDynamic,
    });
    const refetchQueries = [];

    if (isAssessmentGradebookNewApi) {
      writeProjectStudentCriteriaDetails({
        data: updatedData,
        variables: getProjectStudentCriteriaDetailsQueryVars,
      });
      refetchQueries.push({
        query: getStudentRatingDetailQuery,
        variables: {
          id: studentId,
          filtersForGeneric:
            getProjectStudentCriteriaDetailsQueryVars?.filtersForGeneric,
        },
      });
    } else {
      writeProjectRatedCriteriaInCache({
        id: parentId,
        data: updatedData,
      });
    }

    try {
      await client.mutate({
        mutation: PlannerCreateIBPYPElementRatingsMutation,
        refetchQueries,
        awaitRefetchQueries: true,
        variables: {
          input: {
            studentId,
            parentType,
            parentId,
            ibPYPElementType,
            ibPYPElementId,
            createdBy,
            value,
            academicCriteriaSetId,
            isPublished: true,
          },
        },
      });
    } catch (e) {
      if (e.message == RATING_REFRESH_PAGE_ERROR) {
        persistor.purge().then(() => {
          window.location.reload();
        });
        return;
      }
      if (isAssessmentGradebookNewApi) {
        writeProjectStudentCriteriaDetails({
          data,
          variables: getProjectStudentCriteriaDetailsQueryVars,
        });
      } else {
        writeProjectRatedCriteriaInCache({
          id: parentId,
          data,
        });
      }
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteRubricAssessmentCriteriaRating = ({
  parentType,
  parentId,
  ibPYPElementType,
  ibPYPElementId,
  studentCourseFilters,
  academicCriteriaSetId = null,
  isAssessmentGradebookNewApi,
  extraParams: { getProjectStudentCriteriaDetailsQueryVars = {} } = {},
  projectId,
  academicCriteriaSet = null,
  isFinalGradeDynamic,
}) => {
  return async (dispatch, getState) => {
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    const academicYearId = getSelectedAcademicYearId(getState());
    const { node: { students = [] } = {} } = getProjectDetailsFromCache({
      projectId,
      projectGroupType,
      academicYearId,
    });
    const studentId = _.first(students)?.id;

    const { updatedData, data } = getUpdatedDataForAssessmentCriteriaRating({
      actionType: "DELETE",
      isAssessmentGradebookNewApi,
      parentId,
      ibPYPElementId,
      studentCourseFilters,
      academicCriteriaSetId,
      getProjectStudentCriteriaDetailsQueryVars,
      ibPYPElementType,
      academicCriteriaSet,
      isFinalGradeDynamic,
    });

    const refetchQueries = [];

    if (isAssessmentGradebookNewApi) {
      writeProjectStudentCriteriaDetails({
        data: updatedData,
        variables: getProjectStudentCriteriaDetailsQueryVars,
      });
      refetchQueries.push({
        query: getStudentRatingDetailQuery,
        variables: {
          id: studentId,
          filtersForGeneric:
            getProjectStudentCriteriaDetailsQueryVars?.filtersForGeneric,
        },
      });
    } else {
      writeProjectRatedCriteriaInCache({
        id: parentId,
        data: updatedData,
      });
    }

    try {
      await client.mutate({
        mutation: PlannerDeleteIBPYPElementRatingMutation,
        refetchQueries,
        awaitRefetchQueries: true,
        variables: {
          input: {
            studentId,
            parentType,
            parentId,
            ibPYPElementType,
            ibPYPElementId,
            academicCriteriaSetId,
          },
        },
      });
    } catch (e) {
      if (e.message == RATING_REFRESH_PAGE_ERROR) {
        persistor.purge().then(() => {
          window.location.reload();
        });
        return;
      }
      if (isAssessmentGradebookNewApi) {
        writeProjectStudentCriteriaDetails({
          data,
          variables: getProjectStudentCriteriaDetailsQueryVars,
        });
      } else {
        writeProjectRatedCriteriaInCache({
          id: parentId,
          data,
        });
      }
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const getProjectGroupTypeFromId = ({ state, projectGroupId }) => {
  const {
    login: {
      userInfo: {
        communityProjectId,
        personalProjectId,
        serviceAsActionId,
        projectGroups,
      },
    },
  } = state;

  const projectGroupIdsMap = new Map([
    [communityProjectId, PROJECT_GROUP_TYPE_COMMUNITY],
    [personalProjectId, PROJECT_GROUP_TYPE_PERSONAL],
    [serviceAsActionId, PROJECT_GROUP_TYPE_SERVICE_AS_ACTON],
  ]);

  if (!_.isEmpty(projectGroups)) {
    _.forEach(projectGroups, projectGroup => {
      projectGroupIdsMap.set(projectGroup.id, projectGroup.type);
    });
  }

  if (projectGroupIdsMap.has(String(projectGroupId))) {
    return projectGroupIdsMap.get(String(projectGroupId));
  }

  return PROJECT_GROUP_ID_NOT_FOUND;
};

export const getCurrentProjectGroupDetails = ({ state }) => {
  const projectGroupDetails = _.get(state, "project.projectGroupDetails", {});
  return projectGroupDetails;
};

export const createProject = ({
  projectGroupId,
  supervisorId,
  supervisorIds,
  studentIds,
  filters,
  extraParams: { type, queryVariables, projectGroupType },
  fields,
  grades,
  userType,
  studentCollaborators,
  type: projectType,
  portfolioId,
  curriculumProgramIds,
  roleType,
  userEntityType,
  academicYearId,
  shouldCreateProjectsForEachStudent = false,
}) => {
  return async (dispatch, getState) => {
    const selectedAcademicYearId = academicYearId
      ? academicYearId
      : getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([selectedAcademicYearId]);
    const userInfo = getUserInfo();
    const refetchQueries = [];

    const academicYearFilterIds = _.get(
      getState(),
      "project.academicYearFilterDetails.academicYearIds",
      []
    );

    switch (type) {
      case "invite_project_admin":
        refetchQueries.push({
          query: getProjectGroupProjectsQuery,
          variables: {
            projectGroupId,
            filters: {
              ...filters,
              academicYearIds,
            },
          },
        });
        refetchQueries.push({
          query: getProjectGroupProjectsCountQuery,
          variables: {
            projectGroupId,
            filters: { academicYearIds },
          },
        });

        break;
      case "student_progress_supervisor":
        refetchQueries.push({
          query: getSupervisorProjectQuery,
          variables: {
            projectGroupIds: [projectGroupId],
            staffId: supervisorId,
            searchText: "",
            skipCourseDetails: false,
          },
        });
        break;
      case "student_portfolio_project": {
        refetchQueries.push({
          query: getStudentProjectPortfolioQuery,
          variables: {
            id: portfolioId,
            projectCountFilter: {
              academicYearIds: academicYearFilterIds,
            },
            completionStatusFilters: {
              academicYearIds: academicYearId ? [academicYearId] : [],
            },
            plannerElementEvidenceFilters: {
              projectStatuses: PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS,
              plannerElement: {
                type: PORTFOLIO_LEARNING_OUTCOMES_MAP[projectGroupType],
              },
              academicYearIds: _.isEmpty(academicYearFilterIds)
                ? academicYearId
                  ? [academicYearId]
                  : []
                : academicYearFilterIds,
            },
          },
        });
        break;
      }
      case "project_dashboard": {
        refetchQueries.push({
          query: getProjectGroupProjectsWithFieldsQuery,
          variables: queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectsIdsQuery,
          variables: queryVariables.getProjectGroupProjectsIdsQueryVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectAndPortfolioCountQuery,
          variables: {
            id: projectGroupId,
            portfolioFilters: {
              academicYearIds,
            },
            projectFilters: {
              academicYearIds,
              projectsCreatedAtAcademicYearIds: academicYearFilterIds,
            },
          },
        });
        refetchQueries.push({
          query: getProjectGroupProjectCountQuery,
          variables: {
            id: projectGroupId,
            filters: {
              courses: [],
              academicYearIds,
            },
          },
        });
        break;
      }
      case "saa_project_with_yearGroup_mapped":
        refetchQueries.push(
          {
            query: getUserProjectGroupYearGroupsQuery,
            variables: {
              id: userInfo.id,
              type: userEntityType,
              filters: {
                projectGroupTypes: [projectType],
                yearGroupSearchText: "",
                yearGroupArchivalState: "ACTIVE",
              },
              gradeFilters: {
                academicYearId,
              },
              studentProjectPortfolioFilters: {
                academicYearIds,
              },
              projectFilters: {
                academicYearIds,
              },
            },
          },
          {
            query: getProjectGroupProjectCountQuery,
            variables: {
              id: projectGroupId,
              filters: {
                courses: [],
                academicYearIds,
              },
            },
          }
        );
        break;
      case "group_4_project":
      case "collaborative_sciences_project":
        refetchQueries.push(
          {
            query: getProjectGroupProjectsWithFieldsQuery,
            variables:
              queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupProjectsIdsQuery,
            variables: queryVariables.getProjectGroupProjectsIdsQueryVars,
          },
          {
            query: getProjectGroupCourseQuery,
            variables: {
              id: projectGroupId,
              projectFilters: { projectGroupId },
              projectGroupProjectFilters: { academicYearIds },
            },
          },
          {
            query: getProjectGroupProjectCountQuery,
            variables: {
              id: projectGroupId,
              filters: {
                courses: [],
                academicYearIds,
              },
            },
          }
        );
        break;
    }

    let statusObj = {};
    const {
      type: projectGroupType,
      category: projectGroupCategoryType,
    } = getCurrentProjectGroupDetails({
      state: getState(),
    });

    switch (projectGroupCategoryType) {
      case PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO:
        statusObj = {
          status: PROJECT_STATUS_DRAFT,
        };
        break;
      default:
        statusObj = {
          status: PROJECT_STATUS_NOT_STARTED,
        };
        break;
    }

    let input = {};
    switch (projectGroupType) {
      case PROJECT_GROUP_TYPE_DP_CAS:
      case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING:
      case PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT:
        input = {
          projectGroupId,
          fields,
          studentCollaborators,
          type: projectType,
          supervisorIds,
          ...statusObj,
        };
        break;
      default:
        input = {
          projectGroupId,
          supervisorId,
          supervisorIds,
          studentIds,
          fields,
          grades,
          shouldCreateProjectsForEachStudent,
          ...statusObj,
        };
        break;
    }
    try {
      return await client.mutate({
        mutation: createProjectMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries,
      });
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const bulkCreateProjects = ({
  projectGroupId,
  supervisorId,
  supervisorIds,
  studentIds,
  extraParams: { type },
  fields,
  grades,
  type: projectType,
  userEntityType,
  academicYearId,
  shouldCreateProjectsForEachStudent = false,
}) => {
  return async (dispatch, getState) => {
    const selectedAcademicYearId = academicYearId
      ? academicYearId
      : getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([selectedAcademicYearId]);
    const userInfo = getUserInfo();
    const refetchQueries = [];

    switch (type) {
      case "saa_project_with_yearGroup_mapped":
        refetchQueries.push(
          {
            query: getUserProjectGroupYearGroupsQuery,
            variables: {
              id: userInfo.id,
              type: userEntityType,
              filters: {
                projectGroupTypes: [projectType],
                yearGroupSearchText: "",
                yearGroupArchivalState: "ACTIVE",
              },
              gradeFilters: {
                academicYearId,
              },
              studentProjectPortfolioFilters: {
                academicYearIds,
              },
              projectFilters: {
                academicYearIds,
              },
            },
          },
          {
            query: getProjectGroupProjectCountQuery,
            variables: {
              id: projectGroupId,
              filters: {
                courses: [],
                academicYearIds,
              },
            },
          }
        );
        break;
    }

    const input = {
      projectGroupId,
      supervisorId,
      supervisorIds,
      studentIds,
      fields,
      grades,
      shouldCreateProjectsForEachStudent,
      status: PROJECT_STATUS_DRAFT,
    };

    try {
      return await client.mutate({
        mutation: bulkCreateProjectMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries,
      });
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const getProjectFields = ({ projectData }) => {
  return _.map(_.keys(projectData), key => {
    return {
      uid: key,
      value: projectData[key].value,
    };
  });
};

//need to change the key names i am not getting the idea what should be the name
export const getObjectIdsByDifference = ({
  minuendObjectList,
  subtrahendObjectList,
}) => {
  return _.map(
    _.differenceBy(minuendObjectList, subtrahendObjectList, "id"),
    object => object.id
  );
};

export const editProject = ({
  projectId,
  projectGroupId,
  filters,
  extraParams: { type, supervisorId, queryVariables } = {},
  previousStudents,
  updatedStudents,
  previousSupervisor,
  updatedSupervisor,
  previousStudentCollaborators,
  updatedStudentCollaborators,
  isProjectWithMultipleSupervisors,
}) => {
  return async (dispatch, getState) => {
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);
    let addedStudents = [],
      removedStudents = [],
      addedSupervisors = [],
      removedSupervisors = [],
      addedStudentCollaborators = [],
      removedStudentCollaborators = [];

    if (!_.isEmpty(updatedStudents)) {
      addedStudents = getObjectIdsByDifference({
        minuendObjectList: updatedStudents,
        subtrahendObjectList: previousStudents,
      });
      removedStudents = getObjectIdsByDifference({
        minuendObjectList: previousStudents,
        subtrahendObjectList: updatedStudents,
      });
    }

    // this will only be executed when supervisor are updated and not students
    // ,done because updating students caused setting supervisors as empty in SaA
    if (isProjectWithMultipleSupervisors) {
      if (!_.isEmpty(updatedSupervisor)) {
        addedSupervisors = getObjectIdsByDifference({
          minuendObjectList: updatedSupervisor,
          subtrahendObjectList: previousSupervisor,
        });
        removedSupervisors = getObjectIdsByDifference({
          minuendObjectList: previousSupervisor,
          subtrahendObjectList: updatedSupervisor,
        });
      } else {
        removedSupervisors = getObjectIdsByDifference({
          minuendObjectList: previousSupervisor,
          subtrahendObjectList: updatedSupervisor,
        });
        addedSupervisors = [];
      }
    } else if (!isProjectWithMultipleSupervisors) {
      if (updatedSupervisor != previousSupervisor) {
        addedSupervisors = !_.isEmpty(updatedSupervisor)
          ? [updatedSupervisor]
          : [];
        if (previousSupervisor) removedSupervisors = [previousSupervisor];
      }
    }

    if (
      !_.isEmpty(previousStudentCollaborators) ||
      !_.isEmpty(updatedStudentCollaborators)
    ) {
      addedStudentCollaborators = getObjectIdsByDifference({
        minuendObjectList: updatedStudentCollaborators,
        subtrahendObjectList: previousStudentCollaborators,
      });
      removedStudentCollaborators = getObjectIdsByDifference({
        minuendObjectList: previousStudentCollaborators,
        subtrahendObjectList: updatedStudentCollaborators,
      });
    }
    const refetchQueries = [];

    switch (type) {
      case "invite_project_admin":
        refetchQueries.push({
          query: getProjectGroupProjectsQuery,
          variables: {
            projectGroupId,
            filters: {
              ...filters,
              academicYearIds,
            },
          },
        });
        break;
      case "student_progress_supervisor":
        refetchQueries.push({
          query: getSupervisorProjectQuery,
          variables: {
            projectGroupIds: [projectGroupId],
            staffId: supervisorId,
            searchText: "",
            skipCourseDetails: false,
          },
        });
        break;
      case "project_dashboard_edit_supervisor":
      case "project_dashboard_edit_collaborators":
        refetchQueries.push({
          query: getProjectHeaderInfoQuery,
          variables: queryVariables.projectInfoQueryVar,
        });
        break;
      case "saa_project_and_header":
      case "cas_project_and_header":
        refetchQueries.push(
          {
            query: getProjectHeaderInfoQuery,
            variables: queryVariables.projectInfoQueryVar,
          },
          {
            query: getProjectDetailsQuery,
            variables: queryVariables.projectDetailsQuerVars,
            context: {
              useHttpLink: true,
            },
          },
          {
            query: getProjectStudentCollaboratorsForSplittingQuery,
            variables:
              queryVariables.projectStudentCollaboratorsForSplittingQueryVars,
            context: {
              useHttpLink: true,
            },
          }
        );
        break;
      case "saa_project_and_header_supervisor":
      case "cas_project_and_header_supervisor":
        refetchQueries.push(
          {
            query: getProjectHeaderInfoQuery,
            variables: queryVariables.projectInfoQueryVar,
          },
          {
            query: getProjectDetailsQuery,
            variables: queryVariables.projectDetailsQuerVars,
            context: {
              useHttpLink: true,
            },
          }
        );
        break;
      case "cas_project_and_header_supervisor_external":
        refetchQueries.push(
          {
            query: getProjectHeaderInfoQuery,
            variables: queryVariables.projectInfoQueryVar,
          },
          {
            query: getProjectDetailsQuery,
            variables: queryVariables.projectDetailsQuerVars,
            context: {
              useHttpLink: true,
            },
          },
          {
            query: getProjectApprovedSupervisorsQuery,
            variables: queryVariables.projectApprovedSupervisorsQueryVars,
          }
        );
        break;
      case "project_dashboard_edit_supervisor_cas_portfolio": // will be removed
        refetchQueries.push(
          {
            query: getProjectHeaderInfoQuery,
            variables: queryVariables.projectInfoQueryVar,
          },
          {
            query: getStudentPortfolioSupervisorsQuery,
            variables: queryVariables.portfolioSupervisorQueryVar,
          }
        );
        break;
      case "project_dashboard_edit_supervisor_cas_experiences": // will be removed
        refetchQueries.push(
          {
            query: getProjectHeaderInfoQuery,
            variables: queryVariables.projectInfoQueryVar,
          },
          {
            query: getProjectGroupProjectSupervisorsQuery,
            variables: queryVariables.projectGroupProjectSupervisorsVar,
          }
        );
        break;
      case "saa_dashboard":
        refetchQueries.push({
          query: getProjectGroupProjectsWithFieldsQuery,
          variables: queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
        });

        break;
      case "project_dashboard": {
        refetchQueries.push({
          query: getProjectGroupProjectsWithFieldsQuery,
          variables: queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
        });
        const academicYearFilterIds = _.get(
          getState(),
          "project.academicYearFilterDetails.academicYearIds",
          []
        );
        refetchQueries.push({
          query: getProjectGroupProjectAndPortfolioCountQuery,
          variables: {
            id: projectGroupId,
            portfolioFilters: {
              academicYearIds,
            },
            projectFilters: {
              academicYearIds,
              projectsCreatedAtAcademicYearIds: academicYearFilterIds,
            },
          },
        });
        break;
      }
      case "group_4_project":
      case "collaborative_sciences_project":
        refetchQueries.push(
          {
            query: getProjectGroupProjectsWithFieldsQuery,
            variables:
              queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupCourseQuery,
            variables: {
              id: projectGroupId,
              projectFilters: { projectGroupId },
              projectGroupProjectFilters: { academicYearIds },
            },
          }
        );
        break;
    }

    try {
      await client.mutate({
        mutation: editProjectMutation,
        variables: {
          projectId,
          addedSupervisors,
          removedSupervisors,
          addedStudents,
          removedStudents,
          addedStudentCollaborators,
          removedStudentCollaborators,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const removeProjects = ({
  projectIds,
  projectGroupId,
  filters = {},
  staffId = "",
  searchText = "",
  extraParams: { type, queryVariables },
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);
    const refetchQueries = [];
    let toastMsg = null;

    switch (type) {
      case "invite_project_admin":
        refetchQueries.push({
          query: getProjectGroupProjectsQuery,
          variables: {
            projectGroupId,
            filters: {
              ...filters,
              academicYearIds,
            },
          },
        });
        refetchQueries.push({
          query: getProjectGroupProjectsCountQuery,
          variables: {
            projectGroupId,
            filters: { academicYearIds },
          },
        });
        break;
      case "student_progress_supervisor":
        refetchQueries.push({
          query: getSupervisorProjectQuery,
          variables: {
            projectGroupIds: [projectGroupId],
            staffId,
            searchText,
            skipCourseDetails: false,
          },
        });
        break;
      case "cas_experience_and_projects":
      case "cas_experience_and_projects_students_screen":
        refetchQueries.push({
          query: getStudentProjectPortfolioQuery,
          variables:
            queryVariables.getProjectGroupStudentProjectPortfolioQueryVars,
        });
        break;
      case "saa_project_dashboard": {
        refetchQueries.push(
          {
            query: getStudentPortfolioProjectsQuery,
            variables: queryVariables.getStudentPortfolioProjectsQueryVars,
          },
          {
            query: getStudentProjectPortfolioQuery,
            variables:
              queryVariables.getProjectGroupStudentProjectPortfolioQueryVars,
          },

          {
            query: getStudentPortfolioInsightsProjectsQuery,
            variables:
              queryVariables.getStudentPortfolioInsightsProjectsQueryVars,
            context: { useHttpLink: true },
          },
          {
            query: getLearningOutcomesWithEvidencesInsightsQuery,
            variables:
              queryVariables.getLearningOutcomesWithEvidencesInsightsQueryVars,
          }
        );
        toastMsg = "toastMsgs:activity_successfully_deleted";

        break;
      }
      case "saa_experiences_dashboard": {
        refetchQueries.push(
          {
            query: getProjectGroupProjectsWithFieldsQuery,
            variables:
              queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupProjectsIdsQuery,
            variables: queryVariables.getProjectGroupProjectsIdsQueryVars,
          },
          {
            query: getUserProjectGroupYearGroupsQuery,
            variables: queryVariables.getUserProjectGroupYearGroupsQueryVars,
          },
          {
            query: getProjectGroupProjectCountQuery,
            variables: queryVariables.getProjectGroupProjectCountVars,
          },
          {
            query: getProjectGroupProjectAndPortfolioCountQuery,
            variables:
              queryVariables.getProjectGroupProjectAndPortfolioCountVars,
          }
        );
        toastMsg = "toastMsgs:activity_successfully_deleted";

        break;
      }
      case "project_dashboard":
        refetchQueries.push({
          query: getProjectGroupProjectsWithFieldsQuery,
          variables: queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectsIdsQuery,
          variables: queryVariables.getProjectGroupProjectsIdsQueryVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectAndPortfolioCountQuery,
          variables: queryVariables.getProjectGroupProjectAndPortfolioCountVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectCountQuery,
          variables: queryVariables.getProjectGroupProjectCountVars,
        });
        break;
      case "cas_project_dashboard": {
        refetchQueries.push(
          {
            query: getStudentPortfolioProjectsQuery,
            variables: queryVariables.getStudentPortfolioProjectsQueryVars,
          },
          {
            query: getStudentProjectPortfolioQuery,
            variables:
              queryVariables.getProjectGroupStudentProjectPortfolioQueryVars,
          }
        );
        refetchQueries.push(
          {
            query: getStudentPortfolioInsightsProjectsQuery,
            variables:
              queryVariables.getStudentPortfolioInsightsProjectsQueryVars,
            context: { useHttpLink: true },
          },
          {
            query: getLearningOutcomesWithEvidencesInsightsQuery,
            variables:
              queryVariables.getLearningOutcomesWithEvidencesInsightsQueryVars,
          }
        );
        toastMsg =
          projectGroupType == PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT
            ? "toastMsgs:engagement_successfully_deleted"
            : "toastMsgs:experience_successfully_deleted";
        break;
      }
      case "cas_experiences_dashboard": {
        refetchQueries.push({
          query: getProjectGroupProjectsWithFieldsQuery,
          variables: queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectsIdsQuery,
          variables: queryVariables.getProjectGroupProjectsIdsQueryVars,
        });
        refetchQueries.push({
          query: getProjectGroupProjectAndPortfolioCountQuery,
          variables: queryVariables.getProjectGroupProjectAndPortfolioCountVars,
        });
        toastMsg =
          projectGroupType == PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT
            ? "toastMsgs:engagement_successfully_deleted"
            : "toastMsgs:experience_successfully_deleted";
        break;
      }
      case "group_4_project":
      case "collaborative_sciences_project":
        refetchQueries.push(
          {
            query: getProjectGroupProjectsWithFieldsQuery,
            variables:
              queryVariables.getProjectGroupProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupProjectsIdsQuery,
            variables: queryVariables.getProjectGroupProjectsIdsQueryVars,
          },
          {
            query: getProjectGroupCourseQuery,
            variables: {
              id: projectGroupId,
              projectFilters: { projectGroupId },
              projectGroupProjectFilters: { academicYearIds },
            },
          },
          {
            query: getProjectGroupProjectCountQuery,
            variables: {
              id: projectGroupId,
              filters: {
                courses: [],
                academicYearIds,
              },
            },
          }
        );
        break;
    }
    try {
      await client.mutate({
        mutation: removeProjectsMutation,
        variables: {
          projectIds,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      if (toastMsg) {
        dispatch(setToastMsg({ msg: toastMsg, type: "success" }));
      }
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const restoreProjects = ({
  type,
  projectGroupType,
  projectIds,
  toggleLoader = null,
  queryVars: {
    getProjectGroupProjectAndPortfolioCountVars = {},
    getProjectGroupDeletedProjectsWithFieldsQueryVars = {},
    getProjectGroupProjectsIdsQueryVars = {},
    getProjectGroupProjectsWithStudentsIdsQueryVars = {},
  } = {},
  projectGroupCategoryType,
}) => {
  return async (dispatch, getState) => {
    const refetchQueries = [];
    const academicYearId = getSelectedAcademicYearId(getState());

    switch (type) {
      case "projects_bin":
        refetchQueries.push(
          {
            query: getProjectGroupProjectAndPortfolioCountQuery,
            variables: getProjectGroupProjectAndPortfolioCountVars,
          },
          {
            query: getProjectGroupDeletedProjectsWithFieldsQuery,
            variables: getProjectGroupDeletedProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupProjectsIdsQuery,
            variables: getProjectGroupProjectsIdsQueryVars,
          }
        );
        break;
      case "subjects_type_project_bin": {
        refetchQueries.push(
          {
            query: getProjectGroupProjectAndPortfolioCountQuery,
            variables: getProjectGroupProjectAndPortfolioCountVars,
          },
          {
            query: getProjectGroupDeletedProjectsWithFieldsQuery,
            variables: getProjectGroupDeletedProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupProjectsIdsQuery,
            variables: getProjectGroupProjectsIdsQueryVars,
          },
          {
            query: getProjectGroupProjectsWithStudentsIdsQuery,
            variables: getProjectGroupProjectsWithStudentsIdsQueryVars,
          }
        );
        break;
      }
      default:
        break;
    }

    const projectIdsArray = _.isArray(projectIds) ? projectIds : [projectIds];
    const count = _.size(projectIdsArray);

    const toastMsg = _.isEqual(
      projectGroupType,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON
    )
      ? count > 1
        ? "toastMsgs:activity_successfully_restored_plural"
        : "toastMsgs:activity_successfully_restored"
      : _.isEqual(projectGroupType, PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT)
      ? count > 1
        ? "toastMsgs:engagement_successfully_restored_plural"
        : "toastMsgs:engagement_successfully_restored"
      : _.isEqual(
          projectGroupType,
          PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT
        )
      ? count > 1
        ? "toastMsgs:project_successfully_restored_plural"
        : "toastMsgs:project_successfully_restored"
      : count > 1
      ? "toastMsgs:experience_successfully_restored_plural"
      : "toastMsgs:experience_successfully_restored";

    try {
      if (toggleLoader) toggleLoader(true);
      if (type === "project_details") {
        const variables = {
          projectId: _.first(projectIdsArray),
          projectGroupType,
          projectGroupCategoryType,
          academicYearId,
        };
        const data = getProjectHeaderInfoFromCache(variables);
        const updatedData = update(data, {
          node: {
            isDeleted: { $set: false },
          },
        });

        writeProjectHeaderInfoInCache({
          ...variables,
          data: updatedData,
        });
      }

      await client.mutate({
        mutation: restoreProjectsMutation,
        variables: {
          projectIds: projectIdsArray,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      dispatch(
        setToastMsg({
          msg: toastMsg,
          type: "success",
        })
      );
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    } finally {
      if (toggleLoader) toggleLoader(false);
    }
  };
};

export const archiveProject = ({
  projectId,
  isArchived,
  type,
  projectGroupType = "",
  projectGroupCategoryType,
  t,
  queryVars: {
    getProjectGroupProjectsWithFieldsQueryVars = {},
    getProjectGroupProjectsIdsQueryVars = {},
    getStudentPortfolioProjectsQueryVars = {},
    getProjectGroupStudentProjectPortfolioQueryVars = {},
    getStudentPortfolioInsightsProjectsQueryVars = {},
    getLearningOutcomesWithEvidencesInsightsQueryVars = {},
  } = {},
  toggleLoader = _.noop,
}) => {
  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());
    const refetchQueries = [];

    switch (type) {
      case "projects_dashboard":
        refetchQueries.push(
          {
            query: getProjectGroupProjectsWithFieldsQuery,
            variables: getProjectGroupProjectsWithFieldsQueryVars,
          },
          {
            query: getProjectGroupProjectsIdsQuery,
            variables: getProjectGroupProjectsIdsQueryVars,
          }
        );
        break;
      case "student_portfolio":
        refetchQueries.push(
          {
            query: getStudentPortfolioProjectsQuery,
            variables: getStudentPortfolioProjectsQueryVars,
          },
          {
            query: getStudentProjectPortfolioQuery,
            variables: getProjectGroupStudentProjectPortfolioQueryVars,
          },
          {
            query: getStudentPortfolioInsightsProjectsQuery,
            variables: getStudentPortfolioInsightsProjectsQueryVars,
            context: { useHttpLink: true },
          },
          {
            query: getLearningOutcomesWithEvidencesInsightsQuery,
            variables: getLearningOutcomesWithEvidencesInsightsQueryVars,
          }
        );
        break;
      default:
        break;
    }

    try {
      toggleLoader(true);

      if (type === "project_details") {
        cache.updateQuery(
          {
            query: getProjectHeaderInfoQuery,
            variables: getProjectHeaderInfoVariables({
              projectId,
              projectGroupType,
              projectGroupCategoryType,
              academicYearId,
            }),
          },
          data => {
            return update(data, {
              node: {
                isArchived: { $set: isArchived },
                archivedAt: { $set: null },
                archivedBy: { $set: null },
              },
            });
          }
        );
      }

      await client.mutate({
        mutation: updateProjectFieldMutation,
        variables: {
          input: { id: projectId, isArchived },
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:label_has_been_successfully_actionName",
          locale_params: [
            {
              key: "label",
              value: getArchivedLabel({
                projectGroupType,
                t,
                isToast: true,
              }),
              isPlainText: true,
            },
            {
              key: "actionName",
              value: isArchived ? "common:archived" : "toastMsgs:unarchived",
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
    } catch (e) {
      console.warn(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } finally {
      toggleLoader(false);
    }
  };
};

export const updateProjectGroup = ({
  input,
  extraParams: { getUserProjectGroupsExtraParams },
}) => {
  return async dispatch => {
    const cachedData = readProjectGroupBasicDetailsFromCache({ id: input.id });

    let updatedData = cachedData;

    _.forEach(input, (value, key) => {
      switch (key) {
        case "isEnabled":
          updatedData = update(updatedData, {
            isEnabled: { $set: value },
          });
          break;
      }
    });

    writeProjectGroupBasicDetailsInCache({
      id: input.id,
      data: updatedData,
    });

    /*******************************************************************************************************
     * Refetching userProjectGroups, because when PG's are toggled from YG manager, childrenPage doesnot re-render
     * and hence the PG's are not updated in the store. So, refetching the query to update the store.
     ********************************************************************************************************/

    try {
      await client.mutate({
        mutation: updateProjectGroupMutation,
        variables: {
          input,
        },
        refetchQueries: [
          {
            query: getUserProjectGroupsQuery,
            variables: getUserProjectGroupsExtraParams,
          },
        ],
        awaitRefetchQueries: true,
      });
    } catch (e) {
      writeProjectGroupBasicDetailsInCache({
        id: input.id,
        data: cachedData,
      });

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};
export const ProjectPlannerContext = createContext({});

export const createProjectGroupGuidingQuestion = ({
  question,
  projectGroupId,
  grades,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;

    const curriculumProgramIds = _.get(
      getState(),
      "platform.currentCurriculumProgram.id"
    );
    try {
      await client.mutate({
        mutation: createProjectGroupGuidingQuestionMutation,
        variables: {
          question,
          projectGroupId,
          grades: _.isEmpty(grades) ? null : grades,
        },
        update: (cache, { data }) => {
          const cachedData = getGuidingQuestionsFromCache({ projectGroupId });
          const gradesArray = _.get(
            getOrganizationGradesFromCache({
              id: organizationId,
              filters: {
                curriculumProgramIds,
              },
            }),
            "grades",
            []
          );
          const guidingQuestionId = _.get(
            data,
            "documentation.createProjectGroupGuidingQuestion.id",
            ""
          );
          const selectedGrades = _.filter(gradesArray, grade =>
            _.includes(grades, grade.id)
          );
          writeGuidingQuestionsInCache({
            variables: { projectGroupId },
            data: update(cachedData, {
              node: {
                guidingQuestions: {
                  $push: [
                    {
                      question,
                      grades: selectedGrades,
                      id: guidingQuestionId,
                      __typename: "ProjectGroupGuidingQuestion",
                    },
                  ],
                },
              },
            }),
          });
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      if (e.message == REFRESH_PAGE_ERROR) {
        persistor.purge().then(() => {
          window.location.reload();
        });
        return;
      }
    }
  };
};

export const deleteProjectGroupGuidingQuestion = ({ id, projectGroupId }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: deleteProjectGroupGuidingQuestionMutation,
        variables: {
          id,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getGuidingQuestionsQuery,
            variables: { projectGroupId },
          },
        ],
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      if (e.message == REFRESH_PAGE_ERROR) {
        persistor.purge().then(() => {
          window.location.reload();
        });
        return;
      }
    }
  };
};

export const updateProjectFieldValuesForStudentAndProjectGroups = ({
  projectGroupTypes,
  studentId,
  fieldUpdateData,
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateProjectFieldValuesForStudentAndProjectGroupsMutation,
        variables: {
          projectGroupTypes,
          studentId,
          fieldUpdateData,
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateProjectGroupGuidingQuestion = ({ id, question, grades }) => {
  return async dispatch => {
    const cachedData = getGuidingQuestionFragmentFromCache({ id });
    try {
      writeGuidingQuestionFragmentInCache({
        id,
        data: update(cachedData, {
          question: { $set: question },
          grades: {
            $set: grades,
          },
        }),
      });
      const gradeAdded = _.map(
        _.differenceBy(grades, cachedData.grades, "id"),
        item => item.id
      );

      const gradeRemoved = _.map(
        _.differenceBy(cachedData.grades, grades, "id"),
        item => item.id
      );

      await client.mutate({
        mutation: updateProjectGroupGuidingQuestionMutaion,
        variables: {
          id,
          question,
          gradeAdded,
          gradeRemoved,
        },
      });
    } catch (e) {
      writeGuidingQuestionFragmentInCache({ id, data: cachedData });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      if (e.message == REFRESH_PAGE_ERROR) {
        persistor.purge().then(() => {
          window.location.reload();
        });
        return;
      }
    }
  };
};

export const reorderProjectGroupGuidingQuestion = ({
  fromIndex,
  toIndex,
  id,
  putAfterItemId,
  projectGroupId,
}) => async dispatch => {
  const cachedData = getGuidingQuestionsFromCache({ projectGroupId });
  const guidingQuestions = _.get(cachedData, "node.guidingQuestions", []);

  const updatedGuidingQuestions = moveElementInArray({
    array: guidingQuestions,
    fromIndex,
    toIndex,
  });

  writeGuidingQuestionsInCache({
    variables: { projectGroupId },
    data: update(cachedData, {
      node: {
        guidingQuestions: { $set: updatedGuidingQuestions },
      },
    }),
  });
  try {
    await client.mutate({
      mutation: reorderProjectGroupGuidingQuestionMutation,
      variables: {
        id,
        putAfterItemId,
      },
    });
  } catch (e) {
    writeGuidingQuestionsInCache({
      variables: { projectGroupId },
      data: cachedData,
    });
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

export const updateGuidingQuestionInCache = ({
  id,
  changedData,
  changedKey,
}) => {
  const cachedData = getGuidingQuestionFragmentFromCache({ id });
  writeGuidingQuestionFragmentInCache({
    id,
    data: update(cachedData, {
      [changedKey]: { $set: changedData },
    }),
  });
};

const getProjectsUsersList = ({ projects, userType }) => {
  const users = _.reduce(
    projects,
    (result, project) => {
      const usersList = _.get(project, `node.${userType}`, []);
      if (_.isNil(usersList)) return result;
      if (_.isArray(usersList)) {
        _.forEach(usersList, user => {
          if (!_.find(result, { id: _.get(user, `id`) })) {
            const { alertTypes } = user;
            result.push({
              ..._.omit(user, ["alertTypes"]),
              ...(userType === "students" && { alertTypes }),
            });
          }
        });

        return result;
      } else {
        if (!_.find(result, { id: _.get(usersList, `id`) })) {
          const { alertTypes } = usersList;

          result.push({
            ..._.omit(usersList, ["alertTypes"]),
            ...(userType === "students" && { alertTypes }),
          });
        }

        return result;
      }
    },
    []
  );
  const sortedUsers = getSortedUsersList({ usersList: users });

  return _.filter(sortedUsers, item => item.id);
};

const getAdvisorsList = ({ projects }) => {
  const users = _.reduce(
    projects,
    (result, project) => {
      const staffData = _.get(project, `node.staff`, {});

      if (!_.find(result, { id: _.get(staffData, `id`) })) {
        const { isArchived = false, isArchivedV2 = false } = staffData || {};

        result.push({
          ...staffData,
          isArchived,
          isArchivedV2,
        });
      }
      return result;
    },
    []
  );

  const sortedUsers = getSortedUsersList({ usersList: users });

  return _.filter(sortedUsers, item => item.id);
};

export const getProjectsUsersListMemoized = _.memoize(
  params => getProjectsUsersList(params),
  params => {
    const { projects, userType } = params;

    return JSON.stringify({
      projects: _.map(projects, project => {
        const { node } = project;

        if (_.isArray(node[userType])) {
          return _.map(node[userType], user =>
            _.pick(user, ["id", "isArchived", "isArchivedV2"])
          );
        } else {
          if (node[userType]) {
            return _.pick(node[userType], ["id", "isArchived", "isArchivedV2"]);
          } else {
            return "";
          }
        }
      }),
      userType,
    });
  }
);

export const getAdvisorsListMemoized = _.memoize(
  params => getAdvisorsList(params),
  params => {
    const { projects } = params;

    return JSON.stringify({
      projects: _.map(projects, project => {
        const { node } = project;

        return _.pick(node.staff, ["id", "isArchived", "isArchivedV2"]);
      }),
    });
  }
);

export const updateCreateProjectDataInRedux = data => {
  return {
    type: UPDATE_CREATE_PROJECT_DATA_IN_REDUX,
    data,
  };
};

export const resetCreateProjectDataInRedux = data => {
  return {
    type: RESET_CREATE_PROJECT_DATA_IN_REDUX,
    data,
  };
};

export const updateRightSidebarTab = data => {
  return {
    type: UPDATE_RIGHT_SIDEBAR_TAB,
    data,
  };
};

export const updateYearGroupDetails = data => {
  return {
    type: UPDATE_YEAR_GROUP_DETAILS,
    data,
  };
};

export const updateProjectModalAndDialogueValue = data => {
  return {
    type: UPDATE_PROJECT_MODAL_AND_DIALOGUE_VALUE,
    data,
  };
};

export const setReflectionSearchText = data => {
  return {
    type: SET_REFLECTION_SEARCH_TEXT,
    data,
  };
};

export const setIsProjectDisabled = data => {
  return {
    type: IS_PROJECT_DISABLED,
    data,
  };
};

export const setG4ProjectCreationStudentSearchText = data => {
  return {
    type: SET_G4_PROJECT_CREATION_STUDENT_SEARCH_TEXT,
    data,
  };
};

export const updateRoleValue = data => {
  return {
    type: UPDATE_ROLE_VALUE,
    data,
  };
};

export const resetRoleValue = data => {
  return {
    type: RESET_ROLE_VALUE,
    data,
  };
};

export const updateDashboardFilters = data => {
  return {
    type: UPDATE_DASHBOARD_FILTERS,
    data,
  };
};

export const updateInsightsFilters = data => {
  return {
    type: UPDATE_INSIGHTS_FILTERS,
    data,
  };
};

export const resetInsightsFilters = data => {
  return {
    type: RESET_INSIGHTS_FILTERS,
    data,
  };
};

export const updatePortfolioInsightsValues = data => {
  return {
    type: PORTFOLIO_INSIGHTS_VALUES,
    data,
  };
};

// created action dispatcher for projectGroupDetails
export const updateProjectGroupDetails = data => {
  return {
    type: UPDATE_PROJECT_GROUP_DETAILS,
    data,
  };
};

export const updateOverallProgressIndicators = data => {
  return {
    type: UPDATE_OVERALL_PROGRESS_INDICATORS,
    data,
  };
};

export const updateLearningOutcomeIndicators = data => {
  return {
    type: UPDATE_LEARNING_OUTCOME_INDICATORS,
    data,
  };
};

export const updateTotalProjectsCountForBulkActions = data => {
  return {
    type: UPDATE_TOTAL_PROJECTS_COUNT_FOR_BULK_ACTIONS,
    data,
  };
};

export const setIsProjectDeleted = data => {
  return {
    type: IS_PROJECT_DELETED,
    data,
  };
};

export const updateAcademicYearFilter = data => {
  return {
    type: ACADEMIC_YEAR_FILTER,
    data,
  };
};

const REDUCER_HANDLERS = {
  [RESET_CREATE_PROJECT_DATA_IN_REDUX]: state => {
    return update(state, {
      createProjectData: { $set: _.cloneDeep(initialState.createProjectData) },
    });
  },
  [UPDATE_CREATE_PROJECT_DATA_IN_REDUX]: (state, action) => {
    const params = action.data;
    _.map(_.keys(params), key => {
      state = update(state, {
        createProjectData: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_RIGHT_SIDEBAR_TAB]: (state, action) => {
    return update(state, {
      sidebarTab: { $set: action.data },
    });
  },
  [UPDATE_YEAR_GROUP_DETAILS]: (state, action) => {
    const params = action.data;
    _.map(_.keys(params), key => {
      state = update(state, {
        yearGroupDetails: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_PROJECT_MODAL_AND_DIALOGUE_VALUE]: (state, action) => {
    return update(state, {
      projectModelAndDialogueValue: { $set: action.data },
    });
  },
  [SET_REFLECTION_SEARCH_TEXT]: (state, action) => {
    return update(state, {
      reflectionScreenData: { searchText: { $set: action?.data } },
    });
  },
  [IS_PROJECT_DISABLED]: (state, action) => {
    return update(state, {
      isProjectDisabled: { $set: action.data },
    });
  },

  [SET_G4_PROJECT_CREATION_STUDENT_SEARCH_TEXT]: (state, action) => {
    return update(state, {
      g4ProjectCreationData: { studentSearchText: { $set: action?.data } },
    });
  },
  [UPDATE_ROLE_VALUE]: (state, action) => {
    return update(state, {
      role: { $set: action.data },
    });
  },
  [RESET_ROLE_VALUE]: (state, action) => {
    return update(state, {
      role: { $set: initialState.role },
    });
  },
  [UPDATE_DASHBOARD_FILTERS]: (state, action) => {
    const params = action.data;
    _.map(_.keys(params), key => {
      state = update(state, {
        dashboardFilters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_INSIGHTS_FILTERS]: (state, action) => {
    const params = action.data;
    _.map(_.keys(params), key => {
      state = update(state, {
        insightsFilters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [PORTFOLIO_INSIGHTS_VALUES]: (state, action) => {
    state = update(state, {
      portfolioInsightsValues: { $set: action.data },
    });
    return state;
  },
  [RESET_INSIGHTS_FILTERS]: state => {
    state = update(state, {
      insightsFilters: { $set: {} },
    });
    return state;
  },
  [UPDATE_PROJECT_GROUP_DETAILS]: (state, action) => {
    const params = action.data;
    _.map(_.keys(params), key => {
      state = update(state, {
        projectGroupDetails: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_OVERALL_PROGRESS_INDICATORS]: (state, action) => {
    state = update(state, {
      overallProgressIndicators: { $set: action?.data },
    });
    return state;
  },
  [UPDATE_LEARNING_OUTCOME_INDICATORS]: (state, action) => {
    state = update(state, {
      learningOutcomeIndicators: { $set: action?.data },
    });
    return state;
  },
  [UPDATE_TOTAL_PROJECTS_COUNT_FOR_BULK_ACTIONS]: (state, action) => {
    state = update(state, {
      totalProjectsCountForBulkActions: { $set: action?.data },
    });
    return state;
  },
  [IS_PROJECT_DELETED]: (state, action) => {
    state = update(state, {
      isProjectDeleted: { $set: action?.data },
    });
    return state;
  },
  [ACADEMIC_YEAR_FILTER]: (state, action) => {
    const {
      academicYearIds = [],
      isCurrentAcademicYearSelected = false,
      academicYearName = "",
    } = action?.data || {};
    state = update(state, {
      academicYearFilterDetails: {
        academicYearIds: { $set: academicYearIds },
        isCurrentAcademicYearSelected: { $set: isCurrentAcademicYearSelected },
        academicYearName: { $set: academicYearName },
      },
    });
    return state;
  },
};

const initialState = {
  createProjectData: {},
  sidebarTab: null,
  projectModelAndDialogueValue: {},
  yearGroupDetails: {},
  reflectionScreenData: { searchText: "" },
  isProjectDisabled: false,
  g4ProjectCreationData: { studentSearchText: "" },
  dashboardFilters: {},
  role: null,
  projectGroupDetails: {},
  insightsFilters: {},
  portfolioInsightsValues: {},
  overallProgressIndicators: {},
  learningOutcomeIndicators: {},
  isProjectDeleted: false,
  academicYearFilterDetails: {},
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const updateStudentProjectPortfolioField = params => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateStudentProjectPortfolioMutation,
        variables: params,
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createStudentProjectPortfolioFeedback = ({ input }) => {
  return async (dispatch, getState) => {
    const {
      title,
      parentId,
      parentType,
      isPrivate,
      userId,
      attachments,
    } = input;

    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const portfolioCachedData = getStudentProjectPortfolioProgressFragmentInCache(
      {
        id: input.parentId,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      }
    );

    writeStudentProjectPortfolioProgressFragmentInCache({
      id: input.parentId,
      data: update(portfolioCachedData, {
        feedback: {
          $set: {
            totalCount:
              _.get(portfolioCachedData, "feedback.totalCount", 0) + 1,
            __typename: "PostConnection",
          },
        },
      }),
      variables: {
        completionStatusFilters: {
          academicYearIds: [academicYearId],
        },
      },
    });

    try {
      await client.mutate({
        mutation: createProcessJournalMutation,
        variables: {
          input: {
            title,
            attachments,
            state: "PUBLISHED",
            createdBy: userId,
            parentId,
            parentType,
            isHiddenFromStudents: isPrivate,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentProjectPortfolioFeedbackQuery,
            variables: {
              id: input.parentId,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:added", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      writeStudentProjectPortfolioProgressFragmentInCache({
        id: input.parentId,
        data: portfolioCachedData,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateStudentProjectPortfolioFeedback = ({ input }) => {
  return async dispatch => {
    const {
      title,
      isPrivate,
      userId,
      removedAttachments,
      addedAttachments,
      id,
      portfolioId,
    } = input;

    const attachmentsObject = {
      removeAttachmentIds: removedAttachments,
      addAttachments: addedAttachments,
    };

    try {
      await client.mutate({
        mutation: updateProcessJournalMutation,
        variables: {
          input: {
            title,
            ...attachmentsObject,
            postId: id,
            state: "PUBLISHED",
            isHiddenFromStudents: isPrivate,
            updatedBy: userId,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentProjectPortfolioFeedbackQuery,
            variables: {
              id: portfolioId,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:updated", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteStudentProjectPortfolioFeedback = ({ id, portfolioId }) => {
  return async (dispatch, getState) => {
    const academicYearSelected = getSelectedAcademicYear(getState());

    const { id: academicYearId } = academicYearSelected;

    const portfolioCachedData = getStudentProjectPortfolioProgressFragmentInCache(
      {
        id: portfolioId,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      }
    );

    writeStudentProjectPortfolioProgressFragmentInCache({
      id: portfolioId,
      data: update(portfolioCachedData, {
        feedback: {
          $set: {
            totalCount:
              _.get(portfolioCachedData, "feedback.totalCount", 1) - 1,
            __typename: "PostConnection",
          },
        },
      }),
      variables: {
        completionStatusFilters: {
          academicYearIds: [academicYearId],
        },
      },
    });

    try {
      await client.mutate({
        mutation: deleteProcessJournalMutation,
        variables: {
          id,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentProjectPortfolioFeedbackQuery,
            variables: {
              id: portfolioId,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      writeStudentProjectPortfolioProgressFragmentInCache({
        id: portfolioId,
        data: portfolioCachedData,
        variables: {
          completionStatusFilters: {
            academicYearIds: [academicYearId],
          },
        },
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateBadgeCountOnDeleteInProjectDetailsCache = ({
  projectId,
  type,
  projectGroupType,
  academicYearId,
}) => {
  const projectDetails = getProjectDetailsFromCache({
    projectId,
    projectGroupType,
    academicYearId,
  });

  const totalUnreadPostCount = _.get(
    projectDetails,
    "node.notificationBadgeCounts.unreadPostCount",
    0
  );

  const totalUnreadAcademicHonestyCount = _.get(
    projectDetails,
    "node.notificationBadgeCounts.unreadAcademicHonestyCount",
    0
  );

  if (!_.isEmpty(projectDetails)) {
    writeProjectDetailsInCache({
      projectId,
      academicYearId,
      projectGroupType,
      data: update(projectDetails, {
        node: {
          totalUnreadPostCount: {
            $set:
              type === "POST" || type === "MESSAGE"
                ? totalUnreadPostCount - 1
                : totalUnreadPostCount,
          },
          totalUnreadAcademicHonestyCount: {
            $set:
              type === "PROJECT_ACADEMIC_HONESTY"
                ? totalUnreadAcademicHonestyCount - 1
                : totalUnreadAcademicHonestyCount,
          },
        },
      }),
    });
  }
};

export const FieldComponentContext = createContext();

export const constructNestedTemplateMemoize = _.memoize(
  params => constructNestedTemplate(params),
  ({ projectFieldData, template }) =>
    JSON.stringify({
      filedIds: _.map(projectFieldData, item => item.id),
      template,
    })
);

const alphaBetRegex = /^[A-Za-z]$/;

export const checkIfDisplaySequenceIsFlipped = ({ categories, labelPath }) => {
  const categoryLabelWithSequenceOne = _.get(
    _.find(categories, { displaySequence: 1 }),
    labelPath,
    ""
  );

  // Check if the sequence is flipped
  if (!alphaBetRegex.test(categoryLabelWithSequenceOne)) {
    return categoryLabelWithSequenceOne !== "1";
  }

  return categoryLabelWithSequenceOne !== "A";
};

export const getFinalGradeCriteria = ({ data, projectGroupType, t }) => {
  const academicCriteriaSetId = _.get(data, "node.id", "");
  const categories = _.get(data, "node.categories", []);

  const sortedCategories = _.sortBy(categories, "displaySequence");
  const isNewDisplaySequence = checkIfDisplaySequenceIsFlipped({
    categories: sortedCategories,
    labelPath: "label",
  });

  const isTOKProjectGroup = _.includes(
    [PROJECT_GROUP_TYPE_DP_TOK_ESSAY, PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION],
    projectGroupType
  );

  const label = isTOKProjectGroup ? t("common:grade") : undefined;

  let highestGrade;

  if (isNewDisplaySequence) {
    highestGrade = _.get(sortedCategories, "0.label", "");
  } else {
    highestGrade = _.get(_.last(sortedCategories), "label", "");
  }

  // This is the corresponding highestMarks - difference in numeric between A(as 65 is ASCII for A) and the highest grade.
  let highestMark;
  if (alphaBetRegex.test(highestGrade)) {
    highestMark = highestGrade.toUpperCase().charCodeAt(0) - 65 + 1;
  } else {
    highestMark = _.toNumber(highestGrade);
  }

  const academicCriteriaValues = _.map(sortedCategories, category => {
    const { label, id, description } = category;
    return {
      abbreviation: label,
      description, // skip for now
      label,
      id,
      displaySequence: category?.displaySequence,
    };
  });

  if (isTOKProjectGroup) {
    academicCriteriaValues.push({
      abbreviation: "-",
      description: "-",
      label: "-",
      id: null,
    });
  }

  const finalGradeDescriptors = _.map(academicCriteriaValues, item => {
    return {
      ...item,
      id: item?.id,
      label: item?.description,
      displaySequence: item?.displaySequence,
      achievementLevel: {
        label: item?.abbreviation,
      },
    };
  });

  return {
    id: academicCriteriaSetId,
    objectiveRubricDescriptors: finalGradeDescriptors,
    highestGrade,
    highestMark,
    parent: null,
    type: projectGroupType,
    academicCriteriaValues,
    subType: projectGroupType,
    criteriaType: "CRITERIA_RUBRIC_FINAL_GRADE",
    subText: FINAL_GRADE_SUBTEXT[projectGroupType]
      ? t(FINAL_GRADE_SUBTEXT[projectGroupType])
      : undefined,
    label,
    isFinalGrade: true,
  };
};

export const getFinalGradeCriteriaMemoized = _.memoize(
  params => getFinalGradeCriteria(params),
  params => JSON.stringify(params)
);

export const isIEAssessment = ({ projectGroupSubType }) => {
  return _.includes(
    [
      PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT,
      PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT,
    ],
    projectGroupSubType
  );
};

export const isStudentIEAssessment = ({ role, projectGroupSubType }) => {
  return (
    _.isEqual(role, ROLE_STUDENT) && isIEAssessment({ projectGroupSubType })
  );
};

export const getPlannerElementFilters = ({
  plannerElementFilters,
  courseId,
  academicYearId,
}) => {
  if (plannerElementFilters) {
    const type = _.get(plannerElementFilters, "associatedParents.type", "");

    switch (type) {
      case "SUBJECT": {
        const courseDetails = getCourseDetailsFromCache({
          id: courseId,
          courseGradeFilters: {
            academicYearId,
          },
        });

        const subjectId = _.get(
          _.first(_.get(courseDetails, "subjects", [])),
          "id",
          ""
        );

        return _.merge(plannerElementFilters, {
          associatedParents: { ids: [subjectId] },
        });
      }

      default:
        return {};
    }
  } else {
    return {};
  }
};

export const getStimuliParentType = params => {
  const data = getProjectStudentInfoFragmentFromCache(params);

  const subjectLevelTag = getSubjectLevelTag({
    student: _.get(data, "students.0", {}),
  });

  const parentType = _.isEqual(subjectLevelTag, SL_LABEL)
    ? ATTACHMENT_TYPE_PROJECT_GROUP_SL_STIMULI
    : ATTACHMENT_TYPE_PROJECT_GROUP_HL_STIMULI;

  return parentType;
};

export const getAutoCheckSimilaritySettingName = ({
  projectGroupSubType,
  curriculumProgramType,
}) => {
  switch (projectGroupSubType) {
    case PROJECT_GROUP_SUB_TYPE_CORE: {
      switch (curriculumProgramType) {
        case CURRICULUM_TYPE_MYP:
          return "AutoCheckSimilarityOnFileSubmissionMYPProjects";
        case CURRICULUM_TYPE_DP:
          return "AutoCheckSimilarityOnFileSubmissionDPCore";
        default:
          return null;
      }
    }
    case PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT:
    case PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT: {
      return "AutoCheckSimilarityOnFileSubmissionIA";
    }
    default:
      return null;
  }
};

export const getSelectedColumnIds = ({ settingName, dashboardName }) => {
  const settingsValue = getSettingValue({
    name: settingName,
    readFromUserAndOrgLevel: true,
  });

  const selectedColumnIds = _.get(settingsValue, `${dashboardName}`, []);

  return selectedColumnIds;
};

export const getAssessmentFileUrl = ({
  projectGroup,
  projectIds,
  sheetName,
  fileName = "Assessment File",
  studentIds,
  fileMimeType = "application/pdf",
  extraParams: { gradebookProjectGroupIds } = {},
  portfolioIds,
}) => {
  return async (dispatch, getState) => {
    const fileId = generateRandomId();
    try {
      const result = await client.query({
        query: getProjectAssessmentDownloadUrlQuery,
        variables: {
          id: projectGroup,
          projectGroupAssessmentToolExportUrlInputs: {
            filters: {
              projectIds,
              studentIds,
              portfolioIds,
              academicYearIds: _.compact([
                getSelectedAcademicYearId(getState()),
              ]),
            },
            downloadURLDetails: {
              sheetName,
              gradebookProjectGroupIds,
            },
          },
        },
        fetchPolicy: "network-only",
      });

      const { url = null, isSuccess = false } = _.get(
        result,
        "data.node.generateAssessmentToolExportUrl",
        {}
      );

      const attachment = {
        id: fileId,
        type: "FILE",
        name: fileName,
        mimeType: fileMimeType,
      };

      if (isSuccess) {
        if (_.isNil(url)) {
          dispatch(removeProgressElement({ id: fileId }));
          dispatch(
            setToastMsg({
              msg: "toastMsgs:file_does_not_exist",
              type: "warning",
              position: "toast-top-center",
            })
          );
        } else {
          attachment.url = url;
          dispatch(
            downloadFromUrl({
              attachment,
              shouldAskForSave: true,
            })
          );
        }
      } else {
        dispatch(removeProgressElement({ id: fileId }));
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
            position: "toast-top-center",
          })
        );
      }
    } catch (e) {
      dispatch(removeProgressElement({ id: fileId }));
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      console.error(e);
      return null;
    }
  };
};

export const getProjectFileUrl = ({
  projectIds,
  zipConfig: { pdfPrintTypes, projectFieldUIDs },
  metadata = {},
  isDownload = true,
  name = "zipFile",
  projectsBatchSize,
  isLongRunningTask,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);
    const userId = userInfo.id;
    const userType = userInfo.user_type;
    metadata.userId = userId;
    metadata.userType = userType;
    metadata.organizationId = _.get(userInfo, "org_id", "");
    metadata.plannerElementSetLabels = _.get(
      getState().platform,
      "organizationPlannerElementSetLabels",
      {}
    );
    if (userType !== "staff") {
      metadata.studentIds =
        userType == "parent" ? [userInfo.childID] : [userId];
    }
    if (userType === "parent") {
      metadata.studentId = userInfo.childID;
    }
    if (userType === "student") {
      metadata.studentId = userId;
    }

    const locale = getSettingValue({ name: "locale" }) || "en";

    const pdfFormsInput = _.map(pdfPrintTypes, type => {
      return {
        type: "PDF_FORM",
        typeDetails: {
          type,
          lng: locale,
          metadata,
        },
      };
    });

    const projectFieldInput = _.map(projectFieldUIDs, uid => {
      return {
        type: "PROJECT_FIELD",
        typeDetails: {
          fieldUid: uid,
        },
      };
    });

    const attachmentTypesInput = _.concat(pdfFormsInput, projectFieldInput);

    const chunkSize = projectsBatchSize
      ? projectsBatchSize
      : _.size(projectIds);

    const chunkedProjectIds = _.chunk(projectIds, chunkSize);

    _.forEach(chunkedProjectIds, async (projectIds, idx) => {
      // generate random field Id and intiaite a file download progress
      const attachmentName =
        _.size(chunkedProjectIds) == 1 ? name : `${name}_${idx + 1}`;
      const fileId = generateRandomId();
      const attachment = {
        id: fileId,
        type: "FILE",
        name: attachmentName,
        mimeType: "application/zip",
      };

      if (isDownload) {
        dispatch(
          setProgress({
            id: fileId,
            progress: 0,
            attachment,
            status: "SAVE",
            type: "FILE",
          })
        );
      } else if (isLongRunningTask) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:send_email_when_files_are_ready_for_download",
            type: "info",
            prefixIcon: <MentionOutlined />,
            position: "toast-bottom-left",
            timeout: 4000,
          })
        );
      }

      try {
        const result = await client.mutate({
          mutation: generateProjectFileUrlMutation,
          variables: {
            projectIds,
            attachmentTypesInput,
            isLongRunningTask,
            academicYearIds,
          },
        });
        const fileUrl = _.get(
          result,
          "data.platform.generateProjectFileUrl.url",
          null
        );

        const isLongRunningTaskCreated = _.get(
          result,
          "data.platform.generateProjectFileFolderUrl.longRunningTaskCreated",
          false
        );

        const isSuccess = _.get(
          result,
          "data.platform.generateProjectFileUrl.isSuccess",
          false
        );

        if (isSuccess) {
          if (isLongRunningTask) {
            if (!isLongRunningTaskCreated) {
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:something_went_wrong_download_again",
                  type: "warning",
                  position: "toast-bottom-left",
                })
              );
            }
          } else {
            if (_.isNull(fileUrl)) {
              dispatch(removeProgressElement({ id: fileId }));
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:file_does_not_exist",
                  type: "warning",
                  position: "toast-top-center",
                })
              );
            } else {
              attachment.url = fileUrl;
              dispatch(downloadFromUrl({ attachment, shouldAskForSave: true }));
            }
          }
        } else {
          dispatch(removeProgressElement({ id: fileId }));
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      } catch (e) {
        dispatch(removeProgressElement({ id: fileId }));

        if (e.response) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        } else if (e.networkError) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:no_internet_connection",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      }
    });
  };
};

const getFileFolderTypeInput = ({
  fileFolderTypesInput,
  filesFolderList,
  lng,
  metadata,
}) => {
  _.forEach(filesFolderList, item => {
    const { type } = item;
    switch (type) {
      case "FILE": {
        const {
          fileType,
          fileDetails: { metadata: itemMetadata = {} } = {},
        } = item;
        switch (fileType) {
          case "PDF_FORM":
          case "PROJECT_STUDENT_FORM":
            fileFolderTypesInput.push({
              ...item,
              fileDetails: {
                ...item.fileDetails,
                lng,
                metadata: {
                  ...metadata,
                  ...itemMetadata,
                },
              },
            });

            break;
          case "PROJECT_FIELD":
          case "PROJECT_FIELD_STIMULUS": {
            // only pass the name if the download nomenclature v2 is enabled and the name exists
            const updatedItem = ACLStore.can(ENABLE_PROJECTS_ZIP_DOWNLOAD_V2)
              ? item
              : _.omit(item, ["name"]);
            fileFolderTypesInput.push(updatedItem);

            break;
          }
        }

        break;
      }

      case "FOLDER": {
        const { children = [], name, ...rest } = item;
        const folderObj = {
          name,
          type: "FOLDER",
          children: [],
          ...rest,
        };
        fileFolderTypesInput.push(folderObj);
        getFileFolderTypeInput({
          fileFolderTypesInput: folderObj.children,
          filesFolderList: children,
          lng,
          metadata,
        });
        break;
      }
    }
  });
};

export const getProjectFileFolderUrl = ({
  projectIds,
  courseIds,
  zipConfig: { filesFolderList = [], folderLabel = "", folderLabelV2 = "" },
  metadata = {},
  fileFolderConfig = {},
  isDownload = true,
  name = "zipFile",
  projectsBatchSize,
  isLongRunningTask,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);
    const userId = userInfo.id;
    const userType = userInfo.user_type;
    metadata.userId = userId;
    metadata.userType = userType;
    metadata.organizationId = _.get(userInfo, "org_id", "");

    const locale = getSettingValue({ name: "locale" }) || "en";

    const fileFolderTypesInput = [];

    getFileFolderTypeInput({
      fileFolderTypesInput,
      filesFolderList,
      lng: locale,
      metadata,
    });

    const updatedFolderLabel =
      ACLStore.can(ENABLE_PROJECTS_ZIP_DOWNLOAD_V2) && folderLabelV2
        ? folderLabelV2
        : folderLabel;
    const fileFolderConfigUpdated = {
      ...fileFolderConfig,
      folderLabelConfig: _.reduce(
        _.get(fileFolderConfig, "folderLabelConfig", {}),
        (result, item, key) => {
          result[key] =
            updatedFolderLabel &&
            !_.isEqual(key, "individualProjectFolderNameFormat")
              ? `${item}_${updatedFolderLabel}`
              : item;

          return result;
        },
        {}
      ),
    };

    const chunkSize = projectsBatchSize
      ? projectsBatchSize
      : _.size(projectIds);

    const chunkedProjectIds = _.chunk(projectIds, chunkSize);

    _.forEach(chunkedProjectIds, async (projectIds, idx) => {
      // generate random field Id and intiaite a file download progress
      const attachmentName =
        _.size(chunkedProjectIds) == 1 ? name : `${name}_${idx + 1}`;
      const fileId = generateRandomId();

      const attachment = {
        id: fileId,
        type: "FILE",
        name: attachmentName,
        mimeType: "application/zip",
      };

      if (isDownload) {
        dispatch(
          setProgress({
            id: fileId,
            progress: 0,
            attachment,
            status: "SAVE",
            type: "FILE",
          })
        );
      } else if (isLongRunningTask) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:send_email_when_files_are_ready_for_download",
            locale_params: [
              { key: "email", value: userInfo?.email, isPlainText: true },
            ],
            type: "info",
            prefixIcon: <MentionOutlined />,
            position: "toast-bottom-left",
            timeout: 4000,
          })
        );
      }

      try {
        const result = await client.mutate({
          mutation: generateProjectFileFolderUrlMutation,
          variables: {
            projectIds,
            fileFolderTypesInput,
            fileFolderConfig: fileFolderConfigUpdated,
            courseIds,
            isLongRunningTask,
            academicYearIds,
          },
        });
        const fileUrl = _.get(
          result,
          "data.platform.generateProjectFileFolderUrl.url",
          null
        );

        const isSuccess = _.get(
          result,
          "data.platform.generateProjectFileFolderUrl.isSuccess",
          false
        );

        const fileUrlName = _.get(
          result,
          "data.platform.generateProjectFileFolderUrl.name",
          name
        );

        const isLongRunningTaskCreated = _.get(
          result,
          "data.platform.generateProjectFileFolderUrl.longRunningTaskCreated",
          false
        );

        const attachmentName =
          _.size(chunkedProjectIds) == 1
            ? fileUrlName
            : `${fileUrlName}_${idx + 1}`;

        if (isSuccess) {
          if (isLongRunningTask) {
            if (!isLongRunningTaskCreated) {
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:something_went_wrong_download_again",
                  type: "warning",
                  position: "toast-bottom-left",
                })
              );
            }
          } else {
            if (_.isNull(fileUrl)) {
              dispatch(removeProgressElement({ id: fileId }));
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:file_does_not_exist",
                  type: "warning",
                  position: "toast-top-center",
                })
              );
            } else {
              attachment.url = fileUrl;
              attachment.name = attachmentName;
              dispatch(
                downloadFromUrl({
                  attachment,
                  shouldAskForSave: true,
                  name: attachmentName,
                })
              );
            }
          }
        } else {
          dispatch(removeProgressElement({ id: fileId }));
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      } catch (e) {
        dispatch(removeProgressElement({ id: fileId }));

        if (e.response) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        } else if (e.networkError) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:no_internet_connection",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      }
    });
  };
};

export const getPortfolioFileFolderUrl = ({
  portfolioIds,
  fileFolderConfig = {},
  isDownload = true,
  name = "zipFile",
  isLongRunningTask = false,
  fileFolderTypesInput,
  attachmentName,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearIds = _.compact([getSelectedAcademicYearId(getState())]);

    const fileId = generateRandomId();

    const attachment = {
      id: fileId,
      type: "FILE",
      name: attachmentName,
      mimeType: "application/zip",
    };

    if (isDownload) {
      dispatch(
        setProgress({
          id: fileId,
          progress: 0,
          attachment,
          status: "SAVE",
          type: "FILE",
        })
      );
    } else if (isLongRunningTask) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:send_email_when_files_are_ready_for_download",
          locale_params: [
            { key: "email", value: userInfo?.email, isPlainText: true },
          ],
          type: "info",
          prefixIcon: <MentionOutlined />,
          position: "toast-bottom-left",
          timeout: 4000,
        })
      );
    }

    try {
      const result = await client.mutate({
        mutation: generatePortfolioFileFolderUrlMutation,
        variables: {
          portfolioIds,
          fileFolderTypesInput,
          fileFolderConfig,
          isLongRunningTask,
          academicYearIds,
        },
      });
      const fileUrl = _.get(
        result,
        "data.platform.generatePortfolioFileFolderUrl.url",
        null
      );

      const isSuccess = _.get(
        result,
        "data.platform.generatePortfolioFileFolderUrl.isSuccess",
        false
      );

      const fileUrlName = _.get(
        result,
        "data.platform.generatePortfolioFileFolderUrl.name",
        name
      );

      const isLongRunningTaskCreated = _.get(
        result,
        "data.platform.generatePortfolioFileFolderUrl.longRunningTaskCreated",
        false
      );

      const attachmentName = fileUrlName;

      if (isSuccess) {
        if (isLongRunningTask) {
          if (!isLongRunningTaskCreated) {
            dispatch(
              setToastMsg({
                msg: "toastMsgs:something_went_wrong_download_again",
                type: "warning",
                position: "toast-bottom-left",
              })
            );
          }
        } else {
          if (_.isNull(fileUrl)) {
            dispatch(removeProgressElement({ id: fileId }));
            dispatch(
              setToastMsg({
                msg: "toastMsgs:file_does_not_exist",
                type: "warning",
                position: "toast-top-center",
              })
            );
          } else {
            attachment.url = fileUrl;
            attachment.name = attachmentName;
            dispatch(
              downloadFromUrl({
                attachment,
                shouldAskForSave: true,
                name: attachmentName,
              })
            );
          }
        }
      } else {
        dispatch(removeProgressElement({ id: fileId }));
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
            position: "toast-top-center",
          })
        );
      }
    } catch (e) {
      dispatch(removeProgressElement({ id: fileId }));

      if (e.response) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
            position: "toast-top-center",
          })
        );
      } else if (e.networkError) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:no_internet_connection",
            type: "warning",
            position: "toast-top-center",
          })
        );
      }
    }
  };
};

/**
 * It will download zip url of files by studentIds and projectGroupId
 *
 * @param {Object} param0
 * @returns
 *
 */
export const getFileFolderUrlByStudentProjectGroup = ({
  studentIds,
  projectGroupId,
  courseIds,
  zipConfig: { filesFolderList = [], folderLabel = "" },
  metadata = {},
  fileFolderConfig = {},
  isDownload = true,
  name = "zipFile",
  studentsBatchSize,
  isLongRunningTask,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const userType = userInfo.user_type;
    metadata.userId = userId;
    metadata.userType = userType;
    metadata.organizationId = _.get(userInfo, "org_id", "");

    const locale = getSettingValue({ name: "locale" }) || "en";

    const fileFolderTypesInput = [];

    getFileFolderTypeInput({
      fileFolderTypesInput,
      filesFolderList,
      lng: locale,
      metadata,
    });

    const fileFolderConfigUpdated = {
      folderLabelConfig: _.reduce(
        _.get(fileFolderConfig, "studentProjectGroupFolderLabelConfig", {}),
        (result, item, key) => {
          result[key] =
            folderLabel && !_.isEqual(key, "individualStudentFolderNameFormat")
              ? `${item}_${folderLabel}`
              : item;

          return result;
        },
        {}
      ),
    };

    const chunkSize = studentsBatchSize
      ? studentsBatchSize
      : _.size(studentIds);

    const chunkedStudentIds = _.chunk(studentIds, chunkSize);

    _.forEach(chunkedStudentIds, async (studentIds, idx) => {
      const attachmentName =
        _.size(chunkedStudentIds) == 1 ? name : `${name}_${idx + 1}`;
      const fileId = generateRandomId();

      const attachment = {
        id: fileId,
        type: "FILE",
        name: attachmentName,
        mimeType: "application/zip",
      };

      if (isDownload) {
        dispatch(
          setProgress({
            id: fileId,
            progress: 0,
            attachment,
            status: "SAVE",
            type: "FILE",
          })
        );
      } else if (isLongRunningTask) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:send_email_when_files_are_ready_for_download",
            locale_params: [
              { key: "email", value: userInfo?.email, isPlainText: true },
            ],
            type: "info",
            prefixIcon: <MentionOutlined />,
            position: "toast-bottom-left",
            timeout: 4000,
          })
        );
      }

      try {
        const result = await client.mutate({
          mutation: generateFileFolderUrlByStudentProjectGroupMutation,
          variables: {
            studentIds,
            projectGroupId,
            fileFolderTypesInput,
            fileFolderConfig: fileFolderConfigUpdated,
            courseIds,
            isLongRunningTask,
          },
        });

        const fileUrl = _.get(
          result,
          "data.platform.generateStudentProjectGroupUrl.url",
          null
        );

        const isSuccess = _.get(
          result,
          "data.platform.generateStudentProjectGroupUrl.isSuccess",
          false
        );

        const attachmentName = _.get(
          result,
          "data.platform.generateStudentProjectGroupUrl.name",
          name
        );

        const isLongRunningTaskCreated = _.get(
          result,
          "data.platform.generateStudentProjectGroupUrl.longRunningTaskCreated",
          false
        );

        if (isSuccess) {
          if (isLongRunningTask) {
            if (!isLongRunningTaskCreated) {
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:something_went_wrong_download_again",
                  type: "warning",
                  position: "toast-bottom-left",
                })
              );
            }
          } else {
            if (_.isNull(fileUrl)) {
              dispatch(removeProgressElement({ id: fileId }));
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:file_does_not_exist",
                  type: "warning",
                  position: "toast-top-center",
                })
              );
            } else {
              attachment.url = fileUrl;
              attachment.name = attachmentName;
              dispatch(
                downloadFromUrl({
                  attachment,
                  shouldAskForSave: true,
                  name: attachmentName,
                })
              );
            }
          }
        } else {
          dispatch(removeProgressElement({ id: fileId }));
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      } catch (e) {
        dispatch(removeProgressElement({ id: fileId }));

        if (e.response) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        } else if (e.networkError) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:no_internet_connection",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      }
    });
  };
};

export const entityNameOrderBy = ({ entity, sortedFieldsWithOrder }) => {
  const menuItemEntity = _.get(
    sortedFieldsWithOrder,
    `${entity}.menuItemEntity`,
    ""
  );
  switch (menuItemEntity) {
    case STUDENT_FIRST_NAME:
    case STAFF_FIRST_NAME:
      return FIRST_NAME;
    case STUDENT_LAST_NAME:
    case STAFF_LAST_NAME:
      return LAST_NAME;
    case STUDENT_MIDDLE_NAME:
    case STAFF_MIDDLE_NAME:
      return MIDDLE_NAME;
    case STUDENT_FULL_NAME:
    case STAFF_FULL_NAME:
      return FULL_NAME;
    default:
      return FIRST_NAME;
  }
};

export const getArchivedUsersNames = users => {
  return _.reduce(
    users,
    (names, item) => {
      if (getUserArchivalStatus(item)) {
        const name = getFormattedUserName({ user: item || {} });
        names.push(name);
      }
      return names;
    },
    []
  );
};

export const markAttachmentAnnotationAsRead = ({
  id,
  projectId,
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());
    const projectDetails = getProjectDetailsFromCache({
      projectId,
      projectGroupType,
      academicYearId,
    });
    const attachment = getProjectAttachmentFragmentFromCache({
      attachmentId: id,
    });

    // Updating count in project details
    const updatedProjectDetails = update(projectDetails, {
      node: {
        notificationBadgeCounts: {
          unreadAttachmentAnnotatedCount: { $apply: value => value - 1 },
        },
      },
    });
    writeProjectDetailsInCache({
      projectId,
      academicYearId,
      data: updatedProjectDetails,
      projectGroupType,
    });

    // Marking attachment annotation as read in cache
    writeProjectAttachmentInCache({
      attachmentId: id,
      data: update(attachment, {
        isAnnotationRead: { $set: true },
      }),
    });

    try {
      await client.mutate({
        mutation: updateEntityIsReadMutation,
        variables: {
          id: id,
          entityType: "ANNOTATED_ATTACHMENT",
        },
      });
    } catch (e) {
      writeProjectDetailsInCache({
        projectId,
        academicYearId,
        data: projectDetails,
        projectGroupType,
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

// used in submission Item to create a attachment that contains isAnnotationRead

export const createAttachmentForProjects = ({
  nodeId,
  attachment,
  type,
  parentType,
  portalType,
  lockingState,
}) => {
  return async dispatch => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    try {
      const response = await client.mutate({
        mutation: createAttachmentMutationForProjects,
        variables: {
          input: [
            {
              name: attachment.name,
              url: attachment.url,
              type: attachment.type,
              thumbUrl: attachment.thumbUrl ? attachment.thumbUrl : "",
              mimeType: attachment.mimeType,
              createdBy: userId,
              parentId: nodeId,
              parentType: parentType,
              metadata: attachment.metadata,
              portalType,
              lockingState,
            },
          ],
        },

        update: (
          cache,
          {
            data: {
              platform: { createAttachment },
            },
          }
        ) => {
          if (!isExcludedParentTypesForAttachmentCache({ parentType: type })) {
            const nodeDetails = getAttachmentOfNodeFromCache({ nodeId, type });

            const data = update(nodeDetails, {
              attachments: attachments =>
                update(attachments || [], {
                  $push: [...createAttachment],
                }),
            });

            writeAttachmentNodeFragment({
              nodeId,
              data,
              type,
            });
          }
        },
      });
      return _.get(response, "data.platform.createAttachment", []);
    } catch (e) {
      console.warn(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return [];
    }
  };
};

export const removeLosFromPosts = ({
  variables,
  projectId,
  learningOutcomesIds,
  learningOutcomesType,
}) => {
  return async dispatch => {
    const refetchQueries = [
      {
        query: getLearningOutcomesPostsQuery,
        variables: {
          id: projectId,
          filters: {
            plannerElementIds: learningOutcomesIds,
            plannerElementType: learningOutcomesType,
          },
        },
      },
    ];
    try {
      await client.mutate({
        mutation: removeLosFromPostsMutation,
        variables,
        refetchQueries,
        awaitRefetchQueries: true,
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateCriteriaComment = ({
  remarkMessage,
  ibPYPElementId,
  ibPYPElementType,
  studentId,
  parentType,
  studentCourseFilters,
  parentId,
  isAssessmentGradebookNewApi,
  getProjectStudentCriteriaDetailsQueryVars,
}) => {
  return async dispatch => {
    const userInfo = getUserInfo();
    const createdBy = userInfo.id;
    let updatedData = [];
    let data = [];
    if (isAssessmentGradebookNewApi) {
      data = getProjectStudentCriteriaDetailsFromCache({
        variables: getProjectStudentCriteriaDetailsQueryVars,
      });
      const index = _.findIndex(
        _.get(data, "students[0].ibPypElementRemarks"),
        {
          ibPYPElementId,
        }
      );

      updatedData = data;
      if (index !== -1) {
        updatedData = update(data, {
          students: {
            [0]: {
              ibPypElementRemarks: {
                [index]: {
                  message: {
                    $set: remarkMessage,
                  },
                },
              },
            },
          },
        });
      } else {
        updatedData = update(data, {
          students: {
            [0]: {
              ibPypElementRemarks: {
                $push: [
                  {
                    id: generateRandomId(),
                    ibPYPElementId,
                    ibPYPElementType,
                    message: remarkMessage,
                    __typename: "ibPypElementRemarks",
                  },
                ],
              },
            },
          },
        });
      }
    } else {
      data = getProjectCriteriaDetailsFromCache({
        id: parentId,
        studentCourseFilters,
      });

      const index = _.findIndex(data?.ibPYPElementRemarks, {
        ibPYPElementId,
      });

      updatedData = data;
      if (index !== -1) {
        updatedData = update(data, {
          ibPYPElementRemarks: {
            [index]: {
              message: {
                $set: remarkMessage,
              },
            },
          },
        });
      } else {
        updatedData = update(data, {
          ibPYPElementRemarks: {
            $push: [
              {
                id: generateRandomId(),
                ibPYPElementId,
                ibPYPElementType,
                message: remarkMessage,
                __typename: "IBPYPElementRating",
              },
            ],
          },
        });
      }
    }
    if (isAssessmentGradebookNewApi) {
      writeProjectStudentCriteriaDetails({
        variables: getProjectStudentCriteriaDetailsQueryVars,
        data: updatedData,
      });
    } else {
      writeProjectRatedCriteriaInCache({
        id: parentId,
        data: updatedData,
      });
    }
    try {
      await client.mutate({
        mutation: updateElementRemarkMutationMutation,
        variables: {
          input: {
            studentId,
            parentType,
            parentId,
            ibPYPElementType,
            ibPYPElementId,
            createdBy,
            message: remarkMessage,
          },
        },
      });
    } catch (e) {
      if (isAssessmentGradebookNewApi) {
        writeProjectStudentCriteriaDetails({
          variables: getProjectStudentCriteriaDetailsQueryVars,
          data,
        });
      } else {
        writeProjectRatedCriteriaInCache({
          id: parentId,
          data,
        });
      }
    }
  };
};
export const getProjectsCircularSwitcherSortingFilters = ({
  state,
  portfolioId,
  projectGroupType,
  isPortfolioDetailsPage = false,
  projectGroupCategoryType,
}) => {
  const dashboardFilters = _.get(state, "project.dashboardFilters", {});
  const initialSortedFields = getInitialSortedFields();

  const defaultOrderByFields = getOrderByFieldsMemoized({
    sortedFieldsWithOrder: initialSortedFields,
  });

  let screenType = "";

  const isProjectGroupTypePortfolio = getIsProjectGroupTypePortfolio({
    projectGroupType,
    projectGroupCategoryType,
  });

  if (isProjectGroupTypePortfolio) {
    // here portfolioId is coming from routes it means we are in project details through student portfolio screen
    if (isPortfolioDetailsPage) {
      screenType = `main`;
    } else if (portfolioId) {
      screenType = `portfolios:${portfolioId}`;
    } else {
      screenType = `experiences`;
    }
  } else {
    screenType = `main`;
  }

  const dashboardId = getDashboardIdMemoized({
    projectGroupType,
    screenType,
  });

  const filters = dashboardFilters[dashboardId];

  if (_.isEmpty(dashboardFilters) || !filters) {
    return {
      projectsSortingFilters: defaultOrderByFields,
    };
  }

  const sortedFieldsWithOrder = _.get(filters, "sortedFieldsWithOrder", {});

  const orderByFields = getOrderByFieldsMemoized({
    sortedFieldsWithOrder,
  });
  return { projectsSortingFilters: orderByFields };
};

const getOverallProgressOptions = ({
  customOverallProgressIndicators = [],
  isOverallProgressIndicatorsEnabled,
}) => {
  return _.reduce(
    customOverallProgressIndicators,
    (result, item) => {
      result.push({
        value: item.id,
        label: item.label,
        key: item.id,
        subText: isOverallProgressIndicatorsEnabled
          ? item.abbreviation
          : undefined,
        subtitle: isOverallProgressIndicatorsEnabled
          ? item.abbreviation
          : undefined,
      });

      return result;
    },
    []
  );
};

export const getOverallProgressOptionsMemoized = _.memoize(
  params => getOverallProgressOptions(params),
  params => JSON.stringify(params)
);

const getLearningOutcomesOptions = ({
  customLearningOutcomeIndicators = [],
}) => {
  return _.reduce(
    customLearningOutcomeIndicators,
    (result, item) => {
      result.push({
        value: item.id,
        label: item.label,
        key: item.id,
        subText: item.abbreviation,
      });

      return result;
    },
    []
  );
};

export const getLearningOutcomesOptionsMemoized = _.memoize(
  params => getLearningOutcomesOptions(params),
  params => JSON.stringify(params)
);

// Executes the create action when the "C" key is pressed

export const getSubmissionStatusLabelDetails = ({ status }) => {
  switch (status) {
    case TURNED_IN_ON_TIME:
      return {
        textColor: "var(--text-semantic-info)",
        label: "project:turned_in",
        icon: <TickSmallOutlined size={"xxx-small"} variant="success" />,
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<TickCircleFilled variant="success" />}
            iconType="icon"
            color="teal"
            size="large"
          />
        ),
      };
    case TURNED_IN_LATE:
      return {
        textColor: "var(--text-semantic-info)",
        tableBgColor: "var(--teal-950)",
        label: "project:turned_in_late",
        icon: <ClockOutlined size={"xxx-small"} variant="success" />,
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<TickCircleFilled variant="success" />}
            iconType="icon"
            color="teal"
            size="large"
          />
        ),
      };
    case NOT_SUBMITTED:
      return {
        textColor: "var(--text-semantic-error)",
        tableBgColor: "var(--surface-semantic-error)",
        label: "project:not_submitted",
        icon: <MinusCircleOutlined size={"xxx-small"} variant="critical" />,
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<EvaluationNotApplicableOutlined variant="critical" />}
            iconType="icon"
            color="pink"
            size="large"
          />
        ),
      };
    case OVERDUE:
      return {
        textColor: "var(--text-semantic-error)",
        tableBgColor: "var(--surface-semantic-error)",
        label: "project:overdue",
        icon: <ClockTimerOutlined size={"xxx-small"} variant="critical" />,
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<ClipboardPencilLinesOutlined variant="critical" />}
            iconType="icon"
            color="pink"
            size="large"
          />
        ),
      };
    case REQUEST_RESUBMISSION_OVERDUE:
      return {
        textColor: "var(--text-semantic-error)",
        label: "project:request_resubmission_overdue",
        icon: (
          <ReSubmissionRequestOutlined size={"xxx-small"} variant="critical" />
        ),
        avatarIcon: (
          <Avatar
            size="large"
            shape="square"
            icon={<ClipboardPencilLinesOutlined variant="critical" />}
            iconType="icon"
            color="pink"
          />
        ),
      };
    case REQUEST_RESUBMISSION:
      return {
        textColor: "var(--text-semantic-warning)",
        label: "project:resubmission_requested",
        icon: (
          <ReSubmissionRequestOutlined size={"xxx-small"} variant="warning" />
        ),
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<ReSubmissionRequestOutlined variant="warning" />}
            iconType="icon"
            color="yellow"
            size="large"
          />
        ),
      };
    case SUBMISSION_PENDING:
      return {
        textColor: "var(--text-secondary)",
        label: "common:pending",
        icon: <WarningCircleOutlined size={"xxx-small"} variant="subtle" />,
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<ClockOutlined variant="subtle" />}
            iconType="icon"
            color="yellow"
            size="large"
          />
        ),
      };
    case RESUBMISSION_NOT_SUBMITTED:
      return {
        textColor: "var(--text-semantic-error)",
        tableBgColor: "var(--surface-semantic-error)",
        label: "project:resubmission_not_submitted",
        icon: <MinusCircleOutlined size={"xxx-small"} variant="critical" />,
        avatarIcon: (
          <Avatar
            shape="square"
            icon={<EvaluationNotApplicableOutlined variant="critical" />}
            iconType="icon"
            color="pink"
            size="large"
          />
        ),
      };

    default:
      return {
        textColor: "var(--text-secondary)",
        label: "project:na",
      };
  }
};

export const showUseTemplateErrors = error => {
  return async dispatch => {
    let errorMessage = _.get(error, "graphQLErrors[0].message", null);

    switch (errorMessage) {
      case "GOOGLE_ACCOUNT_NOT_LINKED":
        errorMessage = "GOOGLE_TEACHER_ACCOUNT_NOT_LINKED";
        break;
      case "GOOGLE_ACCOUNT_NOT_WORKING":
        errorMessage = "GOOGLE_TEACHER_ACCOUNT_NOT_WORKING";
        break;
      case "MICROSOFT_ACCOUNT_NOT_LINKED":
        errorMessage = "MICROSOFT_TEACHER_ACCOUNT_NOT_LINKED";
        break;
      case "MICROSOFT_ACCOUNT_NOT_WORKING":
        errorMessage = "MICROSOFT_TEACHER_ACCOUNT_NOT_WORKING";
        break;
      case "MICROSOFT_FILE_DELETED_OR_ACCOUNT_CHANGED":
        errorMessage = "MICROSOFT_FILE_DELETED_OR_TEACHER_ACCOUNT_CHANGED";
        break;
    }
    const errorText = ATTACHMENT_WARNINGS[errorMessage];

    if (!_.isEmpty(errorText)) {
      dispatch(setToastMsg(errorText));
    } else {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const DROP_DOWN_OPTIONS_DEFAULT = [
  {
    key: "upload_device",
    label: "upload_device",
    icon: <DeviceDesktopOutlined />,
  },
  {
    key: "add_google_drive",
    label: "add_google_drive",
    icon: <GoogleDriveColored />,
  },
  { key: "add_one_drive", label: "add_one_drive", icon: <OneDriveColored /> },
];

export const submissionItemDefaultProps = {
  accept: [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.google-apps.document",
    "application/pdf",
    "text/rtf",
    "application/rtf",
    "application/vnd.oasis.opendocument.text",
  ],
  defaultExportType: "LINK",
  attachmentExportOptions: ["LINK", "FILE"],
  multiselect: false,
  canAddMaximumAttachments: null,
  showSimilarity: false,
  isAnnotationEnabled: false,
  showSingleAttachment: false,
  maxSize: 52428800,
  showWaveformPlayer: false,
  dropDownOptions: DROP_DOWN_OPTIONS_DEFAULT,
  submissionItemTitle: "common:response",
  isCustomSubmissionType: false,
};

export const getSubmissionAttachmentExtraIconButtons = ({
  attachment,
  t,
  onClickOpenInNewTab,
}) => {
  const { type } = attachment;

  return type !== "WORKBOOK" ? (
    <Tooltip
      tooltip={t("common:open_in_new_tab")}
      placement="topRight"
      dsVersion={2.0}
    >
      <IconButton
        variant="neutral"
        type={"plain"}
        size={"x-small"}
        dsVersion={"2.0"}
        onClick={e => onClickOpenInNewTab({ e, attachment })}
        icon={<ArrowOutOutlined variant="subtle" />}
      />
    </Tooltip>
  ) : null;
};

export const getIsOverallProgressIndicatorsEnabled = () => {
  return ACLStore.can("FeatureFlag:ProjectOverallProgressWithHistory");
};

const getFilterIcon = ({ type, variant }) => {
  switch (type) {
    case "fileOutlinedIcon":
      return <PlaceholderFileOutlined variant={variant ?? "default"} />;
    case "inProgressThumbsUpIcon":
      return <InProgressThumbsupOutlined variant={variant ?? "success"} />;
    case "badgeFilledIcon":
      return <BadgeTickFilled variant={variant ?? "success"} />;
    case "dashedCircleMinusIcon":
      return <DashedCircleMinusOutlined variant={variant ?? "subtle"} />;
    case "closeCircleFilledIcon":
      return <CloseCircleFilled variant={variant ?? "critical"} />;
    default:
      return null;
  }
};

export const getFilterIconMemoized = _.memoize(
  params => getFilterIcon(params),
  params => JSON.stringify(params)
);

export const getReportStatusFilterOptions = getMemoizedLangFunction(
  ({ t, projectReportStatuses }) => {
    return _.map(projectReportStatuses, item => {
      const statusItem = PROJECT_REPORT_STATUS_FILTER_OPTIONS[item];
      return {
        ...statusItem,
        label: t(statusItem?.label, {
          label: t(statusItem?.subLabel),
        }),
        prefixElement: getFilterIconMemoized({
          type: statusItem?.iconType,
          variant: statusItem?.iconVariant,
        }),
      };
    });
  }
);
